/* eslint-disable no-prototype-builtins */
<template>
    <div class="invoice-form-container">
        <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu" v-on:blur="closeMenu"  v-bind:style="{top:top, left:left}">
            <li  @click="insertRow">Insert</li>
            <template v-if="form.items.length > 2">
                <li @click="moveUpRow">Move Up</li>
                <li @click="moveDownRow">Move Down</li>
            </template>
            <li @click="deleteRow">Delete</li>
        </ul>
        <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
            <ThatsWindow ref="window" title="Sales Transaction" :parentContainerStyle="parentContainerStyle" :windowClass="windowClass" scrollClass='collection height-auto' @deleteYes="emitDelete" :height="height100P" :width="width100P" :formStatus="formStatus" @dialog-state="dialogState" :group="group" @history="openHistory">
                <template #left-button>
                    <template v-if="formLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </mdb-btn>
                    </template>
                    <template v-else>



                        <template v-if="(formStatus == 'update' || formStatus == 'create') && returnItem === false && modify === false && cancelItem === false && (active === 0 || active === 2)">
                            <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading || requestedCancel || requestedExchange || refundRequested || exchangeItemLoading || formOriginal.status === 'cancel'">Save</mdb-btn>
                            <mdb-btn color="elegant" size="sm" @click="issueVoucher" :disabled="viewLoading || requestedCancel || requestedExchange || refundRequested || exchangeItemLoading || formOriginal.status === 'cancel'">ISSUE VOURCHER</mdb-btn>
                            <mdb-btn color="elegant" size="sm" @click="requestDelivery" :disabled="viewLoading || requestedCancel || requestedExchange || refundRequested || exchangeItemLoading || formOriginal.status === 'cancel'">Request Delivery</mdb-btn>
                        </template>
                        <template v-if="(formStatus == 'update' || formStatus == 'create') && returnItem === false && modify === true && active === 0">
                            <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading || requestedCancel || requestedExchange || refundRequested || exchangeItemLoading">Save Changes</mdb-btn>
                        </template>
                        <template v-if="selectedTbo.length > 0  && active === 0">
                            <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)" :disabled="viewLoading || requestedCancel || requestedExchange || refundRequested || exchangeItemLoading">Save & Create Customer PO</mdb-btn>
                        </template>
                        <template v-if="formStatus == 'update'">
                            <template v-if="invoice.payments.length > 0">
                                <mdb-btn @click="fnPrint('/sales/invoice/'+form.token_id)" color="elegant" size="sm" :disabled="viewLoading || formOriginal.status === 'cancel'">Print Invoice</mdb-btn>

                            </template>
                            <template v-else>
                                <mdb-btn @click="fnPrint('/sales/transactions/'+form.token_id)" color="elegant" size="sm" :disabled="viewLoading">Print Quotation</mdb-btn>
                            </template>
                        </template>
                    </template>

                    <template v-if="selected.length > 0 && modify === true && returnItem === false">
                        <mdb-btn color="elegant" size="sm" @click="deleteItem">Delete</mdb-btn>
                    </template>
                </template>

                <template #right-button>

                    <!-- <template v-if="formStatus == 'update' && $helpers.isSalesExecutive()">

              </template>
              <template v-else> -->
                    <template v-if="invoice.series === null || parseFloat(invoice.balance) > 0 && modify === false && returnItem === false && cancelItem === false  && exchangeItem === false && (active === 0  || active === 1)">
                        <mdb-btn color="elegant" size="sm" @click="openPaymentWindow" :disabled="(viewLoading || formLoading || requestedCancel || refundRequested || requestedExchange || formOriginal.status === 'cancel')">Make Payment</mdb-btn>
                    </template>
                    <template v-if="invoice.series !== null && $helpers.isSystemAdministrator() && allowedUser()">
                        <mdb-btn color="elegant" size="sm" @click="confirmSendInvoiceToCustomer" :disabled="(viewLoading || formLoading)">Share to WhatsApp</mdb-btn>
                    </template>
                    <!-- <template v-if="invoice.series !== null && checkSystemSupport && modify === false && returnItem === false && cancelItem === false  && exchangeItem === false && (active === 0  || active === 1)">
                  <mdb-btn color="elegant" size="sm" @click="openPaymentWindow" :disabled="(viewLoading || formLoading || requestedCancel || refundRequested || requestedExchange)">Add Payment</mdb-btn>
                </template> -->
                    <template v-if="invoice.series !== null && (checkSystemSupport) && modify === false && cancelItem === false && returnItem === false && exchangeItem === false && active === 0">
                        <mdb-btn color="elegant" size="sm" @click="enableModify" :disabled="(viewLoading || formLoading || requestedCancel || refundRequested || requestedExchange || formOriginal.status === 'cancel')">Modify</mdb-btn>
                       
                        <!-- <template v-if="form.enable_push === true && (form.attr.hasOwnProperty('document') && (form.attr.document.entry === null || form.attr.document.entry === '') && ($helpers.isSystemAdministrator() || $helpers.isAccounting()))">

                    <template v-if="pushInvoiceToSapLoading">
                      <mdb-btn color="elegant" size="sm" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...
                      </mdb-btn>
                    </template>
                    <template v-else>
                        <mdb-btn color="elegant" size="sm" @click="pushToSap" :disabled="(viewLoading || formLoading || requestedCancel || refundRequested || requestedExchange || formOriginal.status === 'cancel')">Push to SAP</mdb-btn>
                    </template>
                  </template>
                  <template v-else>
                      <mdb-btn color="elegant" size="sm" :disabled="true">Push to SAP</mdb-btn>
                  </template> -->
                    </template>



                    <template v-if="invoice.series !== null && activeTableSlot === 'sap-documents-slot'">
                        <template v-if="deliveryPostLoading">
                            <mdb-btn color="elegant" size="sm" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </mdb-btn>
                        </template>
                        <template v-else>
                            <mdb-btn color="elegant" size="sm" @click="createDelivery" :disabled="!hasSelectedForDelivery">Create Delivery Note</mdb-btn>
                            <mdb-btn color="elegant" size="sm" @click="handShowScan">Scan Collected Items</mdb-btn>
                        </template>
                    </template>
                    <template v-if="invoice.series !== null && activeTableSlot === 'sales-return-request-slot'">
                       <!--  <template v-if="deliveryPostLoading">
                            <mdb-btn color="elegant" size="sm" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </mdb-btn>
                        </template>
                        <template v-else>
                            <mdb-btn color="elegant" size="sm" @click="createDelivery" :disabled="!hasSelectedForDelivery">Create Delivery Note</mdb-btn>
                            <mdb-btn color="elegant" size="sm" @click="handShowScan">Scan Collected Items</mdb-btn>
                        </template> -->

                        <template v-if="return_requestSelectedRows.length > 0 && !allowLegacyCreditNoteRequestEnabled">
                                    <mdb-btn 
                                        color="elegant" 
                                        size="sm" 
                                        @click="confirmSubmitReturnRequest"
                                        :disabled="returnRequestSubmitting"
                                    >
                                        <span v-if="returnRequestSubmitting">
                                            <i class="fas fa-spinner fa-spin"></i> Submitting...
                                        </span>
                                        <span v-else>
                                            Submit Return Request ({{ return_requestSelectedRows.length }} items)
                                        </span>
                                    </mdb-btn>
                                </template>
                    </template>
                    <template v-if="invoice.series !== null && checkSystemSupport && activeTableSlot =='pull-out'">

                        <!-- <mdb-btn color="elegant" size="sm" :disabled="true">Modify Credit Note</mdb-btn> -->

                        <template v-if="modify === false && returnItem === false && modifyReturmItem === false && pullout === false">
                            <mdb-btn color="elegant" size="sm" @click="enablePullOut" :disabled="viewLoading || modifyReturmItem">Pull-out Order</mdb-btn>
                        </template>
                        <template v-if="modify === false && returnItem === false && modifyReturmItem === false && pullout === false">
                            <mdb-btn color="elegant" size="sm" @click="enablePullOut" :disabled="viewLoading || modifyReturmItem">Pull-out Order</mdb-btn>
                        </template>
                        
                    </template>
                    <template v-if="invoice.series !== null && (checkSystemSupport || checkShowroomManager) && (modify === true || modifyReturmItem === true ) && active === 3">
                        <mdb-btn color="elegant" size="sm" @click="passes(fnUpdateCreditNote)" :disabled="(viewLoading || formLoading)">Save Credit Note</mdb-btn>
                        <mdb-btn color="elegant" size="sm" @click="cancelModification" :disabled="(viewLoading || formLoading)">Cancel</mdb-btn>
                    </template>


                    <template v-if="allowLegacyCreditNoteRequestEnabled && (invoice.series !== null && (enableReturn.includes(formOriginal.status) && (formOriginal.attr.payment_status === 'partial-payment' || formOriginal.attr.payment_status === 'full-payment'))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive || $helpers.isInteriorDesigner()) && modify === false && returnItem === false && cancelItem === false && exchangeItem === false && active === 0">
                        <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || requestedCancel || requestedExchange || formOriginal.status === 'cancel')" @click="returnItems">Return</mdb-btn>
                    </template>

                    <template v-if="form!== null  && modify === false && returnItem === false && modifyReturmItem === false && form.oprq.length <= 0 && form.purchase_request_item.length > 0">
                         <mdb-btn color="elegant" size="sm" @click="pushPurchaseRequest" :disabled="formLoading">Create Purchase Request</mdb-btn>
                    </template>
                    <!--
                <template v-if="(invoice.series !== null && (cancelItemEnable.includes(formOriginal.status) && ['partial-payment','full-payment'].includes(formOriginal.attr.payment_status))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && modify === false && returnItem === false && cancelItem === false && exchangeItem === false && refundItem === false && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || requestedCancel || requestedExchange)" @click="cancelItems">Cancel Item</mdb-btn>
                </template> -->

                    <template v-if="allowLegacyCreditNoteRequestEnabled && (invoice.series !== null && (enableReturn.includes(formOriginal.status) && (formOriginal.attr.payment_status === 'partial-payment' || formOriginal.attr.payment_status === 'full-payment'))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive || $helpers.isInteriorDesigner()) && returnItem === true && modify === false && cancelItem === false && exchangeItem === false &&  refundItem === false &&active === 0">
                        <mdb-btn color="elegant" size="sm" :disabled="(hasSelected || viewLoading || formLoading)" @click="passes(requestCreditNote)">Request Credit Note</mdb-btn>

                        <!--    <mdb-dropdown class="thats-dropdown" dropup>
                        <mdb-dropdown-toggle class="mt-2" slot="toggle" color="elegant" size="sm" :disabled="(hasSelected || viewLoading || formLoading)">Request Credit Note</mdb-dropdown-toggle>
                        <mdb-dropdown-menu class="inactive-reactive-menu">
                            <mdb-dropdown-item @click="requestCreditNote">Exchange</mdb-dropdown-item>
                            <div class="dropdown-divider"></div>
                            <mdb-dropdown-item @click="emitDelete">Refund</mdb-dropdown-item>
                        </mdb-dropdown-menu>
                    </mdb-dropdown> -->

                        <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading)" @click="cancelModification">Cancel</mdb-btn>
                    </template>

                     <template v-if="invoice.series !== null && allowSyncInvoice">
                            <template v-if="syncInvoiceLoading">
                                <mdb-btn color="elegant" size="sm" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </mdb-btn>
                            </template>
                            <template v-else>
                                <mdb-btn color="elegant" size="sm" @click="syncInvoice" :disabled="(viewLoading || formLoading || requestedCancel || refundRequested || requestedExchange || formOriginal.status === 'cancel')">Sync Sales Order</mdb-btn>
                            </template>
                        </template>


                    <!--   <template v-if="(invoice.series !== null && (exchangeItemEnable.includes(formOriginal.status) && ['partial-payment','full-payment'].includes(formOriginal.attr.payment_status))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && modify === false && returnItem === false && cancelItem === false && exchangeItem === false && refundItem === false && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || requestedExchange)" @click="exchangeItems">Exchange Item</mdb-btn>
                </template>

                <template v-if="(invoice.series !== null && (refundItemEnable.includes(formOriginal.status) && ['partial-payment','full-payment'].includes(formOriginal.attr.payment_status))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && modify === false && returnItem === false && cancelItem === false && exchangeItem === false && refundItem === false && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || requestedExchange)" @click="refundItems">Refund Item</mdb-btn>
                </template>
 -->


                    <!-- <template v-if="cancelItemLoading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                  <template v-if="(invoice.series !== null && (cancelItemEnable.includes(formOriginal.status) &&  ['partial-payment','full-payment'].includes(formOriginal.attr.payment_status))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && returnItem === false && modify === false && cancelItem === true && active === 0">
                    <mdb-btn color="elegant" size="sm" :disabled="(hasSelected || viewLoading || formLoading || cancelItemLoading)" @click="requestCancelItem">Request Item Cancel</mdb-btn>
                    <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || cancelItemLoading)" @click="cancelModification">Cancel</mdb-btn>
                  </template>
                </template>
 -->


                    <!-- <template v-if="exchangeItemLoading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                 <template v-if="(invoice.series !== null && (exchangeItemEnable.includes(formOriginal.status) && (formOriginal.attr.payment_status === 'partial-payment' || formOriginal.attr.payment_status === 'full-payment'))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && returnItem === false && modify === false && cancelItem === false && exchangeItem === true && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="(hasSelected || viewLoading || formLoading || exchangeItemLoading)" @click="requestExchange">Request Item Exchange</mdb-btn>
                  <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || exchangeItemLoading)" @click="cancelModification">Cancel</mdb-btn>
                </template>
                </template>
 -->

                    <!--   <template v-if="refundItemLoading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                 <template v-if="(invoice.series !== null && (refundItemEnable.includes(formOriginal.status) && (formOriginal.attr.payment_status === 'partial-payment' || formOriginal.attr.payment_status === 'full-payment'))) && (checkSystemSupport || checkShowroomManager || checkSalesExecutive) && returnItem === false && modify === false && cancelItem === false && exchangeItem === false && refundItem === true && active === 0">
                  <mdb-btn color="elegant" size="sm" :disabled="(hasSelected || viewLoading || formLoading || refundItemLoading)" @click="requestRefund">Request Item Refund</mdb-btn>
                  <mdb-btn color="elegant" size="sm" :disabled="(viewLoading || formLoading || refundItemLoading)" @click="cancelModification">Cancel</mdb-btn>
                </template>
                </template> -->

                    <!--   </template> -->

                    <template v-if="invoice.payments.length> 0">
                        <span class="invoice-balance">Total Balance : {{ $helpers.addSeparatorsNF(invoice.balance)}} QAR</span>
                    </template>


                </template>
                <template v-if="invoice.payments.length> 0">
                    <span class="invoice-number">Sales Invoice #: {{invoice.series}} 
                    <!-- <template v-if="invoice.hasOwnProperty('docNum') && invoice.docNum !== null">
                    | Doc Num: {{invoice.docNum}}
                    </template> -->
                    </span>
                </template>
                <div class="mt-1 pl-3 pr-3">
                    <mdb-tabs class="table-tabs mb-0 form" :active="active" default :links="tabs" @activeTab="getActiveTabIndex" >
                        <template :slot="'form-slot'">

                            <mdb-row class="tab-row">
                                <mdb-col col="6" class="tab-col pl-0">
                                    <template v-if="form !== null && form.hasOwnProperty('invoice') && form.invoice.date !== null">
                                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date" placeholder="Date" vid="date" name="date" v-model="form.invoice.date" :validated="validated" :rules="'required'" size="sm" :disabled="disabled"/>
                                    </template>
                                    <template v-if="(modify === true && $helpers.isSystemAdministrator())">
                                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer" vid="name" name="name" v-model="form.attr.name" size="sm" :disabled="true"/>
                                        <a href="javascript:void(0)" @click="editCustomer" class="edit">Edit</a>
                                    </template>
                                    <template v-else>
                                        <ThatsCustomMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Customer" v-model="form.customer_id" :reduce="customer => customer.value" :reduceLabel="'opt'" :options="customer" :rules="'required'" :clearable="false" @select="getCustomerSelected($event)" :addButton="true" @newWindow="openCustomer" @onSearch="searchCustomer" :selected_option="true" :disabled="true" ></ThatsCustomMultiSelect>


                                    </template>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.attr.mobile" size="sm" :disabled="!editCustomerField"/>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="displayAddress" size="sm" :disabled="true" :showEditBtn="allowEditAddress" @open="openAddressForm"/>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Contact Person" vid="contact_person" name="contact_person" v-model="contactPersonName" size="sm" :disabled="true"/>


                                    <!--        <ThatsTextarea tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instructions" name="instructions" v-model="form.attr.instructions" size="sm" :disabled="disabled" :rows="2"/> -->

                                </mdb-col>
                                <mdb-col col="6" class="tab-col pl-0 pr-0">
                                    <ThatsSeriesInput :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Transaction ID" placeholder="Transaction ID" vid="series" name="series" v-model="form.series" :validated="validated" :rules="''" :keycode="false" size="sm" :disabled="true" />
                                    <mdb-row class="form-group input-group-sm thats-form">
                                        <mdb-col sm="4" class="tab-col">
                                            <label v-bind:class="'col-form-label'">Sold By</label>
                                        </mdb-col>
                                        <mdb-col sm="4" class="tab-col">
                                            <ThatsInput :showLabel="false" tabindex="2" labelClass="col-sm-6" fieldClass="col-sm-12 pl-0" label="Sold By" :placeholder="form.sold_by" vid="sold_by" name="sold_by" v-model="form.sold_by" size="sm" :disabled="true" />
                                        </mdb-col>
                                        <mdb-col sm="4" class="tab-col">
                                            <ThatsMultiSelect :multiple="true"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="partner" v-model="form.attr.partner" :reduce="label => label.code" :reduceLabel="'label'" :options="partner" :rules="''" :filterable="false" :clearable="false" ></ThatsMultiSelect>
                                        </mdb-col>
                                    </mdb-row>

                                    <mdb-row class="form-group input-group-sm thats-form">
                                        <mdb-col sm="4" class="tab-col">
                                            <label v-bind:class="'col-form-label'">APPLY RESERVATION</label>
                                        </mdb-col>
                                        <mdb-col sm="4" class="tab-col">
                                        <ThatsMultiSelect :clearable="false" :multiple="false" :showLabel="false"  labelClass="col-md-0" fieldClass="col-md-12  pl-0 pr-0" v-model="form.reservation" :reduce="label => label.code" :reduceLabel="'label'" :options="reservationOptions" :rules="''" :disabled="reservationApplyDisabled"></ThatsMultiSelect>
                                        </mdb-col>
                                    </mdb-row>
                                    <template v-if="isReservationApplied && reservationConfirmationAllowed">
                                        <mdb-row class="form-group input-group-sm thats-form">
                                            <mdb-col sm="4" class="tab-col">
                                                <label v-bind:class="'col-form-label'">RESERVATION CONFIRMATION DATE</label>
                                            </mdb-col>
                                            <mdb-col sm="4" class="tab-col">
                                                <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-0" fieldClass="col-md-12 pl-0 pr-0" label="Reservation Confirmation Date" placeholder="Date" vid="reservation_confirmation_date" name="reservation_confirmation_date" v-model="reservationConfirmationDate" :validated="validated" :rules="''" size="sm" :disabled="reservationConfirmationDisabled" :showLabel="false"/>
                                            </mdb-col>
                                            <mdb-col sm="4" class="tab-col">
                                                <mdb-btn v-if="!reservationAlreadyConfirmed" color="elegant" size="sm" class="m-0" @click="confirmReservation" :disabled="reservationConfirmationDisabled">Confirm</mdb-btn>
                                                <mdb-btn v-if="reservationAlreadyConfirmed" color="danger" size="sm" class="m-0 ml-1" @click="cancelReservationConfirmation" :disabled="reservationConfirmationCancelDisabled">Cancel Confirmation</mdb-btn>
                                            </mdb-col>
                                        </mdb-row>
                                    </template>
                                    <ThatsMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Customer Service" v-model="form.attr.customer_service" :reduce="label => label.label" :reduceLabel="'label'" :options="customerService" :rules="''" :disabled="noInvoiceDisabled"></ThatsMultiSelect>

                                    <ThatsMultiSelect :multiple="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Order Status" v-model="form.status" :reduce="label => label.code" :reduceLabel="'label'" :options="status" :rules="'required'" :filterable="false" :clearable="false" :disabled="noInvoiceDisabled" :selectable="orderStatusSelectable"></ThatsMultiSelect>

                                    <ThatsMultiSelect :multiple="false" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Pending Reason" vid="balance_pending_reason" name="balance_pending_reason" v-model="form.attr.balance_pending_reason" :reduce="option => option.code" :reduceLabel="'label'" :options="balancePendingReasons" :rules="''" :disabled="noInvoiceDisabled" :clearable="false" />

                                    <template v-if="isBalancePendingByOrder">
                                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="ETA" placeholder="ETA" vid="balance_pending_eta" name="balance_pending_eta" v-model="form.attr.balance_pending_eta" :validated="validated" :rules="'required'" size="sm" :disabled="noInvoiceDisabled" />
                                    </template>

                                    <template v-if="form.status === 'for-delivery-schedule'">
                                        <template v-if="form.hasOwnProperty('delivery_schedule')">
                                            <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date Request" placeholder="Date Request" vid="date_request" name="date_request" v-model="form.delivery_schedule.date" :validated="validated" :rules="'required'" size="sm" :disabled="noInvoiceDisabled"/>
                                            <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Delivery Remarks" :placeholder="form.attr.delivery_remarks" vid="delivery_remarks" name="delivery_remarks" v-model="form.delivery_schedule.remarks" size="sm" :disabled="noInvoiceDisabled" />
                                        </template>
                                    </template>
                                    <template v-if="form.status ==='to-be-order'">
                                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Expected Date" placeholder="Expected Date" vid="expected_date" name="expected_date" v-model="form.attr.expected_date" :validated="validated" :rules="'required'" size="sm" :disabled="noInvoiceDisabled"/>
                                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="TBO Details" :placeholder="form.attr.tbo_details" vid="tbo_details" name="tbo_details" v-model="form.attr.tbo_details" size="sm" :disabled="noInvoiceDisabled" />
                                    </template>

                                    <template v-if="form.status === 'cancel'">
                                        <ThatsTextarea tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Remarks" vid="description" name="description" v-model="form.description" size="sm" :disabled="false" :rules="'required'"/>
                                    </template>
                                    <template v-if="$helpers.isSystemAdministrator()">
                                        <ThatsTextarea tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instructions" name="instructions" v-model="form.attr.instructions" size="sm" :disabled="disabled" :rows="2"/>
                                    </template>
                                    <template v-else>
                                        <ThatsMultiSelect  :multiple="false" labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="Instructions"  vid="instructions" name="instructions" v-model="form.attr.instructions" :reduce="label => label.code" :reduceLabel="'label'" :options="instructions" :rules="''" :disabled="disabled"></ThatsMultiSelect>
                                    </template>
                                </mdb-col>
                            </mdb-row>
                            <template v-if="returnItem === true">
                                <mdb-row class="tab-row">
                                    <mdb-col col="6" class="tab-col pl-0">
                                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Return Date" placeholder="Date" vid="return_date" name="return_date" v-model="returnForm.date" :validated="validated" :rules="'required'" size="sm"/>
                                    </mdb-col>
                                </mdb-row>
                            </template>
                            <el-table id="itemTable" ref="itemTable" :key="tblKey" border :data="form.items" class="input-table mt-2 itemTable" style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getSummaries" show-summary :cell-class-name="cell" @row-contextmenu="rowContectMenu" v-mdb-click-outside="handleOutsideClick">
                                <template v-if="showCheckBox">
                                    <el-table-column type="selection" width="35" :selectable="canSelectRow"> </el-table-column>


                                </template>
                                <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>
                                <el-table-column label="SKU" :width="150">
                                    <template slot-scope="scope">
                                        <template v-if="disabled">
                                            {{scope.row.code}}
                                        </template>
                                        <template v-else>
                                            <GridVueSelect v-model="scope.row.code" :reduce="item => item.code" :reduceLabel="'code'" :options="items" :filterable="false" :clearable="false" @onSearch="statusKeyUp" @onFocus="statusKeyUpFocus" @select="getSelected($event,scope.$index)" :disabled="disabled"></GridVueSelect>
                                        </template>

                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <!-- <img :src="scope.row.default" style="width:100%" /> -->
                                        <img :src="scope.row.default" style="width:100%" @click="clickShowSearch(scope.row,scope.$index)" />
                                        <template v-if="scope.row.show_search">
                                            <div class="search-fabric">
                                                <label>Enter/Scan Fabric Code</label>
                                                <button type="button" class="close" aria-label="Close" @click="closeFabric(scope.$index)">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <GridFabricSelect :reduce="item => item.id" :reduceLabel="'id'" :options="fabrics" :filterable="false" :clearable="false" @onSearch="statusKeyUpFabric" @select="getSelectedFabric($event,scope.$index,scope.row)"></GridFabricSelect>
                                            </div>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        <template v-if="disabled">

                                            {{scope.row.name}}

                                            <template v-if="scope.row.hasOwnProperty('InTransitItems') && scope.row.InTransitItems.length > 0">
                                                <span class="text-muted small text-small quantity-allocation-info d-block" v-for="item in scope.row.InTransitItems" :key="item.id">
                                                   
                                                    <el-tag size="mini" type="warning">
                                                        ETA : {{ item.ETAWarehouse }}
                                                    </el-tag>
                    
                                                    <el-tag size="mini" type="warning">
                                                    Qty : {{ item.ReservedQty }}
                                                </el-tag>
                                                </span>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.name" @keydown.enter="addNewRow(scope.$index)" :disabled="disabled" />
                                        </template>


                                    </template>
                                </el-table-column>
                                <template v-if="form.invoice.series === null">
                                    <el-table-column label="Qty" :width="70" align="right">
                                        <template slot-scope="scope">
                                            <template v-if="enableQuantity(scope.row)">

                                                {{scope.row.qty}}
                                            </template>
                                            <template v-else>
                                                <input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-on:change="quantityChangeOnReturn(scope.row,$event)" v-model="scope.row.qty" @keyup="calculate(scope.$index,$event)" @change="calculate(scope.$index,$event)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableQuantity(scope.row)" />
                                            </template>

                                        </template>

                                    </el-table-column>
                                    <el-table-column label="Price" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" @keydown.enter="addNewRow(scope.$index)" :disabled="enablePrice(scope.row)" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Amount" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" @keydown.enter="addNewRow(scope.$index)" :disabled="true" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Discount" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            <span v-html="scope.row.discount"></span>
                                            <template v-if="scope.row.code !== null && scope.row.name !== null && disabled === false">
                                                <a href="javascript:void(0)" class="discount-a" @click="openDiscount(scope.$index,scope.row)"><mdb-icon icon="ellipsis-v" /></a>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Total Amount" :width="120" align = "right">
                                        <template slot-scope="scope">
                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" @keydown.enter="addNewRow(scope.$index)" :disabled="true" />
                                        </template>
                                    </el-table-column>
                                </template>
                                <template v-else>
                                    <el-table-column label="Qty" :width="70" align="right">
                                        <template slot-scope="scope">
                                            <template v-if="enableQuantity(scope.row)">
                                                {{scope.row.qty}}
                                            </template>
                                            <!--  <template v-else><input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" @keyup="calculate(scope.$index)" @change="calculate(scope.$index)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableModifyAndCreditNote" /> -->
                                            <template v-else>
                                                <input type="number" min="1" class="form-control grid-input thats-form-control text-right" v-on:change="quantityChangeOnReturn(scope.row,$event)" v-model="scope.row.qty" @keyup="calculate(scope.$index,$event)" @change="calculate(scope.$index,$event)" @keydown.enter="addNewRow(scope.$index)" :disabled="enableQuantity(scope.row)" />

                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Price" :width="100" align = "right">
                                        <template slot-scope="scope">

                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" :disabled="!enablePrice(scope.row)" @keydown.enter="addNewRow(scope.$index)"  @input="calculatePrice(scope.$index,$event)" @focus="removeFormat(scope.$index)" @blur="formatOnBlur(scope.$index)"/>

                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Amount" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" :disabled="true" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Discount" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            <span v-html="scope.row.discount"></span>
                                            <template v-if="scope.row.code !== null && scope.row.name !== null && disabled === false">
                                                <a href="javascript:void(0)" class="discount-a" @click="openDiscount(scope.$index,scope.row)"><mdb-icon icon="ellipsis-v" /></a>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Total Amount" :width="120" align = "right">
                                        <template slot-scope="scope">
                                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" :disabled="true" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="FR. DISPLAY" :width="120" align = "left">
                                        <template slot-scope="scope">
                                            {{(scope.row.from_display=== true ? 'YES' : 'NO')}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="TBO" :width="80" align = "left">
                                        <template slot-scope="scope">
                                            {{(scope.row.tbo=== true ? 'YES' : 'NO')}}
                                        </template>
                                    </el-table-column>
                                </template>

                                <template v-if="returnItem === true">
                                    <el-table-column :width="90" label="Delivered">
                                        <!--   <template slot-scope="{}" slot="header">
                                  <el-checkbox :indeterminate="isIndeterminateDelivered" v-model="checkAllDelivered" @change="handleCheckAllChangeDelivered">Delivered</el-checkbox>
                                </template> -->
                                        <template slot-scope="scope">
                                            <ValidationProvider :rules="(checkIfRowSelected(scope.row.id) === true ? 'required' : '')" :vid="`delivery-${scope.row.id}`" :name="`delivery-${scope.row.id}`" v-slot="{ errors }">
                                                <select class="thats-form-control" :key="scope.row.id" v-model="scope.row.delivered">
                                                    <option value=""></option>
                                                    <option value="false">No</option>
                                                    <option value="true">Yes</option>
                                                </select>

                                                <span class="text-sm small text-red block text-danger ">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            <!-- <el-checkbox v-model="scope.row.delivered" style="margin-left:6px" @change="handleCheckedTboChangeDelivered">Delivered</el-checkbox> -->
                                        </template>
                                    </el-table-column>
                                </template>

                                <el-table-column :label="(refundItem === true || returnItem === true  || exchangeItem === true ? 'Reason' : 'Remarks')" :width="120">
                                    <template slot-scope="scope">
                                        <ValidationProvider :rules="(checkIfRowSelected(scope.row.id) === true ? 'required' : '')" :vid="`delivery-remarks-${scope.row.id}`" :name="`delivery-remarks-${scope.row.id}`" v-slot="{ errors }">

                                            <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.remarks" :disabled="enableReason(scope.row)" />
                                            <span class="text-sm small text-red text-danger block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </template>
                                </el-table-column>
                                <template v-if="form.invoice.series === null">
                                    <el-table-column :width="75">
                                        <template slot-scope="{}" slot="header">
                                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllTbo" @change="handleCheckAllChange">TBO</el-checkbox>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-checkbox v-model="scope.row.tbo" style="margin-left:6px" @change="handleCheckedTboChange">TBO</el-checkbox>
                                        </template>
                                    </el-table-column>


                                </template>
                                <!--  <el-table-column :width="120" align="center">
                              <template slot-scope="scope" slot="header">
                                <el-checkbox :indeterminate="isIndeterminateFromDisplay" v-model="checkAllFromDisplay" @change="handleCheckAllFromDisplayChange" :disabled="enableQuantity(scope.row)">Fr. Display</el-checkbox>
                              </template>
                              <template slot-scope="scope">

                                <template v-if="enableQuantity(scope.row)">
                                    <template v-if="scope.row.from_display">Yes</template>
                                </template>
                                <template v-else>
                                  <el-checkbox v-model="scope.row.from_display" style="margin-left:6px" @change="handleCheckedFromDisplayChange"></el-checkbox>
                                </template>



                              </template>
                            </el-table-column> -->

                            </el-table>






                            <table class="el-table">
                                <tr>
                                    <template v-if="!disabled">
                                        <td></td>
                                    </template>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style="width:100px"><el-checkbox v-model="form.more_discount.enable" :disabled="disabled">Invoice Discount </el-checkbox></td>
                                    <td style="width:200px">
                                        <input type="text" class="form-control grid-input thats-form-control text-right inv-discount-percent" style="padding-right : 5px" v-model="form.more_discount.percent" @keyup="invoiceDiscountPercent" :disabled="disabled" />
                                        <span class="inv-discount-percent-lbl">%</span>
                                        <input type="text" class="form-control grid-input thats-form-control text-right inv-discount" style="padding-right : 5px" v-model="form.more_discount.discount" @keyup="invoiceDiscount" @focus="removeDiscountFormat()" @blur="formatOnBlurMoreDiscount()" @keydown.enter="addMoreDiscount()" :disabled="disabled" />



                                    </td>
                                    <td style="width:120px" class="text-right">
                                        <strong>{{form.total}}</strong>
                                    </td>
                                    <template v-if="disabled">
                                        <td style="width:130px"></td>
                                    </template>
                                    <template v-else>
                                        <td style="width:114px"></td>
                                    </template>
                                </tr>
                            </table>

                            <mdb-row class="tab-row">
                                <mdb-col col="6" class="tab-col pl-0">
                                </mdb-col>
                                <mdb-col col="6" class="tab-col">
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0 pr-0 text-right" label="Discount Remarks" vid="discount_remarks" name="discount_remarks" v-model="form.attr.discount_remarks" size="sm" :disabled="disabled"/>
                                </mdb-col>
                            </mdb-row>

                        </template>
                        <template :slot="'credit-notes'">

                            <el-table :key="'cn'+tblKey" border :data="form.credit_note_items" @selection-change="handleCreditNoteSelectionChange" class="input-table mt-0" style="width: 100%" :summary-method="getCreditNoteSummaries" show-summary>

                                <template v-if="pullout">
                                    <el-table-column type="selection" width="35" :selectable="canSelectRow"> </el-table-column>
                                </template>

                                <el-table-column label="SKU" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.code}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.default" style="width:90px" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Qty" :width="70" align="right">
                                    <template slot-scope="scope">
                                        <template v-if="(checkSystemSupport === true && modifyReturmItem === true) || (checkSystemSupport === true && scope.row.status === 'for-approval' && modifyReturmItem === true)">
                                            <input type="number" min="1" v-on:change="quantityChange(scope.row,$event)" :max="scope.row.max" class="form-control grid-input thats-form-control text-right" v-model="scope.row.qty" @keyup="calculateCreditNote(scope.$index,$event)" @change="calculateCreditNote(scope.$index,$event)" @keydown.enter="addNewRow(scope.$index)" />
                                        </template>
                                        <template v-else>
                                            {{scope.row.qty}}
                                        </template>
                                        <!-- {{scope.row.qty}} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="Price" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.price | amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Discount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.discount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Total Amount" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.total}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Reason" :width="120">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Status" :width="120">
                                    <template slot-scope="scope">
                                        {{scope.row.status_label}}
                                    </template>
                                </el-table-column>
                            </el-table>

                            <template v-if="form.credit_note !== null && Object.keys(form.credit_note).length > 0 && form.credit_note.constructor === Object">
                                <table class="el-table">
                                    <tr>

                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="width:100px"  class="text-right"></td>

                                        <td style="width:200px" class="text-right">
                                            <template v-if="form.credit_note.status === 'for-approval'">
                                                Credit Note Amount
                                            </template>
                                            <template v-else>
                                                Approved Credit Note Amount
                                            </template>
                                        </td>
                                        <td style="width:120px" class="text-right">
                                            <template v-if="form.hasOwnProperty('credit_notes') && form.credit_notes.length > 0">
                                                <strong>{{form.credit_notes.filter((i) => i.status === 'approved',[]).map((i) => i.total,0).reduce((a,b) => a + b, 0) | amount}}</strong>
                                            </template>
                                        </td>
                                        <td style="width:114px">&nbsp;</td>
                                        <td style="width:114px">&nbsp;</td>

                                    </tr>
                                </table>

                                <label class="mt-1"><strong>CREDIT NOTE PAYMENTS</strong></label>
                                <el-table :key="'cnreference'+tblKey" border :data="form.credit_note.credit_note_reference" class="input-table mt-1" style="width: 100%" :summary-method="getCreditNotePaymentSummaries" show-summary :cell-class-name="creditNoteCell">


                                    <el-table-column label="Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Invoice Ref. No.">
                                        <template slot-scope="scope">
                                            {{scope.row.invoice.series}}
                                        </template>
                                    </el-table-column>


                                    <el-table-column label="Invoice Amount" :width="150" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.invoice.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Credit note" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.amount | amount}}
                                        </template>
                                    </el-table-column>

                                </el-table>

                                <table class="el-table">
                                    <tr>

                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>

                                        <td style="width:200px" class="text-right">
                                            Remaining Credit Note
                                        </td>
                                        <td style="width:120px" class="text-right">

                                            <template v-if="form.credit_note.hasOwnProperty('credit_note_reference') && form.credit_note.credit_note_reference.length > 0">
                                                <strong>{{ remainingCreditNote | amount}}</strong>
                                            </template>
                                        </td>

                                    </tr>
                                </table>

                                <label class="mt-1"><strong>CREDIT NOTE</strong></label>
                                <el-table :key="'cnsreference'+tblKey" border :data="form.credit_notes" class="input-table mt-1" style="width: 100%" :summary-method="getCreditNotesSummaries" show-summary>


                                    <el-table-column label="Series" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.series}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Approved Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.attr.approved_date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Approved By" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.attr.approved_by}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.invoice.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Invoice Ref. No.">
                                        <template slot-scope="scope">
                                            {{scope.row.invoice.series}}
                                        </template>
                                    </el-table-column>


                                    <el-table-column label="Invoice Amount" :width="150" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.invoice.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Credit note" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Status" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.status}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="" :width="200" align = "left">
                                        <template slot-scope="scope">
                                            <mdb-btn color="elegant" size="sm" @click="fnPrint('/sales-return/print/'+scope.row.token_id)">Print</mdb-btn>
                                            <!-- <template v-if="$helpers.isSystemAdministrator() || $helpers.isAccounting()">
                            <template v-if="scope.row.status === 'approved' && (typeof scope.row.attr.document === 'undefined' || (scope.row.attr.hasOwnProperty('document') && (scope.row.attr.document.entry === null || scope.row.attr.document.entry === 'null')) )">
                              <template v-if="scope.row.loading">
                                <mdb-btn color="elegant" size="sm" disabled>
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  Loading...
                                </mdb-btn>
                              </template>
                              <template v-else>
                                        <mdb-btn @click="creditNotePushToSap(scope.row)" class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                              </template>
                          </template>
                          <template v-else>
                             <mdb-btn :disabled="true" class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                          </template>
                        </template> -->
                                        </template>
                                    </el-table-column>
                                </el-table>


                            </template>
                        </template>


                        <template :slot="'cancelled-items'">

                            <el-table :key="'cn'+tblKey" border :data="form.cancellation_item" @selection-change="handleCreditNoteSelectionChange" class="input-table mt-0" style="width: 100%" :summary-method="getItemCancellationSummaries" show-summary>



                                <el-table-column label="SKU" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.code}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.default" style="width:90px" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Qty" :width="70" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.qty}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Price" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.price | amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Discount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.discount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Total Amount" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.total}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Reason" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>

                            </el-table>

                            <template v-if="form.cancellation.length > 0">

                                <label class="mt-1"><strong>CANCEL REQUEST</strong></label>
                                <el-table :key="'cnreference'+tblKey" border :data="form.cancellation" class="input-table mt-1" style="width: 100%">


                                    <el-table-column label="Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Invoice Ref. No.">
                                        <template slot-scope="scope">
                                            {{scope.row.series}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Amount" :width="150" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Status" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.status}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="" :width="80">
                                        <template slot-scope="scope">
                                            <mdb-btn @click="fnPrint('/cancel-item/print/'+scope.row.token_id)" class="m-0" color="elegant" size="sm">Print</mdb-btn>
                                        </template>
                                    </el-table-column>

                                </el-table>

                            </template>
                        </template>


                        <template :slot="'exchange-items'">

                            <el-table :key="'exc'+tblKey" border :data="form.exchange_item" @selection-change="handleCreditNoteSelectionChange" class="input-table mt-0" style="width: 100%" :summary-method="getItemCancellationSummaries" show-summary>



                                <el-table-column label="SKU" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.code}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.default" style="width:90px" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Qty" :width="70" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.qty}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Price" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.price | amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Discount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.discount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Total Amount" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.total}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Reason" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>

                            </el-table>

                            <template v-if="form.hasOwnProperty('exchange') && form.exchange.length > 0">

                                <label class="mt-1"><strong>EXCHANGE</strong></label>
                                <el-table :key="'cnreference'+tblKey" border :data="form.exchange" class="input-table mt-1" style="width: 100%">


                                    <el-table-column label="Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Invoice Ref. No.">
                                        <template slot-scope="scope">


                                            <a href="javascript:void(0)">{{scope.row.series}}</a>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Amount" :width="150" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Status" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.status}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="" :width="200">
                                        <template slot-scope="scope">

                                            <mdb-btn @click="fnPrint('/exchange-item/print/'+scope.row.token_id)" class="m-0" color="elegant" size="sm">Print</mdb-btn>


                                            <!-- <template v-if="scope.row.status === 'approved' && unformatBalance(form.invoice.balance) < 0 && scope.row.reference_transaction === null">
                                    <a href="javascript:void(0)" @click="viewExchange(scope.row.series,scope.row,scope.$index,false)" class="btn btn-elegant btn-sm">Exchange With</a>
                                  </template> -->
                                            <template v-if="scope.row.status === 'approved' && scope.row.reference_transaction !== null">
                                                <a href="javascript:void(0)" @click="viewExchange(scope.row.series,scope.row,scope.$index,true)" class="btn btn-elegant btn-sm">View</a>
                                            </template>
                                        </template>
                                    </el-table-column>

                                </el-table>

                            </template>
                        </template>

                        <template :slot="'refund-items'">

                            <el-table :key="'exc'+tblKey" border :data="form.refund_item" @selection-change="handleCreditNoteSelectionChange" class="input-table mt-0" style="width: 100%" :summary-method="getItemCancellationSummaries" show-summary>

                                <el-table-column label="SKU" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.code}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.default" style="width:90px" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Qty" :width="70" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.qty}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Price" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.price | amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Discount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.discount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Total Amount" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.total}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Reason" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>

                            </el-table>

                            <template v-if="form.hasOwnProperty('refund') && form.refund.length > 0">

                                <label class="mt-1"><strong>REFUND</strong></label>
                                <el-table :key="'cnreference'+tblKey" border :data="form.refund" class="input-table mt-1" style="width: 100%">


                                    <el-table-column label="Date" width="150">
                                        <template slot-scope="scope">
                                            {{scope.row.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Invoice Ref. No.">
                                        <template slot-scope="scope">


                                            <a href="javascript:void(0)">{{scope.row.series}} </a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Collected By">
                                        <template slot-scope="scope">
                                            {{scope.row.collected_by}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Approved Refund Amount" :width="150" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.total | amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Status" :width="100" align = "right">
                                        <template slot-scope="scope">
                                            {{scope.row.status}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="" :width="200">
                                        <template slot-scope="scope">
                                            <mdb-btn @click="fnPrintDoc(`refund-item/print/${scope.row.token_id}`)" class="m-0" color="elegant" size="sm">Print</mdb-btn>
                                        </template>
                                    </el-table-column>

                                </el-table>

                            </template>
                        </template>

                        <template :slot="'delivery-notes'">
                            <el-table ref="itemsTable" border :data="form.delivery_notes" class="input-table mt-0" style="width: 100%">

                                <el-table-column label="Series" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.series}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Date" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.date}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Details">
                                    <template slot-scope="scope">
                                        {{scope.row.delivered_items}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Delivery Remarks">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Status" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.status | uppercase}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Delivery Note" width="120" align="center">
                                    <template slot-scope="scope">
                                        <mdb-btn @click="fnPrint('/delivery/print-note/'+scope.row.token_id)" class="m-0" color="elegant" size="sm">Print</mdb-btn>



                                    </template>
                                </el-table-column>
                                <!--  <template v-if="$helpers.isSystemAdministrator() || $helpers.isAccounting()">
                      <el-table-column label="" width="120" align="center">
                        <template slot-scope="scope">
                          <template v-if="scope.row.push === true && scope.row.status === 'delivered' && (typeof scope.row.attr.document === 'undefined' || (scope.row.attr.hasOwnProperty('document') && (scope.row.attr.document.entry === null || scope.row.attr.document.entry === 'null')) )">
                            <template v-if="scope.row.loading">
                              <mdb-btn color="elegant" size="sm" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                              </mdb-btn>
                            </template>
                            <template v-else>
                                <mdb-btn @click="deliveryNotePushToSap(scope.row)" class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                            </template>
                          </template>

                        </template>
                      </el-table-column>
                      </template> -->
                            </el-table>

                            <label class="mt-1"><strong>PULL-OUT DETAILS</strong></label>
                            <el-table :key="'cnreference'+tblKey" border :data="form.pull_out" class="input-table mt-1" style="width: 100%">

                                <el-table-column label="Ref. No." width="170">
                                    <template slot-scope="scope">
                                        <a href="javascript:void(0)" @click="openPullOut(scope.row)">{{scope.row.series}}</a>
                                    </template>
                                </el-table-column>

                                <el-table-column label="Date" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.date}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Items">
                                    <template slot-scope="scope">
                                        {{scope.row.item_name}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Remarks">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Status">
                                    <template slot-scope="scope">
                                        {{scope.row.status | pullOutStatus}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Pull-Out Order" width="130" align="center">
                                    <template slot-scope="scope">
                                        <mdb-btn @click="fnPrint(`/invoice/pull-out/${scope.row.token_id}`)" class="m-0" color="elegant" size="sm">Print</mdb-btn>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </template>

                        <template :slot="'purchase-request'">

                            <el-table ref="purchaseRequestTable" border :data="form.oprq" class="input-table mt-0" style="width: 100%" :summary-method="getPurchaseRequestSummaries" show-summary>

                                <el-table-column label="DATE" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.date}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="DOC NUM" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.series}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="REQUESTER">
                                    <template slot-scope="scope">
                                        {{scope.row.attr.RequesterName}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="REQUIRED DATE" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.attr.RequriedDate}}
                                    </template>
                                </el-table-column>
                               <!--  <el-table-column label="STATUS" width="150">
                                    <template slot-scope="scope">
                                        {{oprqStatus[scope.row.status]}}
                                    </template>
                                </el-table-column> -->
                            </el-table>
                            <el-table ref="purchaseRequestTable" border :data="form.purchase_request_item" class="input-table mt-0" style="width: 100%" :summary-method="getPurchaseRequestSummaries" show-summary>

                                <el-table-column label="SKU" width="150">
                                    <template slot-scope="scope">
                                        {{scope.row.code}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Image" width="90">
                                    <template slot-scope="scope">
                                        <img :src="scope.row.default" style="width:90px" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Item Name" :row-class-name="''">
                                    <template slot-scope="scope">
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column label="Qty" :width="70" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.qty}}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="Price" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.price|amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.amount|amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Discount" :width="100" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.discount|amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Total Amount" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.total|amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Remarks" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.remarks}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Status" :width="120" align = "right">
                                    <template slot-scope="scope">
                                        {{scope.row.status_label}}
                                    </template>
                                </el-table-column> -->

                            </el-table>
                        </template>

                        <template :slot="'invoice-slot'">
                            <mdb-row >
                                <mdb-col col="6">
                                    <template v-if="form !== null && form.hasOwnProperty('invoice') && form.invoice.date !== null">
                                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date" placeholder="Date" vid="date" name="date" v-model="form.invoice.date" :validated="validated" :rules="'required'" size="sm" :disabled="true"/>
                                    </template>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.attr.mobile" size="sm" :disabled="true"/>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="form.attr.address" size="sm" :disabled="true"/>
                                </mdb-col>
                                <mdb-col col="6">

                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instruction" name="instruction" v-model="form.attr.instruction" size="sm" :disabled="true"/>
                                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Other Details" vid="other_details" name="other_details" v-model="form.attr.other_details" size="sm" :disabled="true"/>
                                </mdb-col>

                            </mdb-row>

                            <el-table border :data="invoice.payments" class="input-table mt-2" style="width: 100%" :summary-method="getPaymentsSummaries" show-summary :cell-class-name="tableRowClassName">
                                <el-table-column label="Series">
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.method !== 'reverse'">
                                            <a href="javascript:void(0)" @click="openPayment(scope.row)" v-html="scope.row.series"></a>
                                        </template>
                                        <template v-else>
                                            {{scope.row.series}}
                                        </template>

                                    </template>
                                </el-table-column>
                                <el-table-column label="Date">
                                    <template slot-scope="scope">
                                        {{scope.row.date}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Canceled">
                                    <template slot-scope="scope">
                                        {{scope.row.canceled.toUpperCase()}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Mode of Payment" width="200">
                                    <template slot-scope="scope">
                                        {{scope.row.payment_method}}

                                        <template v-if="scope.row.method == 'cheque' && scope.row.attr.realized == false">
                                            (To be cleared)
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Payment Ref" width="160">
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.attr != null && scope.row.attr.hasOwnProperty('payment_reference')">
                                            <template v-if="scope.row.method === 'credit-note'">
                                                <a href="javascript:void(0)" @click="openReferenceInvoice(scope.row.attr.payment_reference)">{{scope.row.attr.payment_reference}}</a>
                                            </template>
                                            <template v-else>
                                                {{scope.row.attr.payment_reference}}
                                            </template>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount" :width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.formatted_amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column :width="100" label="Receipt" align="center">
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.canceled !== 'yes'">
                                            <a href="javascript:void(0)" @click="fnPrint('/sales/receipt/'+scope.row.token_id)" color="elegant" size="sm"><span class="badge badge-dark text-uppercase">Print</span></a>
                                        </template>
                                    </template>
                                </el-table-column>
                                <!-- <template v-if="$helpers.isSystemAdministrator() || $helpers.isAccounting()">
                      <el-table-column label="" width="120" align="center">
                        <template slot-scope="scope">

                          <template v-if="!['credit-note','by-invoice'].includes(scope.row.method) && scope.row.amount > 0 && scope.row.push === true">
                              <template v-if="scope.row.loading">
                                <mdb-btn color="elegant" size="sm" disabled>
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  Loading...
                                </mdb-btn>
                              </template>
                              <template v-else>
                               <template v-if="scope.row.canceled !== 'yes'">
                                  <template v-if="scope.row.attr.hasOwnProperty('document') === true && scope.row.attr.document.entry === null">
                                      <mdb-btn @click="paymentPushToSap(scope.row)" class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                                  </template>
                                  <template v-else>
                                    <template v-if="scope.row.attr.hasOwnProperty('document') === false">
                                      <mdb-btn @click="paymentPushToSap(scope.row)" class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                                    </template>
                                    <template v-else>
                                      <mdb-btn disabled class="m-0" color="elegant" size="sm">Push to SAP</mdb-btn>
                                    </template>
                                  </template>
                              </template>
                              </template>
                          </template>
                          <template v-else>
                            --
                          </template>



                        </template>
                      </el-table-column>
                      </template> -->



                            </el-table>

                            <template v-if="form.hasOwnProperty('credit_memo') && form.credit_memo.length > 0">
                                <label class="small">OVERPAID</label>

                                <el-table border :data="form.credit_memo" class="input-table mt-2" style="width: 100%" :summary-method="getPaymentSummaries" show-summary>
                                    <el-table-column label="Series">
                                        <template slot-scope="scope">
                                            <a href="javascript:void(0)" v-html="scope.row.series"></a>

                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Date">
                                        <template slot-scope="scope">
                                            {{scope.row.date}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Mode of Payment">
                                        <template slot-scope="scope">
                                            {{scope.row.mode_of_payment}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Payment Description" width="160">
                                        <template slot-scope="scope">
                                            {{scope.row.payment_method}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Payment Ref" width="160">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.attr != null && scope.row.attr.hasOwnProperty('payment_reference')">
                                                {{scope.row.attr.payment_reference}}
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Amount" :width="100" align="right">
                                        <template slot-scope="scope">
                                            {{scope.row.formatted_amount}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column :width="100" label="Receipt" align="center">
                                        <template slot-scope="scope">
                                            <a href="javascript:void(0)" @click="fnPrint('/sales/receipt/'+scope.row.token_id)" color="elegant" size="sm"><span class="badge badge-dark text-uppercase">Print</span></a>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>

                        </template>
                        
                        <template :slot="'online-payment'">
                            <div class="d-flex justify-content-end mb-2">
                                <template v-if="canGenerateOnlinePaymentLink && canManageOnlinePaymentLink">
                                        <mdb-btn color="elegant" size="sm" :key="`create-link${formKey}`" @click="createOnlinePaymentLink">Generate Online Payment Link</mdb-btn>
                                </template>
                                <template v-else>
                                    <mdb-btn v-if="primaryOnlinePaymentLink && !isCancelledOnlinePayment(primaryOnlinePaymentLink)" color="elegant" size="sm" :disabled="viewLoading || formLoading" @click="openOnlinePaymentLink()">Open Online Payment Link</mdb-btn>
                                    <mdb-btn v-if="hasPendingOnlinePayment && canCancelOnlinePayment" color="elegant" size="sm" :disabled="viewLoading || formLoading" @click="cancelOnlinePaymentLink(primaryOnlinePaymentLink)">Cancel Payment Link</mdb-btn>
                                </template>
                            </div>
                            <el-table border :data="onlinePaymentLinks" class="input-table mt-2" style="width: 100%" :cell-class-name="tableRowClassName">
                                <el-table-column label="Date">
                                    <template slot-scope="scope">
                                        {{ scope.row.created_at}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Invoice ID">
                                    <template slot-scope="scope">
                                        {{ scope.row.invoice_id || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Amount">
                                    <template slot-scope="scope">
                                        {{$helpers.formatMoney(scope.row.amount)}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Status">
                                    <template slot-scope="scope">
                                        {{scope.row.status}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>

                        <template :slot="'form-attachment'">
                            <ThatsFile labelClass="col-sm-5" fieldClass="col-sm-7 pl-0" label="Attachment" vid="sales-transaction-attachment" name="sales-transaction-attachment" v-model="form.attachment" :disabled="false" :showLabel="false" :accept="'*'"></ThatsFile>
                        </template>

                        <template :slot="'sap-documents-slot'">

                            <template v-if="form.hasOwnProperty('ordr') && form.ordr != null && form.ordr.length > 0">
                                    <mdb-row >
                                            <mdb-col col="6">
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Sales Order No." vid="docNum" name="docNum" v-model="form.ordr[0].number" size="sm" :disabled="true"/>
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Document Entry" vid="docEntry" name="docEntry" v-model="form.ordr[0].entry" size="sm" :disabled="true"/>
                                            </mdb-col>
                                            <template v-if="form.ordr_sap_data !== null">
                                            <mdb-col col="6">
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Connection" vid="Connection" name="Connection" v-model="form.ordr[0].reference" size="sm" :disabled="true"/>
                                                <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Delivery Date" placeholder="Delivery Date" vid="DocDueDate" name="DocDueDate" v-model="form.ordr_sap_data.DocDueDate" :validated="validated" :rules="'required'" size="sm" />
                                            </mdb-col>
                                            </template>

                                        </mdb-row>
                            </template>


                           <!--  <el-table ref="itemsTable" border stripe :data="form.ordr" class="input-table mt-2 custom-element-table" style="width: 100%">
                                <el-table-column label="DocNum" width="100">
                                        <template slot-scope="scope">
                                        {{scope.row.number}}
                                        </template>
                                    </el-table-column>
                                <el-table-column label="DocEntry" width="100">
                                    <template slot-scope="scope">
                                    {{scope.row.entry}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Connection">
                                    <template slot-scope="scope">
                                    {{scope.row.connection}}
                                    </template>
                                </el-table-column>
                            </el-table> -->

                            <template v-if="form.ordr_sap_data !== null">
                                <label class="mt-3"><strong>SALES ORDER ITEMS</strong></label>
                                <el-table
                                    ref="sapTable"
                                    :data="delivery_tableData"
                                    row-key="__rowKey"
                                    border
                                    default-expand-all
                                    :tree-props="{ children: 'children' }"
                                    @selection-change="delivery_onSelectionChange"
                                    @select="delivery_onRowSelect"
                                    @select-all="delivery_onSelectAll"
                                    size="mini"
                                    >
                                    <el-table-column type="selection" width="48" :selectable="delivery_rowSelectable" />

                                    <el-table-column label="Image" width="100">
                                        <template slot-scope="{ row }">
                                            <img v-if="row.default" :src="row.default" style="width:90px" />
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        prop="ItemCode"
                                        label="Item Code"
                                        min-width="170"
                                        show-overflow-tooltip
                                    />

                                    <el-table-column
                                        prop="Dscription"
                                        label="Item Name"
                                        min-width="260"
                                        show-overflow-tooltip
                                    />

                                    <el-table-column
                                        prop="CodeBars"
                                        label="UPC"
                                        min-width="150"
                                        show-overflow-tooltip
                                    />
                                    

                                    <el-table-column label="Qty" width="180">
                                        <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.__issueQty"
                                            :min="0"
                                            :max="row.__maxQty"
                                            :step="1"
                                            size="mini"
                                            :disabled="!!row.__parent"
                                            @change="delivery_onIssueQtyChange(row)"
                                        />
                                        <div class="tiny muted" v-if="row.__maxQty !== null">
                                            <span v-if="row.__parent">
                                            · BOM: x{{ delivery_toNumber(row.BOMReqQty) || 1 }}
                                            </span>
                                        </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Batches" min-width="240">
                                        <template slot-scope="{ row }">
                                        <div class="batch-cell">
                                            <span
                                            v-if="Array.isArray(row.components) && row.components.length > 0"
                                            class="muted"
                                            >-</span
                                            >

                                            <template v-else>
                                            <el-tag size="mini">
                                                {{ delivery_batchAllocatedTotal(row) }} / {{ row.__issueQty }}
                                            </el-tag>

                                            <el-button
                                                type="text"
                                                size="mini"
                                                :disabled="!delivery_canAllocate(row)"
                                                @click="delivery_openBatchDialog(row)"
                                            >
                                                Allocate
                                            </el-button>

                                            <div
                                                v-if="delivery_batchAllocatedTotal(row) > delivery_toNumber(row.__issueQty)"
                                                class="tiny danger"
                                            >
                                                Total by batch exceeds row qty
                                            </div>

                                            <div
                                                v-if="row.__anyBatches && !row.__batchOptions.length"
                                                class="tiny muted"
                                            >
                                                No batches for this warehouse (switch warehouse)
                                            </div>

                                            <div
                                                v-if="
                                                row.__anyBatches &&
                                                row.__batchOptions.length &&
                                                delivery_toNumber(row.__available) <= 0
                                                "
                                                class="tiny danger"
                                            >
                                                No available stock in selected warehouse
                                            </div>

                                            <div v-if="row.__anyBatches && !delivery_isRowValid(row)" class="tiny muted">
                                                Allocate full qty to enable checkbox
                                            </div>
                                            </template>
                                        </div>
                                        </template>
                                    </el-table-column>

                                    

                                    <el-table-column label="Warehouse" min-width="190">
                                    <template slot-scope="{ row }">
                                    <el-select
                                        v-model="row.__whs"
                                        size="mini"
                                        filterable
                                        placeholder="Select"
                                        @change="delivery_onWhsChange(row)"
                                        :disabled="!!row.__parent || row.__warehouses.length <= 1"
                                        style="width: 100%;"
                                    >
                                        <el-option
                                        v-for="w in row.__warehouses"
                                        :key="w.WhsCode || '__na__'"
                                        :label="delivery_warehouseLabel(w)"
                                        :value="w.WhsCode"
                                        :disabled="!w.WhsCode"
                                        />
                                    </el-select>
                                    </template>
                                </el-table-column>

                                    <el-table-column label="Available" width="110" align="right">
                                        <template slot-scope="{ row }">
                                        <span
                                            v-if="Array.isArray(row.components) && row.components.length > 0"
                                            class="muted"
                                            >-</span
                                        >
                                        <span v-else :class="{ danger: row.__available < 0 }">
                                            {{ row.__available }}
                                        </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            
                        </template>

                        <template :slot="'sales-return-request-slot'">
                        
                          <template v-if="form.hasOwnProperty('ordr') && form.ordr != null && form.ordr.length > 0">
                                    <mdb-row >
                                            <mdb-col col="6">
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Sales Order No." vid="docNum" name="docNum" v-model="form.ordr[0].number" size="sm" :disabled="true"/>
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Document Entry" vid="docEntry" name="docEntry" v-model="form.ordr[0].entry" size="sm" :disabled="true"/>
                                            </mdb-col>
                                          <template v-if="form.ordr_sap_data !== null">
                                            <mdb-col col="6">
                                                <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Connection" vid="Connection" name="Connection" v-model="form.ordr[0].reference" size="sm" :disabled="true"/>
                                                <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Return Date" placeholder="Return Date" vid="DocDueDate" name="DocDueDate" v-model="form.ordr_sap_data.DocDueDate" :validated="validated" :rules="'required'" size="sm" />
                                            </mdb-col>
                                            </template>

                                        </mdb-row>
                            </template>

                            <template v-if="return_requestHeader && return_requestHeader.transaction_id === form.mdbID">
                                <mdb-row class="return-request-header">
                                    <mdb-col col="6">
                                        <div class="return-request-header-title">Linked Credit Note Reference</div>
                                        <div class="return-request-header-value">
                                            {{ return_requestHeader.credit_note_series || '-' }}
                                            <template v-if="return_requestHeader.credit_note_id">
                                                (#{{ return_requestHeader.credit_note_id }})
                                            </template>
                                        </div>
                                        <div class="return-request-header-subtitle">
                                            Status: {{ return_requestHeader.credit_note_status || '-' }}
                                        </div>
                                    </mdb-col>
                                </mdb-row>
                            </template>

                             <template v-if="form.ordr_sap_data !== null && return_requestTableData.length > 0">
                                <el-table
                                    ref="sapReturnTable"
                                    :data="return_requestTableData"
                                    row-key="__rowKey"
                                    border
                                    stripe
                                    default-expand-all
                                    :row-class-name="returnReq_rowClassName"
                                    :tree-props="{ children: 'children' }"
                                    @selection-change="returnReq_onSelectionChange"
                                    @select="returnReq_onRowSelect"
                                    @select-all="returnReq_onSelectAll"
                                    size="mini"
                                    >
                                    <el-table-column type="selection" width="48" :selectable="returnReq_rowSelectable" />
                                    <el-table-column
                                        label="ItemCode"
                                        min-width="170"
                                        show-overflow-tooltip
                                    >
                                        <template slot-scope="{ row }">
                                            <span>{{ row.ItemCode }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Image" width="100">
                                        <template slot-scope="{ row }">
                                            <img
                                                v-if="row.default"
                                                :src="row.default"
                                                style="width:50px"
                                            />
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Item Name"
                                        min-width="260"
                                        show-overflow-tooltip
                                    >
                                        <template slot-scope="{ row }">
                                            <span>{{ row.Dscription }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Source"
                                        width="150"
                                        show-overflow-tooltip
                                    >
                                        <template slot-scope="{ row }">
                                            <span>{{ row.__rowTypeLabel }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Line Status"
                                        width="120"
                                        align="center"
                                    >
                                        <template slot-scope="{ row }">
                                            <el-tag size="mini" :type="returnReq_lineStatusType(row)">
                                                {{ returnReq_lineStatusLabel(row) }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Picking"
                                        width="110"
                                        align="center"
                                    >
                                        <template slot-scope="{ row }">
                                            <span>{{ returnReq_pickingStatusLabel(row) }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        prop="DeliveredDateDisplay"
                                        label="Delivered Date"
                                        min-width="120"
                                        show-overflow-tooltip
                                    />

                                    <el-table-column
                                        prop="DocNum"
                                        label="DN Number"
                                        min-width="110"
                                        show-overflow-tooltip
                                    />

                                    <el-table-column label="Available Qty" width="120" align="right">
                                        <template slot-scope="{ row }">
                                            <span>{{ delivery_toNumber(row.Qty) }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="Return Qty" width="130">
                                        <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.__issueQty"
                                            :min="0"
                                            :max="row.__maxQty"
                                            :step="1"
                                            size="mini"
                                            :disabled="!returnReq_rowSelectable(row)"
                                            @change="returnReq_onIssueQtyChange(row)"
                                        />
                                        </template>
                                    </el-table-column>

                                   <!--  <el-table-column label="Returnable" width="110" align="center">
                                        <template slot-scope="{ row }">
                                            <el-tag v-if="returnReq_rowSelectable(row)" size="mini" type="success">Yes</el-tag>
                                            <el-tag v-else size="mini" type="info">No</el-tag>
                                        </template>
                                    </el-table-column> -->

                                    <el-table-column label="Remarks" min-width="160">
                                        <template slot-scope="{ row }">
                                            <div>
                                                <el-input
                                                    v-model="row.Remarks"
                                                    size="mini"
                                                    placeholder="Remarks (Required)"
                                                    :disabled="!returnReq_rowSelectable(row)"
                                                    :class="{'is-invalid': returnReq_isRowSelected(row) && !row.Remarks}"
                                                />
                                                <div v-if="returnReq_isRowSelected(row) && !row.Remarks" class="tiny danger" style="margin-top: 2px;">
                                                    Required
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                
                                <!-- Debug info -->
                               <!--  <div class="mt-2 text-muted small">
                                    Selected: {{ return_requestSelectedRows.length }} items | 
                                    Expanded: {{ return_requestExpandedSelectedRows.length }} items
                                </div> -->
                                
                                
                            </template>


                        </template>

                        
                    </mdb-tabs>


                </div>
            </ThatsWindow>
        </ValidationObserver>
        <ContactsForm ref="contactForm" :group="(group + 1)" @success="contactSuccess" @update="contactUpdateSuccess"></ContactsForm>
        <PaymentForm ref="paymentForm" :group="(group + 1)" @success="paymentSuccess" @print="fnPrint"></PaymentForm>
        <UpdatePaymentForm ref="updatePaymentForm" :data="paymentForm" :group="(group + 1)" @success="updatePaymentSuccess" @print="fnPrint" :formStatus="paymentFormStatus"></UpdatePaymentForm>
        <UpdatePaymentFormVerTwo ref="updatePaymentFormVerTwo" :group="(group + 1)" @success="updatePaymentSuccess" @print="fnPrint"></UpdatePaymentFormVerTwo>
        <DiscountForm ref="discount" :group="(group + 1)" @apply="applyDiscount"></DiscountForm>
        <PrintWindow ref="printWindow" :group="3" :url="printUrl"></PrintWindow>
        <PullOutForm ref="pullOutForm" :group="(group + 1)"></PullOutForm>
        <ContactsFormUpdate ref="contactsFormUpdate" :group="(group + 1)" @success="contactUpdateSuccess"></ContactsFormUpdate>
        <PromptPassword ref="promptPasswordForm" :group="(group + 1)" @isAuthorized="isAuthorized"></PromptPassword>
        <ExchangeForm ref="exchangeForm" :group="(group + 1)" @request-exchange="requestExchangeReplacement"></ExchangeForm>
        <ExchangeViewForm ref="exchangeViewForm" :group="(group + 1)"></ExchangeViewForm>
        <HistoryWindow :group="(group + 1)" ref="historyWindow" title="History" :width="900"></HistoryWindow>

        <AddressForm :group="(group + 1)" ref="addressForm" title="Address" :width="900" :formDataProps="form" @update="updateAddress"></AddressForm>
        <ConfirmCreditNoteForm :group="(group + 1)" ref="confirmCreditNoteForm" title="Confirm" :width="900" @action-selected="confirmCreditNote"></ConfirmCreditNoteForm>


        <el-dialog title="Send Delivery Request" :visible.sync="requestDeliveryDialog" :close-on-click-modal="false" width="40%" size="small" class="text-left">
        
        
           <!-- <p class="m-0">
        <strong>To : </strong> <el-select class="border-0" v-model="requiredDeliveryForm.recipient" multiple placeholder="Select" :disabled="true">
        <el-option
          v-for="item in [{
              value: 'delivery@thatliving.com',
              label: 'delivery@thatliving.com'
            }]"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </p>

      <p class="m-0">
        <strong>From : </strong> <el-select class="border-0" v-model="requiredDeliveryForm.from" multiple placeholder="Select" :disabled="true">
        <el-option
          v-for="item in [{
              value: requiredDeliveryForm.from[0],
              label: requiredDeliveryForm.from[0]
            }]"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </p> -->
            <mdb-alert color="warning">
                The message will be sent to the delivery team
            </mdb-alert>
            <br />
            <p>Dear Team,</p>
            <p>Please schedule delivery for invoice # : <strong>{{form.invoice.series }}</strong></p>

            <p class="text-muted text-danger"><i> <strong>Reminder</strong>: Our delivery team requires the customer's delivery location. Please provide a complete address as much as possible.<br />
                Insert your additional message below. </i></p>
            <mdbWysiwygTextarea ref="descriptionEditor" class="mt-3 mb-4" placeholder="Additional Message"></mdbWysiwygTextarea>
            <p>Thank you</p>


            <mdb-btn color="elegant" size="sm" @click="sendDeliveryRequestForm" :disabled="requestDeliveryLoading">Send</mdb-btn>

        </el-dialog>

        <el-dialog
            title="Return Request Type"
            :visible.sync="returnRequestTypeDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="420px"
            class="text-left"
        >
            <div class="dialog-head">
                Please select return request type <span class="danger">*</span>
            </div>

            <el-radio-group v-model="returnRequestType">
                <el-radio label="exchange">Exchange (can be use to another invoice as payment)</el-radio>
                <el-radio label="refund">Refund</el-radio>
            </el-radio-group>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="closeReturnRequestTypeDialog">Cancel</el-button>
                <el-button
                    type="primary"
                    size="mini"
                    :disabled="!returnRequestType"
                    @click="proceedSubmitReturnRequest"
                >
                    Continue
                </el-button>
            </span>
        </el-dialog>

        <PaymentDialogForm ref="paymentDialogForm" @success="paymentSuccess"></PaymentDialogForm>
        <IssueVoucher ref="issueVoucherDialogForm" @success="issueVoucherSuccess"></IssueVoucher>
        <PaymentLinkDialogForm ref="paymentLinkDialogForm" @makePayment="makePayment" @linkCreated="linkCreated" @cancelPaymentLink="cancelOnlinePaymentLinkFromDialog" :data="paymentLinkDialogForm"></PaymentLinkDialogForm>

<el-dialog
      title="Batch allocation"
      :visible.sync="delivery_batchDialogVisible"
      width="780px"
      @close="delivery_onBatchDialogClose"
    >
      <div v-if="delivery_activeRow">
        <div class="dialog-head">
          <div class="strong">
            {{ delivery_activeRow.ItemCode }} — {{ delivery_activeRow.Dscription }}
          </div>
          <div class="tiny muted">
            Warehouse: {{ delivery_activeRow.__whs || "N/A" }} · Qty:
            {{ delivery_activeRow.__issueQty }} · Available: {{ delivery_activeRow.__available }} ·
            Allocated: {{ delivery_batchAllocatedTotal(delivery_activeRow) }}
          </div>
        </div>

        <div class="dialog-actions">
          <!-- <el-button
            size="mini"
            @click="delivery_autoAllocateFIFO(delivery_activeRow)"
            :disabled="
              !delivery_activeRow.__batchOptions.length || delivery_toNumber(delivery_activeRow.__available) <= 0
            "
          >
            Auto allocate (FIFO)
          </el-button>

          <el-button
            size="mini"
            @click="delivery_clearBatchAlloc(delivery_activeRow)"
            :disabled="!delivery_activeRow.__batchOptions.length"
          >
            Clear
          </el-button> -->
        </div>

        <div v-if="!delivery_activeRow.__batchOptions.length" class="muted">
          No batches available for the selected warehouse.
        </div>

        <div
          v-else-if="delivery_toNumber(delivery_activeRow.__available) <= 0"
          class="danger tiny"
        >
          No available stock in selected warehouse.
        </div>

        <el-table
          v-else
          :data="delivery_activeRow.__batchOptions"
          border
          size="mini"
          style="width: 100%;"
        >
          <el-table-column prop="BatchNumber" label="Batch" width="170" />

          <el-table-column label="On Hand" width="120" align="right">
            <template slot-scope="{ row: b }">
              {{ delivery_toNumber(b.OnHand) }}
            </template>
          </el-table-column>

        <!--   <el-table-column prop="ExpDate" label="Exp Date" min-width="170" /> -->

          <el-table-column label="Qty" width="190">
            <template slot-scope="{ row: b }">
              <el-input-number
                v-model="delivery_activeRow.__batchAlloc[b.BatchNumber]"
                :min="0"
                :max="delivery_toNumber(b.OnHand)"
                :step="1"
                size="mini"
                @change="
                  (val, oldVal) =>
                    delivery_onBatchQtyChange(delivery_activeRow, b, val, oldVal)
                "
              />
            </template>
          </el-table-column>
        </el-table>

        <div class="footer-metrics">
          <div
            class="tiny"
            :class="{
              danger:
                delivery_batchAllocatedTotal(delivery_activeRow) >
                delivery_toNumber(delivery_activeRow.__issueQty),
            }"
          >
            Allocated total: {{ delivery_batchAllocatedTotal(delivery_activeRow) }} /
            {{ delivery_activeRow.__issueQty }}
          </div>

          <div
            class="tiny danger"
            v-if="delivery_batchAllocatedTotal(delivery_activeRow) > delivery_toNumber(delivery_activeRow.__issueQty)"
          >
            Fix: reduce batch quantities or increase row qty.
          </div>

          <div
            class="tiny muted"
            v-if="delivery_batchAllocatedTotal(delivery_activeRow) < delivery_toNumber(delivery_activeRow.__issueQty)"
          >
            Allocate full qty to enable checkbox.
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">

     <!--  <el-button
            size="mini"
            @click="delivery_autoAllocateFIFO(delivery_activeRow)"
            :disabled="
              !delivery_activeRow.__batchOptions.length || delivery_toNumber(delivery_activeRow.__available) <= 0
            "
          >
            Auto allocate (FIFO)
          </el-button> -->
 <template v-if="delivery_activeRow">
          <el-button
            size="mini"
            @click="delivery_clearBatchAlloc(delivery_activeRow)"
            :disabled="!delivery_activeRow.__batchOptions.length"
          >
            Clear
          </el-button>
          </template>
          <el-button @click="delivery_batchDialogVisible = false"  size="mini">Close</el-button>
      </span>
    </el-dialog>

     <scan-upc-batch-dialog
      v-model="showScan"
       :document="form.ordr_sap_data"
  prefer-whs-code="SR-03"
      @submit="handleScanSubmit"
    />

    </div>
</template>
<script>

/*eslint no-prototype-builtins: "error"*/

// var hasBarProperty = Object.prototype.hasOwnProperty.call(foo, "bar");

// var isPrototypeOfBar = Object.prototype.isPrototypeOf.call(foo, bar);

// var barIsEnumerable = {}.propertyIsEnumerable.call(foo, "bar");
import { mdbClickOutside,mdbBtn, mdbRow,mdbCol, mdbIcon, mdbTabs,   mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,mdbAlert} from "mdbvue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'


import { userData } from '../../helpers/user'
// import { isGeneralManager } from '../../helpers/headers'
import { selectReturnRequestRows, transformReturnRequestRows, runTestScenarios } from '../../helpers/returnRequestTransform'

import { ThatsWindow,ThatsInput, ThatsSeriesInput, ThatsDatePicker, ThatsMultiSelect, ThatsFile, ThatsCustomMultiSelect, ThatsTextarea, HistoryWindow} from '../../components/thats/Thats'
import mdbWysiwygTextarea from '../../components/wysiwyg/mdbWysiwyg'
import { MessageBox } from 'element-ui';
import Fuse from 'fuse.js'
import unformat from 'accounting-js/lib/unformat.js'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import ContactsForm from '../contacts/ContactsForm'
import DiscountForm from './DiscountForm'
import PaymentForm from './PaymentForm'
import UpdatePaymentForm from './UpdatePaymentForm'
import PullOutForm from './PullOutForm'
import PrintWindow from '../../components/thats/PrintWindow'
import GridVueSelect from './GridVueSelect'
import GridFabricSelect from './GridFabricSelect'
import Sortable from 'sortablejs'
import ContactsFormUpdate from './ContactsFormUpdate'
import axios from 'axios'
import PromptPassword from '../../components/PromptPassword'

import ExchangeForm from './ExchangeForm';
import ExchangeViewForm from './ExchangeViewForm';
import ConfirmCreditNoteForm from './ConfirmCreditNoteForm.vue'
import UpdatePaymentFormVerTwo from './UpdatePaymentFormVerTwo.vue'
import AddressForm from './AddressForm.vue'
import PaymentDialogForm from './PaymentDialogForm'
import IssueVoucher from './IssueVoucher'
import PaymentLinkDialogForm from "./PaymentLinkDialogForm.vue";
import SapIssuePickTable from './SapIssuePickTable.vue'
import ScanUpcBatchDialog from './ScanUpcBatchDialog.vue'
export default {
    directives: {
        mdbClickOutside
    },
    props : {
        group : {
            type : Number,
            default : 2
        },
        windowClass : {
            type : String,
            default : 'collection height-auto invoice-form'
        },
        parentContainerStyle  : {
            type : String,
            default : ''
        }
    },
    components: {
        AddressForm,
        UpdatePaymentFormVerTwo,
        ConfirmCreditNoteForm,
        ExchangeViewForm,
        ExchangeForm,
        PromptPassword,
        ContactsFormUpdate,
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbIcon,
        mdbTabs,
        mdbAlert,
        mdbDropdown,
        mdbDropdownItem,
        mdbDropdownMenu,
        mdbDropdownToggle,
        ValidationProvider,
        ValidationObserver,
        ThatsWindow,
        ThatsInput,
        ThatsSeriesInput,
        ThatsDatePicker,
        ThatsMultiSelect,
        ThatsFile,
        ThatsCustomMultiSelect,
        PrintWindow,
        GridVueSelect,
        ContactsForm,
        DiscountForm,
        PaymentForm,
        UpdatePaymentForm,
        GridFabricSelect,
        PullOutForm,
        ThatsTextarea,
        HistoryWindow,mdbWysiwygTextarea,
        PaymentDialogForm,
        IssueVoucher,
        PaymentLinkDialogForm,
        SapIssuePickTable,
        ScanUpcBatchDialog

    },

    data : () => ({
        formKey : 0,
        isIndeterminateFromDisplay : false,
        checkAllFromDisplay : false,
        requestDeliveryDialog : false,
        dialogTableVisible: false,
        dialogFormVisible: false,
        requestedExchange : false,
        requestedCancel : false,
        customerField : false,
        testing : false,
        isIndeterminate : false,
        checkAllTbo : false,
        isIndeterminateDelivered : false,
        checkAllDelivered : false,
        modifyReturmItem : false,
        returnItem : false,
        request : null,
        selectedTbo : [],
        requests : [],
        disabled : false,
        modify : false,
        pullout : false,
        printUrl : '',
        active : 1,
        validated : false,
        form : null,
        formOriginal : {
            status : 'no-remarks'
        },
        formLoading : false,
        response : {
            error : null,
            message : null
        },
        selected : [],
        tabs : [
            { text: 'Sales Details', slot: 'form-slot' }
        ],
        delivery_status : [],
        showError : false,
        status : [],
        paymentMethod : [],
        items : [],
        fabrics : [],
        customer : [],
        partnerSalesPerson : [],
        partner : [],
        reservationOptions : [
            {label : "Yes", code : 1},
            {label : "No", code : 0},
        ],
        reservationConfirmationDate : null,
        discountForm : null,
        discountFormIndex : null,
        paymentForm : {
            series : 0,
            date : "",
            mode : "full-payment",
            method : "cash",
            customer : "",
            attr : {},
            description : null,
            invoice_series : null,
            amount : 0,
            reference : null,
            transaction_id : null,
            invoice : {
                series : null,
                balance : 0,
                paid : 0,
                amount : 0,
            },

        },
        paymentFormStatus : 'update',
        customFooter : {rows : [{name : "demo"},{remarks : "remarks"}], columns : [{
                field : 'name'
            },{
                field : 'remarks'
            }]},
        total : 0,
        context: null,
        viewMenu: false,
        top: '0px',
        left: '0px',
        newArrange : [],
        sortableState : {},
        sortableStateStatus : true,


        creditNoteSelection : [],

        enableReturn : ["delivered",'collected','cancel','partial-returned','rendered'],
        returnItem : false,


        cancelItemEnable : ["request-item-cancel"],
        cancelItem : false,
        cancelItemLoading : false,

        exchangeItemEnable : ["request-item-exchange"],
        exchangeItem : false,
        exchangeItemLoading : false,

        refundRequested : false,
        refundItemEnable : ["request-item-refund"],
        refundItem : false,
        refundItemLoading : false,

        pushInvoiceToSapLoading : false,
        syncInvoiceLoading : false,

        returnForm : {
            date : null
        },
        instructions : [
            {"label" : "Items by order", "code" : "Items by order"}
        ],
        balancePendingReasons : [
            { label : "-", code : "-" },
            { label : "By Order", code : "by-order" },
            { label : "Fit-Out", code : "fitout" },
            { label : "Custom Furniture", code : "custom-furniture" },
            { label : "All Available", code : "all-available" },
        ],
        displayAddress : '',

        requestDeliveryForm : {
            recipient : ["delivery@thatsliving.com"],
            from : [],
            subject : "",
            message : "",
            invoice : "",
            id : ""
        },
        requestDeliveryLoading : false,
        customerService : [],
        oprqLoading : false,
        oprqStatus : {"bost_Open" : "Open","bost_close" : "Closed"},
        paymentLinkDialogForm : {
            transaction_id : "",
            series : "",
            amount : 0,
            mobile : "",
            currency : "QAR",
            country_code : "974",
            name : "",
            balance_amount : 0,
            maximum_amount : 50000,
            cx_series : "",
            ...{
              total : 0,
              attr : {
                    name : "",
                    mobile : "",
              },
              link : null
          }
        },

        delivery_tableData: [],
        delivery_selectedRows: [],
        delivery_batchDialogVisible: false,
        delivery_activeRow: null,
        delivery_picking: false,
        return_requestTableData: [],
        return_requestSelectedRows: [],
        return_requestExpandedSelectedRows: [],
        return_requestPicking: false,
        showScan : false,
        returnRequestSubmitting: false,
        returnRequestTypeDialogVisible: false,
        returnRequestType: '',
        return_requestHeader: null,
        allowLegacyCreditNoteRequestEnabled: true,
    }),


    created : function() {
        const formItemVar = this.formItemVar();


        if(this.formStatus == 'create' || (this.formStatus == 'update' && this.form === null)){
            this.form = this.formVar();

            this.form.items.push(formItemVar);

            this.nextCode()
            this.currentDateSetter();
            this.tabs = [
                { text: 'Sales Details', slot: 'form-slot' },

            ]

        }
        this.optionsHandler();
        this.loadInvoiceSettings();
        this.discountForm = this.formItemVar();

        const {settings,user} = JSON.parse(localStorage.getItem('user'));


        this.paymentMethod = settings.payment_mode
        this.status = settings.sales_transaction_order_status;
        this.requestDeliveryForm.from.push(user.email)
        // console.log(this.form)
        // alert(this.form)
        // alert(this.formStatus)

//         this.status = [
//     { code: 'collected-x', label: '___________________________________', seperator : true },
//     { code: 'bar', label: 'This is bar' },
//     { code: 'collected-1', label: '___________________________________' , seperator : true },
//     { code: 'disabled', label: 'This option is disabled', disabled: true },
// ];
    },

    mounted(){

        const arr = [
            {name : "test1", code : "test-1"},
            {name : "test2", code : "test-2"},
            {name : "test3", code : "test-3"},
            {name : "test4", code : "test-4"},
            {name : "test5", code : "test-5"},
            {name : "test6", code : "test-6"},
            {name : "test7", code : "test-7"},
        ];

        arr.splice(0, 0, arr.splice(2, 1)[0]);

        // Run return request transformation tests if dev flag is enabled
        // Set window.RUN_RETURN_REQUEST_TESTS = true in console to enable
        if (window.RUN_RETURN_REQUEST_TESTS === true) {
            console.log("🧪 Running Return Request Transformation Tests...");
            runTestScenarios();
        }

    },

    updated(){
        this.$refs.itemTable.$el.querySelector(
            ".el-table__body-wrapper tbody"
        );
    },
    methods: {
        ...mapActions('OnlinePaymentLinkModule',[
            'getStatus',
            'cancelLink'
        ]),
        ...mapActions('LoyaltyMemberModule',[
            'getCustomerLoyaltyMembership'
        ]),
        ...mapMutations('HistoryModule',[
            'setModule',
            'setRecordId',
        ]),
        ...mapMutations('ItemExchangeFormModule',[ 'setItemToExchange','setViewForm','setItemToReplace','exchangeForm']),
        ...mapActions('ItemExchangeFormModule',{
            getExchangeRecord : 'getRecord'
        }),
        ...mapActions('ContactsModule',[ 'GetContacts' ]),
        ...mapActions('ContactsModule',{
            getContact : 'getRecord',
            storeContactRecord : 'StoreRecord',
        }),
        ...mapMutations('ContactsModule',{
            setFormContactStatusUpdate : 'SetFormStatusUpdate',
            setFormRecordUpdate : 'setFormRecordUpdate'
        }),
        ...mapActions('SalesOrderDeliveryModule',{
            createDeliveryDocument : 'storeRecord',
        }),
        ...mapActions('InvoiceModule',[
            'getPartner',
            'storeRecord',
            'updateRecord',
            'updateCreditNote',
            'filterItems',
            'updateStatus',
            'getRecord',
            'getRecordSeries',
            'storeCreditNote',
            'storeItemCancellation',
            'storeItemExchange',
            'storeItemReplacement',
            'storePullOut',
            'storeRefund',
            'sapIntegration',
            'sapCreditNoteIntegration',
            'sapDeliveryNoteIntegration',
            'sapPaymentIntegration',
            'sendDeliveryRequest',
            'createPurchaseRequest',
            'storeReturnRequest',
            'sendInvoiceToCustomer',
        ]),
        ...mapActions('MakePaymentModule',[
            'getCustomerCreditNotes',
            'getCustomerOverPaid',
        ]),
        ...mapMutations('MakePaymentModule',[

            'setPaymentForm',
        ]),
        ...mapActions('PullOutModule',{
            getPullOutRecord : 'getRecord',
        }),
        ...mapMutations('PullOutModule',{
            setPullOutFormRecord : 'setFormRecord',
            setPullOutStatusUpdate: 'setFormStatusUpdate',
        }),
        ...mapMutations('InvoiceModule',[
            'setFormStatusCreate',
            'setFormRecord',
            'setFormStatusUpdate',
            'setTblKey',
        ]),
        ...mapMutations('DiscountModule',[
            'setDiscountForm',
        ]),
        ...mapMutations('TableModule',[
            'SetPage'
        ]),
        ...mapActions('TransactionModule',[
            'filterFabric',
            'getCustomerService',
        ]),

        ...mapMutations('PaymentModule',['setFormData']),
        ...mapMutations('PaymentModule',{
            setPaymentStatusUpdate : 'formUpdate',
            setPaymentStatusCreate : 'formCreate'
        }),
        ...mapActions('DataIntegrationModule',['integrate']),
        ...mapActions('SettingsModule',{
            settingsGetSettings : 'getSettings'
        }),

        ...mapMutations('IssueVoucherModule',{
            setIssueVoucherFormData : 'setFormData'
        }),
        normalizeSettingBoolean(value){
            return value === true || value === 1 || String(value).toLowerCase() === 'true';
        },
        extractAllowLegacyCreditNoteRequestSetting(settings){
            if(!settings){
                return null;
            }

            if(Array.isArray(settings)){
                const matchedSetting = settings.find((setting) => {
                    return setting && (
                        setting.reference === 'allow-legacy-credit-note-request' ||
                        setting.reference === 'allow_legacy_credit_note_request' ||
                        setting.name === 'Allow Legacy Credit Note Request'
                    );
                });

                if(matchedSetting && matchedSetting.attr){
                    return this.normalizeSettingBoolean(matchedSetting.attr.enable);
                }

                return null;
            }

            if(typeof settings !== 'object'){
                return null;
            }

            if(settings.allow_legacy_credit_note_request && settings.allow_legacy_credit_note_request.attr){
                return this.normalizeSettingBoolean(settings.allow_legacy_credit_note_request.attr.enable);
            }

            if(settings['allow-legacy-credit-note-request'] && settings['allow-legacy-credit-note-request'].attr){
                return this.normalizeSettingBoolean(settings['allow-legacy-credit-note-request'].attr.enable);
            }

            if(settings.reference === 'allow-legacy-credit-note-request' && settings.attr){
                return this.normalizeSettingBoolean(settings.attr.enable);
            }

            const values = Object.values(settings);
            const matchedSetting = values.find((setting) => {
                return setting && typeof setting === 'object' && setting.attr && (
                    setting.reference === 'allow-legacy-credit-note-request' ||
                    setting.reference === 'allow_legacy_credit_note_request' ||
                    setting.name === 'Allow Legacy Credit Note Request'
                );
            });

            if(matchedSetting && matchedSetting.attr){
                return this.normalizeSettingBoolean(matchedSetting.attr.enable);
            }

            return null;
        },
        resolveAllowLegacyCreditNoteRequestSetting(settings){
            const directValue = this.extractAllowLegacyCreditNoteRequestSetting(settings);
            if(directValue !== null){
                return directValue;
            }

            if(settings && typeof settings === 'object' && Object.prototype.hasOwnProperty.call(settings, 'data')){
                const nestedDataValue = this.extractAllowLegacyCreditNoteRequestSetting(settings.data);
                if(nestedDataValue !== null){
                    return nestedDataValue;
                }
            }

            if(settings && typeof settings === 'object' && Object.prototype.hasOwnProperty.call(settings, 'settings')){
                const nestedSettingsValue = this.extractAllowLegacyCreditNoteRequestSetting(settings.settings);
                if(nestedSettingsValue !== null){
                    return nestedSettingsValue;
                }
            }

            return null;
        },
        loadInvoiceSettings(retryCount = 0){
            this.settingsGetSettings().then((settings) => {
                const allowLegacy = this.resolveAllowLegacyCreditNoteRequestSetting(settings);
                if(allowLegacy !== null){
                    this.allowLegacyCreditNoteRequestEnabled = allowLegacy;
                    return;
                }

                if(retryCount < 1){
                    setTimeout(() => {
                        this.loadInvoiceSettings(retryCount + 1);
                    }, 200);
                    return;
                }

                this.allowLegacyCreditNoteRequestEnabled = true;
            }).catch(() => {
                if(retryCount < 1){
                    setTimeout(() => {
                        this.loadInvoiceSettings(retryCount + 1);
                    }, 200);
                }
            });
        },
        formVar(){
            return {
                series : "",
                date : "",
                status_index : 0,
                status : "no-remarks",
                reservation : 0,
                reservation_confirmed_at : null,
                reservation_confirmed_by : null,
                attr : {
                    partner : [],
                    name : null,
                    mobile : null,
                    address: null,
                    address2 : {
                        street : null,
                        building : null,
                        zone : null,
                        area : null,
                        city : null,
                    },
                    instructions : null,
                    other_details : null,
                    payment_status : 'no-payment',
                    expected_date : null,
                    tbo_details : null,
                    balance_pending_reason : "-",
                    balance_pending_eta : null,
                    document : {
                        entry : null,
                        number : null,
                        status : false
                    },
                    more_discount : {
                        enable : false,
                        discount : 0,
                        percent : 0
                    },
                    corporate : false,
                    contact_person : {
                        name : null,
                        mobile : null,
                        attr : {

                            address: null,
                            address2 : {
                                street : null,
                                building : null,
                                zone : null,
                                area : null,
                                city : null,
                            },
                            designation : null,
                            email : null,
                            first_name : null,
                            middle_name : null,
                            last_name : null,
                            salutation : null
                        }
                    },
                    from_display: false,
                    quantity_origin:[]
                },
                customer : {
                    name : null,
                    mobile : null,
                    address : null,
                },
                user_id : null,
                ordr_sap_data : null,
                sold_by : null,
                customer_id : null,
                payment_method : 'cash',
                items : [],
                pull_out : [],
                purchase_request_item : [],
                delivery_notes : [],
                attachment : [],
                invoice : {
                    series : null,
                    date : "",
                    balance : 0,
                    paid : 0,
                    attachment : [],
                    payments : [],
                },
                delivery_schedule : {
                    date : "",
                    remarks : null,
                    status : 'for-delivery-schedule',
                },
                total : 0,
                more_discount : {
                    enable : false,
                    discount : 0,
                    percent : 0
                },
                credit_notes : [],
                credit_note_items : [],
                cancellation : [],
                cancellation_item : [],
                refund : [],
                refund_item : [],
                exchange : [],
                exchange_item : [],
                credit_memo : [],
                enable_push : false,
                description: "",
                credit_note : {
                    total : 0,
                    status : null,
                    credit_note_reference : []
                },
                oprq : [],
            }
        },

        formItemVar(){
            return {
                default: "",
                item_id: null,
                code: null,
                name : null,
                category : null,
                description: null,
                reference: null,
                qty: 1,
                max: 1,
                formatted_price: 0,
                price: 0,
                amount: 0,
                discount: 0,
                discount_type: null,
                custom_discount: {
                    apply : true,
                    discount : 0,
                    off_price : 0,
                    promo : 0,
                },
                total: 0,
                tbo: false,
                show_search: false,
                remarks: null,
                delivered : null,
                from_display : false
            }
        },
        /* start */
        paymentSuccess(response){
            this.setFormRecord(response.data)
            this.$emit('success')
        },
        updatePaymentSuccess(){
            const self = this;

            self.getRecordSeries({token_id : self.form.token_id, series : self.form.invoice.series}).then(() => {
                self.active = 1
            })
        },
        applyDiscount(v){
            const self = this;
            const applyDiscountType = v.form.custom_discount.apply
            const applyDiscountValue = v.form.custom_discount.discount
            const frm = v.form;
            const qty = frm.qty;
            let price = frm.price;

            if(frm.promotions.length > 0 && frm.discount_type === 'promo'){
                const itemPromo = frm.promotions[0];
                const discountValue = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);

                const discount = unformat(discountValue);
                frm.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });


                frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
                // frm.remarks = this.setRemarks(qty,itemPromo);
                frm.total = this.computeTotalAmount(qty, price, frm.discount)
            }

            if(frm.discount_type === 'discount'){
                const itemPromo = frm.promotions[0];

                const discountValue = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);

                const discount = unformat(discountValue);
                frm.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });


                // frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
                // frm.remarks = this.setRemarks(qty,frm.custom_discount);
                frm.total = this.computeTotalAmount(qty, price, frm.discount)
            }
            if(v.apply_all){
                const items = this.form.items;
                console.log(items)
                if(items.length > 0){
                    items.forEach((item, index)=>{


                        // const itemForm = JSON.parse(JSON.stringify(item));

                        const unFormatPrice = unformat(item.price);
                        let unFormatDiscount = unformat(applyDiscountValue);
                        item.custom_discount.apply = applyDiscountType
                        item.custom_discount.discount = applyDiscountValue
                        if(unFormatDiscount !== null){
                            if(parseInt(unFormatDiscount) > 0){
                                item.discount_type = 'discount'
                            }else{
                                item.discount_type = null
                            }

                            if(unFormatDiscount === ""){
                                unFormatDiscount = 0
                            }

                            if(applyDiscountType === true || applyDiscountType === 1){
                                const off = (unFormatDiscount / 100) * unFormatPrice;
                                const promo = unFormatPrice - off;

                                item.custom_discount.promo = self.formatNumber(promo)
                                item.custom_discount.off_price = self.formatNumber(off)
                            }else{

                                if(unFormatDiscount === ""){
                                    unFormatDiscount = 0;
                                }
                                const promo = unFormatPrice - unFormatDiscount;
                                item.custom_discount.promo = self.formatNumber(promo)
                                item.custom_discount.off_price = self.formatNumber(unFormatDiscount)
                            }

                        }

                        const qty = item.qty;
                        let price = item.price;

                        if(item.promotions.length > 0 && item.discount_type === 'promo'){
                            const itemPromo = item.promotions[0];
                            const discountValue = self.computeDiscount(qty,price,itemPromo,item.discount_type,item.custom_discount);

                            const discount = unformat(discountValue);
                            item.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });


                            item.discount = self.computeDiscount(qty,price,itemPromo,item.discount_type,item.custom_discount);
                            // item.remarks = self.setRemarks(qty,itemPromo);
                            item.total = self.computeTotalAmount(qty, price, item.discount)
                        }


                        const itemPromo = item.promotions[0];

                        const discountValue = self.computeDiscount(qty,price,itemPromo,item.discount_type,item.custom_discount);

                        const discount = unformat(discountValue);
                        item.discount = formatMoney(discount, { symbol: "", precision: 2, thousand: ",", decimal: "." });

                        // item.remarks = self.setRemarks(qty,item.custom_discount);
                        item.total = self.computeTotalAmount(qty, price, item.discount)


                        self.$set(self.form.items, index, item)

                    })
                }

            }else{
                this.$set(this.form.items, v.index, frm)
            }



        },
        cell({columnIndex}) {
            const self = this;
            if(self.formStatus === 'update'){
                if(columnIndex ===5){
                    return 'cell-align-center';
                }
            }

            if(self.formStatus === 'create'){
                if(columnIndex ===6){
                    return 'cell-align-center';
                }
            }

            return null;
        },
        creditNoteCell({row}) {
            const self = this;


            /*   if(row.series === self.form.invoice.sereies){
        return 'text-red'
      } */
            return 'text-red';
        },

        tableRowClassName({ row }) {
            if (row.canceled === 'yes' ) {
                return 'text-red'
            }

            if (row.method === 'cheque' && row.attr.realized == false ) {
                return 'row-background-warning'
            }
            return ''
        },


        openDiscount(index,row){
            this.setDiscountForm({index : index, form: row});
            this.$refs.discount.openDialog();
        },

        getCreditNoteSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            let totalText= 6;
            let totalAmount= 7;


            columns.forEach((_column, index) => {
                if (index === totalText) {
                    sums[index] = 'Total';
                    return;
                }

                /*    if (index === totalQty) {
            const qty = data.map(item => {
                return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
              })

              if (!qty.every(qty => isNaN(qty))) {
                  sums[index] = qty.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
              }
            return;
          }
 */
                if (index === totalAmount) {
                    const total = data.map(item => {
                        return unformat(item.total);
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);


                        this.total =  this.formatNumber(sum)
                        sums[index] = this.formatNumber(sum)

                    }


                    return;
                }



            });

            // this.toggleCheck()

            return sums;
        },
        getItemCancellationSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];

            let totalText= 6;
            let totalAmount= 7;


            columns.forEach((_column, index) => {
                if (index === totalText) {
                    sums[index] = 'Total';
                    return;
                }

                if (index === totalAmount) {
                    const total = data.map(item => {
                        return unformat(item.total);
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);


                        this.total =  this.formatNumber(sum)
                        sums[index] = this.formatNumber(sum)

                    }


                    return;
                }



            });

            return sums;
        },
        getPaymentSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];

            let totalText= 4;
            let totalAmount= 5;


            columns.forEach((_column, index) => {
                if (index === totalText) {
                    sums[index] = 'Total';
                    return;
                }

                if (index === totalAmount) {
                    const total = data.map(item => {
                        // return unformat(item.amount);

                        let amount = unformat(item.amount);

                        if(item.canceled === 'yes' || item.attr.realized ===  false){
                            amount = 0
                        }
                        return amount;
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }

                    return;
                }



            });

            return sums;
        },getPaymentsSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];


            console.log("data, columns")
            console.log(data, columns)


            columns.forEach((_column, index) => {
                if (index === 4) {
                    sums[index] = 'Total';
                    return;
                }

                if (index === 5) {

                    const total = data.map(item => {
                        let amount = parseFloat(item.amount);
                        if(item.canceled === 'yes' || (item.method === "cheque" && item.attr.realized ===  false)){
                            amount = 0
                        }
                        return amount;
                    });
                    if (!total.some(isNaN)) {
                        const sum = total.reduce((prev, curr) => prev + curr, 0);
                        sums[index] = this.$helpers.formatMoney(sum, { symbol: '', precision: 2, thousand: ',', decimal: '.' });
                    }
                    return;
                }



            });

            return sums;
        },
        getCreditNotePaymentSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];

            let totalText= 2;
            let totalAmount= 3;


            columns.forEach((_column, index) => {
                if (index === totalText) {
                    sums[index] = 'Total';
                    return;
                }

                if (index === totalAmount) {
                    const total = data.map(item => {
                        return unformat(item.amount);
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }

                    return;
                }



            });

            return sums;
        },
        getCreditNotesSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];

            let totalText= 3;
            let totalAmount= 4;


            columns.forEach((_column, index) => {
                if (index === totalText) {
                    sums[index] = 'Total';
                    return;
                }

                if (index === totalAmount) {
                    const total = data.filter((i) => i.status === 'approved',[]).map(item => {
                        return unformat(item.total);
                    },0);

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }

                    return;
                }



            });

            return sums;
        },

        roundAmount(amount) {
            let integerPart = Math.floor(amount); // Get the integer part of the number
            let fractionalPart = amount % 1; // Get the fractional part of the number

            if (fractionalPart <= 0.49) {
                fractionalPart = 0.00;
            } else if (fractionalPart >= 0.50) {
                fractionalPart = 0.50;
            }

            return integerPart + fractionalPart;
        },

        removeCommas(amountString) {
            return parseFloat(amountString.replace(/,/g, ''));
        },
        addCommas(amount) {
            // Split the amount into integer and decimal parts
            let [integerPart, decimalPart] = amount.toString().split('.');

            // Add commas to the integer part
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // Ensure the decimal part always has two digits
            decimalPart = decimalPart ? decimalPart.padEnd(2, '0') : '00';

            // Return the formatted amount with the decimal part
            return `${integerPart}.${decimalPart}`;
        },

        getSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];
            const numberColumns = [2,3,4,5,6,7,8]

            let totalCol = 3;
            let totalQty= 4;
            let totalPrice= 5;
            let totalAmount= 6;
            let totalDiscount= 7;
            let totalTotal= 8;

            if((self.formStatus === 'create')){
                totalCol = 4;
                totalQty= 5;
                totalPrice= 6;
                totalAmount= 7;
                totalDiscount= 8;
                totalTotal= 9;
            }

            columns.forEach((column, index) => {
                if (index === totalCol) {
                    sums[index] = 'Total';
                    return;
                }


                if (index === totalQty) {
                    const qty = data.map(item => {
                        return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
                    })

                    if (!qty.every(qty => isNaN(qty))) {
                        sums[index] = qty.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    }
                    return;
                }

                if (index === totalAmount) {
                    const amount = data.map(item => {
                        return parseInt(item.qty) * parseFloat(item.price);
                    });

                    if (!amount.every(amount => isNaN(amount))) {
                        const sum = amount.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }

                    return;
                }
                if (index === totalDiscount) {
                    const discount = data.map(item => {
                        let d = 0;
                        // if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                        //   const itemPromo = item.promotions[0];
                        //   d = self.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                        //   // alert(d)
                        // }else{
                        d = unformat(item.discount)
                        // }
                        return d;
                    })




                    if (!discount.every(discount => isNaN(discount))) {
                        const sum = discount.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }
                    return;
                }

                if (index === totalTotal) {
                    const total = data.map(item => {
                        let d = 0;

                        d = unformat(item.discount)
                        // if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                        //   const itemPromo = item.promotions[0];
                        //   d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                        // }
                        //
                        // if(item.discount_type === 'discount'){
                        //     const itemPromo = item.promotions[0];
                        //     d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                        //
                        //   }


                        return self.computeTotalAmountNumber(item.qty,item.price,d);
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);


                        //  this.form.total =  this.formatNumber(sum)
                        this.total =  this.formatNumber(sum)
                        sums[index] = this.formatNumber(sum)

                    }


                    return;
                }



            });

            // this.toggleCheck()
            console.log(columns,"getSummery")
            return sums;
        },
        getActiveTabIndex(index){
            this.active = index
        },

        confirmSendInvoiceToCustomer(){
            const self = this;

            if(this.formStatus !== 'update'){
                return;
            }

            const invoiceSeries = self.invoice && self.invoice.series ? self.invoice.series : null;

            if(invoiceSeries === null){
                self.$ThatsNotify.error({
                    message : 'This transaction has no invoice yet, so there is nothing to share.'
                });

                return;
            }

            const recipientName = (self.form.attr.name || '').toString().trim();
            const recipientMobile = (self.form.attr.mobile || '').toString().trim();

            /* The dialog renders as HTML so the recipient can be set apart from the
               question, which means anything coming from the record is escaped. */
            const escapeHtml = (value) => {
                return String(value === null || typeof value === 'undefined' ? '' : value)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
            };

            const confirmMessage = `Share invoice <strong>${escapeHtml(invoiceSeries)}</strong> on WhatsApp?`
                + '<br /><br />Recipient'
                + `<br /><strong>${escapeHtml(recipientName !== '' ? recipientName : 'Unnamed customer')}</strong>`
                + '<br /><br />Send to this number, or edit it to use another.';

            /* Prompt rather than confirm: the number is prefilled from the customer
               record but stays editable, so a one-off recipient needs no change to
               the invoice itself. An invoice with no number on file opens empty and
               the validator below is what insists on one. */
            MessageBox.prompt(confirmMessage, 'Share to WhatsApp', {
                confirmButtonText: 'Share',
                cancelButtonText: 'Cancel',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                inputValue: recipientMobile,
                inputPlaceholder: 'Mobile number',
                inputValidator: (value) => {
                    const entered = (value || '').toString().trim();

                    if(entered === ''){
                        return 'Enter the mobile number to share to.';
                    }

                    /* Digits, with the separators people paste from a contact list.
                       Kept loose on purpose - country formats vary and the sender
                       normalises anyway; this only catches obvious typos. */
                    if(!/^\+?[0-9(][0-9\s\-()]*$/.test(entered)){
                        return 'That does not look like a mobile number.';
                    }

                    if(entered.replace(/[^0-9]/g, '').length < 7){
                        return 'That mobile number looks too short.';
                    }

                    return true;
                }
            }).then(({ value }) => {
                /* formLoading both drives the button's disabled state and guards a
                   second send here, in case the click lands before Vue repaints -
                   the customer would otherwise get two copies of the same message. */
                if(self.formLoading === true){
                    return;
                }

                const sendToMobile = (value || '').toString().trim();

                self.formLoading = true;

                /* The endpoint takes series as an array so one call can carry several
                   invoices; this screen only ever shares the one it shows, which is
                   also what makes the mobile override valid here. It is sent every
                   time so the send goes to exactly the number just confirmed. */
                self.sendInvoiceToCustomer({
                    series : [invoiceSeries],
                    mobile : sendToMobile
                }).then((response) => {
                    self.formLoading = false;

                    self.$ThatsNotify.success({
                        message : (response && response.message) ? response.message : `Invoice was shared to ${sendToMobile} on WhatsApp.`
                    });
                }).catch((error) => {
                    self.formLoading = false;

                    const message = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Unable to share the invoice on WhatsApp.';

                    self.$ThatsNotify.error({
                        message : message,
                        timeOut : 20000
                    });
                });
            }).catch(() => {});
        },

        openPaymentWindow(){
            const paymentformVar = {
                // v.transaction.customer.customer.loyalty_number
                transaction : {
                    ...this.form,
                    customer : {
                        ...this.form.customer,
                        customer : {
                            ...this.form.customer.customer,
                            loyalty_number : this.form.attr.loyalty_number ? this.form.attr.loyalty_number : "",
                        }
                    }
                },
                payment_reference : [],

            }

            console.log("paymentformVar")
            console.log(paymentformVar)

            this.getCustomerCreditNotes(this.form)
            // this.getCustomerOverPaid(this.form)
            this.getCustomerLoyaltyMembership(this.form.attr.cx_series)

            this.setPaymentForm(paymentformVar);
            this.$refs.paymentDialogForm.openDialog()
        },


        array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        },

        move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length;
                while ((k--) + 1) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        },

        optionsHandler(){
            const self = this;

            // alert(this.formStatus)
            /*  if(this.form !== null){
        this.dispatchFilterItems({transaction_date : this.form.date})
      } */
            this.getPartner().then((response) => {
                if(response.length > 0){
                    // self.partner = response

                    self.partner = response.filter((item) => item.isDesigner == 1 || item.isShowMan == 1, []);
                    self.partnerSalesPerson = response

                }
            })
            // this.linksHandler();


        },
        destroySortable(){
            this.sortableStateStatus = false
            this.sortableState = null
        },
        initSortable(){
            const self = this;
            this.disableSortable();

            // if(this.form.items.length > 0){


            const tbody = this.$refs.itemTable.$el.querySelector(
                ".el-table__body-wrapper tbody"
            );

            self.sortableState = Sortable.create(tbody,{
                onEnd: function (evt) {
                    //   const oldIndex = evt.oldIndex;
                    //   const newIndex = evt.newIndex;
                    //   const toArrange = JSON.parse(JSON.stringify(self.form.items));
                    //  self.newArrange = self.move(toArrange,oldIndex,newIndex);

                    const oldIndex = evt.oldIndex;
                    const newIndex = evt.newIndex;
                    const toArrange = JSON.parse(JSON.stringify(self.form.items));
                    const targetRow = toArrange.splice(oldIndex, 1)[0];
                    toArrange.splice(newIndex, 0, targetRow);
                    self.newArrange = toArrange

                },
                sort : true
            });



        },
        disableSortable(){
            const self = this;
            if(Object.keys(self.sortableState).length !== 0){
                const tbody = this.$refs.itemTable.$el.querySelector(
                    ".el-table__body-wrapper tbody"
                );

                self.sortableState = Sortable.create(tbody,{
                    onEnd: function (evt) {

                        const oldIndex = evt.oldIndex;
                        const newIndex = evt.newIndex;
                        const toArrange = JSON.parse(JSON.stringify(self.form.items));
                        const targetRow = toArrange.splice(oldIndex, 1)[0];
                        toArrange.splice(newIndex, 0, targetRow);
                        self.form.items = toArrange
                    },
                    sort : true
                });
            }


        },
        enableSortable(){
            const self = this;

            /*   const tbody = document.querySelector('#itemTable .el-table__body-wrapper table.el-table__body tbody')
        self.sortableState = Sortable.create(tbody,{
          onEnd: function (evt) {


            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;

            const targetRow = self.form.items.splice(oldIndex, 1)[0];
            self.form.items.splice(newIndex, 0, targetRow);

            const toArrange = JSON.parse(JSON.stringify(self.form.items));
           self.newArrange = self.move(toArrange,oldIndex,newIndex);
          },
          sort : self.sortableStateStatus
        }); */
        },
        customLabel({label , mobile}){
            return `${label} – ${mobile}`
        },
        fnGetContacts(params){
            const self = this;
            const contacts = []
            this.GetContacts(params).then((response) => {
                if(response.length > 0){
                    response.forEach((element) => {
                        contacts.push({
                            opt : element.label + " " + element.mobile,
                            label : element.label,
                            value : element.value,
                            mobile : element.mobile,
                            address : element.address,
                        })
                    })
                }

            })

            self.customer = contacts;
        },
        async setPreparedBy(){
            var self = this;
            const loggedUser = await userData()

            const frm = this.form
            frm.sold_by = loggedUser.user.name
            this.form = frm;
        },


        deleteItem(){

            if(this.selected.length){
                if(this.formStatus === 'update'){
                    MessageBox.confirm('This will permanently delete the file. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.selected.forEach(element => {
                            var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                            this.form.items.splice(removeIndex, 1);
                        });

                        if(this.form.items.length <= 0){

                            const formItemVar = this.formItemVar();
                            this.form.items.push(formItemVar)
                        }
                    })
                }else{
                    this.selected.forEach(element => {
                        var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                        this.form.items.splice(removeIndex, 1);
                    });

                    if(this.form.items.length <= 0){
                        const formItemVar = this.formItemVar();
                        this.form.items.push(formItemVar)
                    }
                }



            }


// remove object


        },

        handleSelectionChange(v){

            this.selected = v

        },
        addNewRow(index){
            /*   */

            var dataLength = this.form.items.length - 1;

            if(dataLength === index){
                const item = this.form.items[index];
                if(item.code !== null && item.description !== null){
                    const formItemVar = this.formItemVar();
                    this.form.items.push(formItemVar)

                }
            }

        },
        getSelectedFabric(v,index,row){
            const getItem = this.fabrics.filter( e => {
                return (e.id === v);
            })[0]
            if(getItem){

                // console.log(getItem)
                const name = `${row.name}/${getItem.code}/${getItem.label}`;
                this.$set(this.form.items[index], 'default', getItem.thumb)
                this.$set(this.form.items[index], 'name', name)
            }

            this.handleOutsideClick();
        },
        statusKeyUpFocusFabric(){

            const localItems = this.fabrics;
            const filterOnFocus = [];
            if(localItems.length > 0){
                localItems.forEach(item => {
                    if(this.itemSeries.indexOf(item.code) < 0){
                        filterOnFocus.push(item)
                    }
                });

                this.fabrics = filterOnFocus
            }


        },

        getSelected(v,index){
            const getSelected = this.items.filter(item => {
                return (item.code === v)
            })[0];

            if(getSelected){

                const qty = 1;
                let price = getSelected.price;
                let discount = 0;
                let remarks = null;

                if(getSelected.promotions.length > 0){
                    const itemPromo = getSelected.promotions[0];

                    const cd = {
                        apply: true,
                        discount: 0,
                        off_price: 0,
                        promo: 0,
                    }

                    discount = this.computeDiscount(qty,price,itemPromo,'promo',cd);
                    // remarks = this.setRemarks(qty,itemPromo);
                    this.$set(this.form.items[index], 'discount_type','promo');
                }

                this.$set(this.form.items[index], 'category', getSelected.category)
                this.$set(this.form.items[index], 'item_id', getSelected.id)
                this.$set(this.form.items[index], 'name', getSelected.label)
                this.$set(this.form.items[index], 'default', getSelected.default)
                this.$set(this.form.items[index], 'qty', qty)
                this.$set(this.form.items[index], 'promotions', getSelected.promotions)
                this.$set(this.form.items[index], 'formatted_price', getSelected.formatted_price)
                this.$set(this.form.items[index], 'price', price)
                this.$set(this.form.items[index], 'amount', this.computeAmount(qty, price))
                this.$set(this.form.items[index], 'discount', discount)
                // this.$set(this.form.items[index], 'remarks', remarks)
                this.$set(this.form.items[index], 'delivered', false)
                this.$set(this.form.items[index], 'total', this.computeTotalAmount(qty, price, discount))
                // this.newArrange = this.move(this.form.items,index,index);

                var dataLength = this.form.items.length - 1;
                if(dataLength === index){
                    const formItemVar = this.formItemVar();
                    this.form.items.push(formItemVar)
                }
            }

            this.handleOutsideClick();
        },

        statusKeyUpFocus(){

            const localItems = this.items;
            const filterOnFocus = [];
            if(localItems.length > 0){
                localItems.forEach(item => {
                    if(this.itemSeries.indexOf(item.code) < 0){
                        filterOnFocus.push(item)
                    }
                });

                this.items = filterOnFocus
            }


        },

        dispatchFilterItems(params){
            const results = [];
            this.filterItems(params).then((response) =>{
                if(response.length > 0){
                    response.forEach(element => {
                        results.push({label : element.name, code : element.series,formatted_price : element.formatted_price,price : element.sale_price, id : element.mdbID,promotions : element.promotions,eta : element.eta,qty : element.qty,future : element.future_stock, default : element.default,category : element.category,  remaining : element.remaining, status : element.status})
                    });
                }
            })
            this.items = results

        },

        statusKeyUpFabric(v){
// this.getPurchaseOrder(v)

            const params = {term : v};
            const results = [];
            this.filterFabric(params).then((response) =>{
                if(response.length > 0){
                    response.forEach(element => {
                        results.push({thumb: element.thumb,label : element.name, code : element.series,formatted_price : element.formatted_price,price : element.price, id : element.id, default : element.default, description : element.description})
                    });
                }
            })
            this.fabrics = results
        },

        statusKeyUp(v){
// this.getPurchaseOrder(v)

            const params = {term : v, items : this.itemSeries,transaction_date : this.form.date};
            this.dispatchFilterItems(params)
        },
        openDialog(){
            this.loadInvoiceSettings();
            this.$refs.window.openDialog();
        },
        nextCode(){
            var self = this;
        },
        /* end */
        closeDialog(){
            this.$refs.window.closeDialog()
        },

        fnUpdateCreditNote(){
            const self = this;
            if(self.formStatus == 'update'){
                self.formLoading = true
                self.customerField = false
                self.updateCreditNote(self.form).then(() => {
                    self.$ThatsNotify.success({
                        message : "Record was successfully updated"
                    })
                    self.$emit('success')
                    self.setFormRecord(response)
                    self.formLoading = false
                    self.newArrange = []
                    self.selected = []
                    self.returnItem = false
                    self.modify = false

                    self.modifyReturmItem = false
                    self.disabled = false
                    self.customerField = false


                }).catch((error) => {
                    self.formLoading = false
                    self.modify = false
                    self.response.error = 1;
                    if (error.response) {
                        if(error.response.data.hasOwnProperty('errors')){
                            self.$refs.observer.setErrors(error.response.data.errors);
                            this.showError = true
                        }
                    } else if (error.request) {
                        self.response.message = error.request
                    } else {
                        self.response.message = error.message
                    }
                    return;
                })
            }
        },


        onSubmitForm(){
            var self =this
            this.validated = true
            const isValid = this.$refs.observer.validate();

            console.log(isValid);
            this.showError = false
            if (isValid) {
                // this.form.description = this.getText();
                if(self.formLoading === false){
                    self.formLoading = true
                    if(self.formStatus == 'create'){

                        /* if(self.newArrange.length > 0){
                          self.form.items = self.newArrange
                        } */
                        self.storeRecord(self.form).then((response) => {
                            self.$ThatsNotify.success()
                            self.$emit('success')
                            self.setFormStatusUpdate()
                            self.setFormRecord(response)
                            self.formLoading = false
                            self.SetPage(1)
                            self.newArrange = []
                        }).catch((error) => {
                            self.formLoading = false
                            self.response.error = 1;
                            if (error.response) {
                                if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                }
                            } else if (error.request) {
                                self.response.message = error.request
                            } else {
                                self.response.message = error.message
                            }
                            return;
                        })
                    }

                    if(self.formStatus == 'update'){

                        /* if(self.newArrange.length > 0){
                          self.form.items = self.newArrange
                        } */

                        if(this.form.status === 'cancel'){
                            const getAllCreditNotePayments = this.form.credit_note.credit_note_reference.filter(i => i.mode !== 'cancelled');
                            const getAllPayments = this.form.invoice.payments.filter(i => i.canceled !== 'yes');
                            const getAllCreditNotes = this.form.credit_notes.filter(i => i.status !== 'cancelled');
                            const getAllDelivery= this.form.delivery_notes.filter(i => i.status !== 'cancelled');


                            if(getAllCreditNotePayments.length > 0 || getAllPayments.length > 0 || getAllCreditNotes.length > 0 || getAllDelivery.length > 0){
                                self.formLoading = false
                                if(getAllCreditNotePayments.length > 0 || getAllCreditNotes.length > 0 || getAllDelivery.length > 0){
                                    MessageBox({
                                        message: 'The record could not be deleted because the record is associated with other document.',
                                        type: 'error'
                                    })
                                    return false;
                                }

                                if(getAllPayments.length > 0){
                                    MessageBox({
                                        message: 'The record could not be deleted. Please cancel payment first.',
                                        type: 'error'
                                    })


                                    return false;
                                }

                                return false;
                            }
                        }






                        self.modify = false
                        self.customerField = false
                        self.updateRecord(self.form).then(() => {
                            self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                            })
                            self.$emit('success')
                            self.setFormRecord(response)
                            self.formLoading = false
                            self.newArrange = []
                            self.selected = []
                            self.returnItem = false
                            self.refundItem = false
                            self.modify = false
                            self.customerField = false
                            self.cancelItem = false

                        }).catch((error) => {
                            self.formLoading = false
                            self.modify = false
                            self.cancelItem = false
                            self.response.error = 1;
                            if (error.response) {
                                if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                }
                            } else if (error.request) {
                                self.response.message = error.request
                            } else {
                                self.response.message = error.message
                            }
                            return;
                        })
                    }
                }

            }
        },

        getText() {
            let text = this.$refs.descriptionEditor.$children;
            text = text.$el.innerHTML;
            return text;
        },
        FormResetter(){
            this.form = this.formVar()
            this.setReservationConfirmationDateFromForm(this.form)
            const formItemVar = this.formItemVar()
            this.form.items.push(formItemVar)
            this.setPreparedBy()
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.validated = false
            this.formLoading = false
            this.sendLoading = false
            this.setFormStatusCreate();
            this.showError = false
            this.currentDateSetter();
            this.tabs = [
                { text: 'Sales Details', slot: 'form-slot' }
            ]
            this.disabled = false
            this.modify = false
            this.returnItem = false
            this.modifyReturmItem = false
            this.customerField = false
            this.itemCancellation = false
            this.cancelItem = false
            this.requestedCancel = false
            this.requestedExchange = false
            this.refundRequested = false
            this.refundItem = false
            this.exchangeItem = false
            this.newArrange = []

        },

        currentDateSetter(){
            var MyDate = new Date();
            var date =MyDate.getFullYear()  + '-' + ('0' + (MyDate.getMonth()+1)).slice(-2) +'-'+ ('0' + MyDate.getDate()).slice(-2);
            this.form.date = date;
        },
        currentDateValue(){
            var MyDate = new Date();
            return MyDate.getFullYear()  + '-' + ('0' + (MyDate.getMonth()+1)).slice(-2) +'-'+ ('0' + MyDate.getDate()).slice(-2);
        },
        isReservationAppliedValue(value){
            return value === true || parseInt(value, 10) === 1;
        },
        hasReservationConfirmationValue(value){
            return value !== null && value !== undefined && value !== "";
        },
        isReservationConfirmedRecord(form){
            if(!form){
                return false;
            }

            return this.isReservationAppliedValue(form.reservation) &&
                this.hasReservationConfirmationValue(form.reservation_confirmed_at) &&
                this.hasReservationConfirmationValue(form.reservation_confirmed_by);
        },
        extractDateValue(value){
            if(value === null || value === undefined || value === ''){
                return null;
            }

            return String(value).split('T')[0].split(' ')[0];
        },
        setReservationConfirmationDateFromForm(form){
            if(form && form.reservation_confirmed_at){
                this.reservationConfirmationDate = this.extractDateValue(form.reservation_confirmed_at);
                return;
            }

            if(form && this.isReservationAppliedValue(form.reservation)){
                this.reservationConfirmationDate = this.currentDateValue();
                return;
            }

            this.reservationConfirmationDate = null;
        },
        confirmReservation(){
            const self = this;

            if(!this.form || this.formStatus !== 'update'){
                MessageBox({
                    message: 'Reservation can only be confirmed after the transaction is saved.',
                    type: 'error'
                });
                return;
            }

            if(!this.reservationConfirmationAllowed){
                MessageBox({
                    message: 'You are not allowed to confirm reservation.',
                    type: 'error'
                });
                return;
            }

            if(!this.isReservationApplied){
                MessageBox({
                    message: 'Apply reservation before confirming.',
                    type: 'error'
                });
                return;
            }

            if(this.reservationAlreadyConfirmed){
                MessageBox({
                    message: 'Reservation is already confirmed.',
                    type: 'error'
                });
                return;
            }

            if(!this.reservationConfirmationDate){
                MessageBox({
                    message: 'Reservation confirmation date is required.',
                    type: 'error'
                });
                return;
            }

            MessageBox.confirm(
                `Confirm reservation using ${this.reservationConfirmationDate} and the current server time?`,
                'Confirm Reservation',
                {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            ).then(() => {
                if(self.formLoading === true){
                    return;
                }

                self.formLoading = true;
                const payload = JSON.parse(JSON.stringify(self.form));
                payload.confirm_reservation = true;
                payload.reservation_confirmation_date = self.reservationConfirmationDate;

                self.updateRecord(payload).then((response) => {
                    self.$ThatsNotify.success({
                        message : "Reservation was successfully confirmed"
                    });
                    self.$emit('success');
                    self.formLoading = false;
                    self.form.reservation_confirmed_at = response.reservation_confirmed_at;
                    self.form.reservation_confirmed_by = response.reservation_confirmed_by;
                    self.formOriginal.reservation = self.form.reservation;
                    self.formOriginal.reservation_confirmed_at = response.reservation_confirmed_at;
                    self.formOriginal.reservation_confirmed_by = response.reservation_confirmed_by;
                    self.setReservationConfirmationDateFromForm(response);
                }).catch((error) => {
                    self.formLoading = false;
                    const message = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Reservation confirmation failed.';

                    MessageBox({
                        message: message,
                        type: 'error'
                    });
                });
            }).catch(() => {});
        },
        cancelReservationConfirmation(){
            const self = this;

            if(!this.reservationConfirmationAllowed){
                MessageBox({
                    message: 'You are not allowed to cancel reservation confirmation.',
                    type: 'error'
                });
                return;
            }

            if(!this.reservationAlreadyConfirmed){
                MessageBox({
                    message: 'Reservation is not confirmed.',
                    type: 'error'
                });
                return;
            }

            MessageBox.confirm(
                'This will remove the reservation confirmation and set Apply Reservation to No. Continue?',
                'Cancel Reservation Confirmation',
                {
                    confirmButtonText: 'Cancel Confirmation',
                    cancelButtonText: 'Close',
                    type: 'warning'
                }
            ).then(() => {
                if(self.formLoading === true){
                    return;
                }

                self.formLoading = true;
                const payload = JSON.parse(JSON.stringify(self.form));
                payload.cancel_reservation_confirmation = true;
                payload.reservation = 0;

                self.updateRecord(payload).then((response) => {
                    self.$ThatsNotify.success({
                        message : "Reservation confirmation was successfully cancelled"
                    });
                    self.$emit('success');
                    self.formLoading = false;
                    self.form.reservation = 0;
                    self.form.reservation_confirmed_at = null;
                    self.form.reservation_confirmed_by = null;
                    self.formOriginal.reservation = 0;
                    self.formOriginal.reservation_confirmed_at = null;
                    self.formOriginal.reservation_confirmed_by = null;
                    self.setReservationConfirmationDateFromForm(response);
                }).catch((error) => {
                    self.formLoading = false;
                    const message = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Reservation confirmation cancellation failed.';

                    MessageBox({
                        message: message,
                        type: 'error'
                    });
                });
            }).catch(() => {});
        },
        dialogState(state){
            this.active = 0;
            this.optionsHandler();


            if(!state){
                this.FormResetter();
                // this.disableSortable()
                return
            }

            if(this.formStatus == 'create'){
                this.FormResetter();
                // this.initSortable();
                this.nextCode();
                this.tabs = [
                    { text: 'Sales Details', slot: 'form-slot' }
                ]

                this.$refs.historyWindow.closeDialog();

            }

            // alert("dialog State " + this.formStatus)

        },
        emitDelete(){
            this.$emit('delete',this.FormRecord)
        },

        computeDiscount(qty,price,promo,discount_type,custom_discount){

            if(discount_type !== null){
                let discountPrice = 0
                let apply = false;
                let discount = 0;
                if(discount_type === 'promo'){
                    apply = promo.apply
                    discount = promo.discount
                }else{
                    if(custom_discount !== null){
                        if(custom_discount.hasOwnProperty("apply")){
                            apply = custom_discount.apply;
                        }
                        if(custom_discount.hasOwnProperty("discount")){
                            discount = custom_discount.discount;
                        }
                    }


                }
                const p = parseFloat(price) * qty;

                if(apply === true || apply === 1){
                    discountPrice = parseFloat(p) * (discount / 100);
                }else{
                    discountPrice = parseFloat(discount);
                }
                return discountPrice;
            }
            return 0;
        },


        setRemarks(_qty,promo){
            if(promo.apply === true || promo.apply === 1){
                if(promo.discount > 0){
                    return `${promo.discount}% Discount`;
                }else{
                    return "";
                }
            }else{
                if(promo.discount > 0){
                    return `${this.formatNumber(promo.discount)} QAR Off`;
                }else{
                    return "";
                }
            }
        },
        computeAmount(qty,price){
            return this.formatNumber((qty * parseFloat(price)));
        },
        computeTotalAmountNumber(qty,price,discount){
            const d = parseFloat(discount);
            const amount = qty * parseFloat(price);
            const totalAmount = amount - d;
            return ((d > 0) ? totalAmount : amount);
        },
        computeTotalAmount(qty,price,discount){
            const d = unformat(discount);
            const amount = qty * unformat(price);
            const totalAmount = amount - d;
            return this.formatNumber(((d > 0) ? totalAmount : amount));
        },

        calculate(index,_event){
            const self = this;

            this.calculateTable();
            // this.newArrange = this.move(this.form.items, index, index);

            /* if(typeof self.form.items[index] !== 'undefined') {
              const item = self.form.items[index];

              let discount = 0;
              let remarks = null;

              if(item.promotions.length > 0){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                }

                if(item.discount_type === 'discount' || (item.attr.hasOwnProperty("applied_discount") && item.attr.applied_discount.type === 'loyalty-discount')){
                  const itemPromo = [];
                  let custom_discount = item.custom_discount;
                  let discount_type = item.discount_type;
                  if(item.discount_type === 'discount'){
                      custom_discount = item.attr.applied_discount;
                      discount_type = item.attr.applied_discount.type;
                  }
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,custom_discount);
                }





              if(item.code !== null && item.name !== null){
                 const amount = this.computeAmount(item.qty,item.price);
                 const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                 this.$set(self.form.items[index], 'discount', this.formatNumber(discount))
                 this.$set(self.form.items[index], 'amount', amount)
                 this.$set(self.form.items[index], 'total', totalAmount)

              }
          } */
        },


        calculateTable(){
            const self = this;

            
            // let filterBenefits = this.benefits?.filter(benefit => benefit.benefit_type === 'discount');

            // const filterBenefit = JSON.parse(JSON.stringify(filterBenefits));
            let applied_tier_discount = null;
            let benefitDiscountPercentage = 0;
            let unitDiscountPercent = 0;
            // if(filterBenefit.length > 0){
            //   applied_tier_discount = filterBenefit[0];
            //   benefitDiscountPercentage = parseFloat(filterBenefit[0].discount) / 100;
            //       const tierBenefitAdditionalDiscount = parseFloat(filterBenefit[0].additional_discount) || 0;
            //       unitDiscountPercent = tierBenefitAdditionalDiscount/100;
            // }

            const itemItems = this.form.items.map((item) => {


                let price = (item.price !== null) ? unformat(item.price) : 0;
                let qty = (item.qty !== null) ? parseInt(item.qty) : 0;
                let amount = price * qty;
                let discount = 0;
                let total = amount;
                let discount_type = item.discount_type;
                let applied_discount = { type: item.discount_type, percent: 0, price: 0, value: 0 },
                    appliedDiscountObject = { type: null, percent: 0, price: 0, value: 0 };
                let remarks = (item.remarks !== null) ? item.remarks : "";
                let benefit_type = item.benefit_type;

                const getOrginalItem = self.formOriginal.items.filter((orgItm) => {
                    return orgItm.id == item.id
                },[]);

                if(getOrginalItem.length > 0){
                    const orgLineItem = getOrginalItem[0]
                    const orgDiscount = unformat(orgLineItem.discount)

                    if(orgDiscount > 0){
                        const unitDiscount = orgDiscount / orgLineItem.qty
                        discount = unitDiscount * item.qty
                        total = (price * item.qty) - discount;

                        console.log("unitDiscount",discount)
                    }

                console.log("orgDiscount",orgDiscount)
                console.log("getOrginalItem",getOrginalItem)
                }
                

                if(item.code !== null){

/* 
                    if(item.discount_type !== null){
                        switch (item.discount_type) {
                            case 'promo':
                            case null:
                                if(item.hasOwnProperty('promotions') && item.promotions.length > 0){
                                    discount_type = 'promo';
                                    console.log("Calculating Promo")
                                    const itemPromo = item.promotions[0];
                                    price = unformat(itemPromo.price);
                                    const discountPercent = unformat(itemPromo.discount)/100;
                                    discount = (price * discountPercent) * item.qty;
                                    total = amount - discount;
                                    applied_discount.percent = unformat(itemPromo.discount)/100;
                                    applied_discount.price = itemPromo.price;
                                    applied_discount.value = itemPromo.price * discountPercent;

                                    appliedDiscountObject = {
                                        type : 'promo',
                                        percent : discountPercent,
                                        price : unformat(itemPromo.price),
                                        value : unformat((itemPromo.price * discountPercent))
                                    }
                                    remarks = itemPromo;
                                }

                                break;

                            case 'discount':

                                const itemDiscount = item.custom_discount;
                                price = unformat(item.price);
                                const discountPercent = unformat(itemDiscount.off_price)/price;
                                discount = (price * discountPercent) * item.qty;
                                total = amount - discount;
                                applied_discount.percent = discountPercent;
                                applied_discount.price = item.price;
                                applied_discount.value = item.price * discountPercent;

                                appliedDiscountObject = {
                                    type : 'discount',
                                    percent : discountPercent,
                                    price : unformat(item.price),
                                    value : unformat(itemDiscount.off_price)
                                }

                                remarks = itemDiscount;
                                // remarks = `${discountPercent} Discount`;
                                break;
                        }
                    }else{

                        console.log("item.attr.applied_discount")
                        console.log(item.attr.applied_discount)
                        if(item.attr.hasOwnProperty("applied_discount") && item.attr.applied_discount.type === 'loyalty-discount'){
                            const itemDiscount = item.attr.applied_discount;
                            price = unformat(item.price);
                            const discountPercent = itemDiscount.percent;
                            discount = (price * discountPercent) * item.qty;
                            total = amount - discount;

                            // remarks = itemDiscount;
                            // remarks = `${discountPercent} Discount`;
                        }
                    } */


                    /* const applyMultipleTierDiscount = this.form.attr.multiple_tier_discount.apply;

                if (filterBenefits.length > 0) {

                        if(item.hasOwnProperty("is_service_item") && item.is_service_item === false){

                          if(appliedDiscountObject.value > 0){


                            const itemAppliedDiscount = price - appliedDiscountObject.value

                            console.log("itemDiscountTotal",price,itemAppliedDiscount,unitDiscountPercent, item.code, applied_tier_discount)

                            if(unitDiscountPercent > 0){

                              const additionalDiscount = itemAppliedDiscount * unitDiscountPercent;
                              applied_tier_discount.apply = 'additional_discount';
                              applied_tier_discount.value = additionalDiscount;
                              const unitDiscount = (appliedDiscountObject.value + additionalDiscount);
                              discount = unitDiscount * qty;
                              total = (price * qty) - discount;
                              const benefitDiscountPercentage = discount/amount;
                              applied_discount.value = unitDiscount;
                              applied_discount.percent = benefitDiscountPercentage;

                              console.log("itemAppliedAdditionalDiscountTotal",item.code, itemAppliedDiscount, unitDiscountPercent, additionalDiscount, unitDiscount, discount, total,applied_discount)

                              remarks = `${applied_tier_discount.name}`;
                              applied_discount.type = 'loyalty-additional-discount';
                              benefit_type = 'benefit-additional-discount';
                            }

                          }else{

                            applied_discount.percent = benefitDiscountPercentage;
                            console.log("benefitDiscountPercentage",benefitDiscountPercentage)
                            let benefitDiscount = price * benefitDiscountPercentage;
                            console.log("benefitDiscount",price,benefitDiscount)
                            discount = qty * benefitDiscount;
                            console.log("discount",discount)
                            total = (price * qty) - discount;
                            remarks = `${applied_tier_discount.name}`;
                            benefit_type = 'benefit-discount';
                            applied_tier_discount.discount = benefitDiscountPercentage;
                            applied_tier_discount.additional_discount = 0;
                            console.log("itemAppliedDiscountTotal",item.code, price,benefitDiscountPercentage,benefitDiscount, discount, total)
                            applied_discount.type = 'loyalty-discount';
                            applied_discount.value = benefitDiscount;
                          }

                          applied_discount.price = price;
                        }



                } */
                }





                console.log("return",item.code,discount_type,price,discount,amount,total,remarks,applied_discount,{
                    ...item,
                    price : price,
                    discount_type,
                    benefit_type,
                    applied_discount,
                    discount : this.formatNumber(discount),
                    amount : this.formatNumber(amount),
                    total : this.formatNumber(total),
                    remarks : this.setLineRemarks(remarks),
                })
                return {
                    ...item,
                    price : price,
                    discount_type,
                    benefit_type,
                    applied_discount,
                    attr : {
                        ...item.attr
                    },
                    discount : this.formatNumber(discount),
                    amount : this.formatNumber(amount),
                    total : this.formatNumber(total),
                    remarks : this.setLineRemarks(remarks),
                }
            });

            this.form.items = itemItems;
        },
        setLineRemarks(value = null) {
            if (value!== null && typeof value === 'object' && value.apply !== undefined && value.discount !== undefined) {
                if (value.apply && value.discount > 0) {
                    return `${value.discount}% Discount`;
                } else {
                    return value.discount > 0 ? `${this.formatNumber(value.discount)} QAR Off` : "";
                }
            } else {
                return value;
            }
        },
        calculateCreditNote(index){
            const self = this;

            if(typeof self.form.credit_note_items[index] !== 'undefined') {
                const item = self.form.credit_note_items[index];

                let discount = 0;
                let remarks = null;

                if(item.promotions.length > 0){
                    const itemPromo = item.promotions[0];
                    discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                    // remarks = this.setRemarks(item.qty,itemPromo)
                }

                if(item.discount_type === 'discount'){
                    const itemPromo = item.promotions[0];
                    discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                    // remarks = this.setRemarks(item.qty,item.custom_discount);
                    // frm.total = this.computeTotalAmount(qty, price, frm.discount)
                }


                if(item.code !== null && item.name !== null){
                    const amount = this.computeAmount(item.qty,item.price);
                    const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                    //  this.$set(self.form.credit_note_items[index], 'remarks',remarks)
                    this.$set(self.form.credit_note_items[index], 'discount', this.formatNumber(discount))
                    this.$set(self.form.credit_note_items[index], 'amount', amount)
                    this.$set(self.form.credit_note_items[index], 'total', totalAmount)
                }
            }
        },

        formatNumber(n) {
            return parseFloat(n).toFixed(2).replace(/./g, function(c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            });
        },
        fnPrint(url){



            let session = JSON.parse(localStorage.getItem('user'));
            let token = session.token;

            const locationId = session.location.id

            var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";
            const win = window.open(`${url}?location=${locationId}&token=${token}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()

        },
        fnPrintDoc(url){


            var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";
            const win = window.open(`https://docs.thatsliving.com/${url}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()

        },


        toggleCheck(){
            const self = this;
            if(this.form.transaction.items.length > 0){
                const getCode = this.form.items.map(i => i.code);

                if(getCode.length > 0){
                    self.$nextTick(() => {
                        self.form.transaction.items.forEach((item,_index) => {
                            if(getCode.includes(item.code)){
                                self.$refs.itemsTable.toggleRowSelection(item,true);
                                // alert(index)
                            }
                        })

                    })



                }else{
                    self.$refs.itemsTable.clearSelection();
                }

            }
        },

        getRowKey(row){
            return row.code
        },
        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ["mobile", "label"],
                shouldSort: true
            });
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list;
        },

        searchCustomer(v){
            const self = this;
            if(v !== ""){
                this.fnGetContacts({term : v})
            }
        },
        getCustomerSelected(v){
            const selectedCustomer = this.customer.filter(c => {
                return c.value === v;
            })[0];

            if(selectedCustomer !== null){
                this.form.attr.name = selectedCustomer.label
                this.form.attr.mobile = selectedCustomer.mobile
                this.form.attr.address = selectedCustomer.address
            }

        },

        openCustomer(){
            this.$refs.contactForm.openDialog();
        },
        contactSuccess(v){
            const contact = { label: v.name, value: v.mdbID, mobile: v.mobile, address : v.address }
            this.customer.unshift(contact);
            this.form.customer_id = v.mdbID
            this.form.mobile = v.mobile
            this.form.attr.name = v.name;
            this.form.attr.mobile = v.mobile;
            this.form.attr.address = v.address;

            // alert(v.name)
        },

        openPayment(paymentRow){

            const paymentFromData = {...paymentRow,invoice : {
                    series : this.invoice.series,
                    balance : this.invoice.balance,
                    paid : this.invoice.paid,
                    total : this.invoice.total
                },
                customer : this.form.attr.name }
            this.setPaymentStatusUpdate()
            this.setFormData(paymentFromData)
            this.$refs.updatePaymentFormVerTwo.openDialog();
        },
        openUpdatePaymentWindow(){
            this.paymentFormStatus = 'create'
            const pForm = {...this.paymentForm,invoice_series : this.form.seires, customer : this.form.attr.name + " "+ this.form.attr.mobile}
            // this.paymentForm.invoice_series = this.form.series
            this.paymentForm = pForm
            this.$refs.updatePaymentForm.openDialog();
        },
        addMoreDiscount(){

        },
        sendRequest(){
            if (this.request) this.cancelRequest();
            this.makeRequest()
        },
        cancelRequest(){
            this.request.cancel();
            this.clearOldRequest("Cancelled");
        },

        makeRequest(){
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
            axios
                .get("/api/user/filter", { cancelToken: axiosSource.token })
                .then(() => {
                    this.clearOldRequest("Success");
                })
                .catch(this.logResponseErrors);
        },
        logResponseErrors(err) {
            if (axios.isCancel(err)) {
                // console.log("Request cancelled");
            }
        },
        clearOldRequest(msg) {
            this.request.msg = msg;
            this.requests.push(this.request);
            this.request = null;
        },


        paymentPushToSap(obj){
            const self = this;


            const {document} = obj.attr;

            if(typeof document === 'undefined' || (document?.entry === null || document?.entry === '')){
                MessageBox.confirm(`Payment ${obj.series} will be push to SAP. Are you sure want to continue?`, 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    obj.loading = true


                    self.integrate({endpoint : 'payments',series : obj.series, index : 0}).then((response) => {
                        self.$ThatsNotify.success({
                            message : response.message
                        });
                        obj.loading = false
                    }).catch((error) => {
                        self.$ThatsNotify.warning({
                            message : error.response.data.message
                        });
                        obj.loading = false
                    });


                    /*  self.sapPaymentIntegration({series : obj.series}).then(function(response){
                          self.$ThatsNotify.success({
                            message : `${response.message}`
                        });
                        obj.loading = false
                  }).catch((error) => {

                    self.formLoading = false
                    self.modify = false
                    self.response.error = 1;
                    obj.loading = false

                    if(error.response.status === 500){
                          self.$ThatsNotify.error({
                          message : error.message,
                          timeOut: 20000
                        })
                    }
                    if(error.response.status === 422){
                      if(error.response.data.hasOwnProperty('message')){
                          self.$ThatsNotify.error({
                          message : error.response.data.message,
                          timeOut: 20000
                        })
                      }
                    }
                    if (error.response) {
                        if(error.response.data.hasOwnProperty('errors')){

                          if(error.response.status === 400){
                               self.$ThatsNotify.error({
                                message : `Unable to push to sap. Please contact System Administrator. <br /><strong>Details</strong> : ${error.response.data.errors.value}`,
                                timeOut: 20000
                              })
                          }
                          self.$refs.observer.setErrors(error.response.data.errors);
                          this.showError = true
                        }



                      } else if (error.request) {
                          self.response.message = error.request
                      } else {
                          self.response.message = error.message
                      }
                      return;
                  }) */
                })
            }


        },
        deliveryNotePushToSap(obj){
            const self = this;


            const {document} = obj.attr;

            if(typeof document === 'undefined' || (document?.entry === null || document?.entry === '')){
                MessageBox.confirm(`Delivery Note ${obj.series} will be push to SAP. Are you sure want to continue?`, 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    obj.loading = true
                    self.sapDeliveryNoteIntegration({series : obj.series}).then(function(response){
                        self.$ThatsNotify.success({
                            message : `${response.message}`
                        });
                        obj.loading = false
                    }).catch((error) => {

                        self.formLoading = false
                        self.modify = false
                        self.response.error = 1;
                        obj.loading = false

                        if(error.response.status === 500){
                            self.$ThatsNotify.error({
                                message : error.message,
                                timeOut: 20000
                            })
                        }
                        if(error.response.status === 422){
                            if(error.response.data.hasOwnProperty('message')){
                                self.$ThatsNotify.error({
                                    message : error.response.data.message,
                                    timeOut: 20000
                                })
                            }
                        }
                        if (error.response) {
                            if(error.response.data.hasOwnProperty('errors')){

                                if(error.response.status === 400){
                                    self.$ThatsNotify.error({
                                        message : `Unable to push to sap. Please contact System Administrator. <br /><strong>Details</strong> : ${error.response.data.errors.value}`,
                                        timeOut: 20000
                                    })
                                }
                                self.$refs.observer.setErrors(error.response.data.errors);
                                this.showError = true
                            }



                        } else if (error.request) {
                            self.response.message = error.request
                        } else {
                            self.response.message = error.message
                        }
                        return;
                    })
                })
            }


        },
        creditNotePushToSap(obj){
            const self = this;


            const {document} = obj.attr;

            if(typeof document === 'undefined' || (document?.entry === null || document?.entry === '')){
                MessageBox.confirm(`Credit Note ${obj.series} will be push to SAP. Are you sure want to continue?`, 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    obj.loading = true
                    self.sapCreditNoteIntegration({series : obj.series}).then(function(response){
                        self.$ThatsNotify.success({
                            message : `${response.message}`
                        });
                        obj.loading = false
                    }).catch((error) => {

                        self.formLoading = false
                        self.modify = false
                        self.response.error = 1;
                        obj.loading = false

                        if(error.response.status === 500){
                            self.$ThatsNotify.error({
                                message : error.message,
                                timeOut: 20000
                            })
                        }

                        if(error.response.status === 422){
                            if(error.response.data.hasOwnProperty('message')){
                                self.$ThatsNotify.error({
                                    message : error.response.data.message,
                                    timeOut: 20000
                                })
                            }
                        }

                        if (error.response) {
                            if(error.response.data.hasOwnProperty('errors')){

                                if(error.response.status === 400){
                                    self.$ThatsNotify.error({
                                        message : `Unable to push to sap. Please contact System Administrator. <br /><strong>Details</strong> : ${error.response.data.errors.value}`,
                                        timeOut: 20000
                                    })
                                }
                                self.$refs.observer.setErrors(error.response.data.errors);
                                this.showError = true
                            }



                        } else if (error.request) {
                            self.response.message = error.request
                        } else {
                            self.response.message = error.message
                        }
                        return;
                    })
                })
            }


        },

        syncInvoice(){
            const self = this;
            if(self.syncInvoiceLoading){
                return;
            }

            const series = self.invoice && self.invoice.series ? self.invoice.series : null;
            if(!series){
                self.$ThatsNotify.error({message : 'No invoice series found.'});
                return;
            }
            if(!self.allowSyncInvoice){
                self.$ThatsNotify.warning({message : 'Sales order already exists in QATL Production.'});
                return;
            }

            self.syncInvoiceLoading = true;
            self.integrate({
                endpoint : 'sync-sales-orders',
                series : series,
                index : 0,
                connection : 'QATL_PRODUCTION',
                delivery_date : '2030-12-31'
            }).then((response) => {
                const message = response && response.message ? response.message : 'Sync completed.';
                self.$ThatsNotify.success({
                    message : message
                });
                self.getRecordSeries({series : series});
            }).catch((error) => {
                const message = error?.response?.data?.message || error?.message || 'Sync failed.';
                self.$ThatsNotify.warning({
                    message : message
                });
            }).finally(() => {
                self.syncInvoiceLoading = false;
            });
        },

        pushToSap(){
            // this.modify = true
            // this.disabled = false
            // this.returnItem = false
            // if(this.form.items.length === 0){
            //   const formItemVar = this.formItemVar();
            //     this.form.items.push(formItemVar)
            // }
            // this.initSortable();

            const self = this;


            if(this.formStatus === 'update'){


                const {document} = this.formOriginal.attr;


                if(document.entry === null || document.entry === ''){
                    MessageBox.confirm('This will push to SAP. Are you sure want to continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        self.pushInvoiceToSapLoading = true


                        self.integrate({endpoint : 'invoices',series : self.form.invoice.series, index : 0}).then((response) => {
                            self.$ThatsNotify.success({
                                message : response.message
                            });
                            self.pushInvoiceToSapLoading = false
                        }).catch((error) => {
                            self.$ThatsNotify.warning({
                                message : error.response.data.message
                            });
                            self.pushInvoiceToSapLoading = false
                        });

                        /* self.sapIntegration({...self.form.invoice}).then(function(response){
                          self.$ThatsNotify.success({
                            message : response.message
                        });

                        self.pushInvoiceToSapLoading = false
                  }).catch((error) => {
                        self.$ThatsNotify.warning({
                            message : error.response.data.message
                        });
                        self.pushInvoiceToSapLoading = false
                  }) */
                    })
                }


            }

        },
        enableModify(){
            this.modify = true
            this.disabled = false
            this.returnItem = false
            if(this.form.items.length === 0){
                const formItemVar = this.formItemVar();
                this.form.items.push(formItemVar)
            }
            // this.initSortable();
        },
        enableExchange(){
            this.modifyReturmItem = false
            this.modify = false
            this.disabled = false
            this.returnItem = false
            this.exchangeItem = true
        },
        enableModifyCreditNote(){
            this.modifyReturmItem = true
            this.modify = false
            this.disabled = false
            this.returnItem = false
            this.exchangeItem = false
        },

        openLink(_target) {
            // console.log(target);
        },
        copyLink(target) {
            console.log(target);
        },

        rowContectMenu(row,_col,e){
            const self = this

            if((row.code !== null && this.formStatus === 'create') || (this.formStatus === 'update' && row.code !== null && (this.modify === true || this.form.invoice.series === null))){
                this.context = row
                this.viewMenu = true;
                this.$nextTick(function() {
                    self.$refs.right.focus();
                    self.setMenu(e.y, e.x)
                }.bind(this));
                e.preventDefault();
            }
        },

        setMenu: function(top, left) {

            const largestHeight = window.innerHeight - this.$refs.right.offsetHeight - 75;
            const largestWidth = window.innerWidth - this.$refs.right.offsetWidth - 75;

            if (top > largestHeight) top = largestHeight;

            if (left > largestWidth) left = largestWidth;

            this.top = top + 'px';
            this.left = left + 'px';
        },

        closeMenu: function() {
            this.viewMenu = false;
            this.context = null
        },

        deleteRow(){
            const self = this
            if(this.context != null){

                if(self.context.hasOwnProperty('id')){
                    const matchItem = this.form.items.filter((i) => {
                        return i.id != self.context.id;
                    })
                    self.form.items = matchItem
                }
                if(self.context.hasOwnProperty('item_id')){
                    const matchItem = this.form.items.filter((i) => {
                        return i.item_id != self.context.item_id;
                    })
                    self.form.items = matchItem
                }

                this.closeMenu()
            }

        },
        moveUpRow(){
            const self = this
            if(this.context != null){
                const index = this.form.items.findIndex(e => e.code == self.context.code);

                if (index > 0) {
                    const el = this.form.items[index];
                    this.$set(this.form.items, index, this.form.items[index - 1]);

                    this.$set(this.form.items, index - 1, el);
                    this.closeMenu()
                }
            }
        },
        moveDownRow(){
            const self = this
            if(this.context != null){
                const index = this.form.items.findIndex(e => e.code == self.context.code);

                if (index !== -1 && index < self.form.items.length - 2) {
                    const el = self.form.items[index];
                    this.$set(self.form.items, index, self.form.items[index + 1]);
                    this.$set(self.form.items, index + 1, el);
                    this.closeMenu()
                }

            }
        },

        cancelModification(){

            const self = this;
            self.modifyReturmItem = false
            self.exchangeItem = false
            self.returnItem = false
            self.cancelItem = false
            self.refundItem = false
            self.modify = false
            self.disabled = true
            self.requestedExchange = false
            self.refundRequested = false
            self.selected = []
            // self.getRecord({token_id : self.form.token_id})

            

            self.$nextTick(() => {
                const newTblKey = self.tblKey + 1;
                self.setTblKey(newTblKey)
                const frmOriginal = JSON.parse(JSON.stringify(self.formOriginal));
                self.setFormRecord(frmOriginal)
            })

        },

        insertRow(){
            const self = this
            if(this.context != null){
                if(self.context.hasOwnProperty('id')){
                    const index = this.form.items.findIndex(e => e.id == self.context.id);
                    const formItemVar = this.formItemVar();
                    this.form.items.splice((index + 1), 0, formItemVar);
                }
                if(self.context.hasOwnProperty('item_id')){
                    const index = this.form.items.findIndex(e => e.item_id == self.context.item_id);
                    const formItemVar = this.formItemVar();
                    this.form.items.splice((index + 1), 0, formItemVar);
                }
                this.closeMenu()
            }


        },

        returnItems(){
            const creditNoteItems = this.form.credit_note_items || [];
            const items = this.form.items;
            items.forEach((row, index) => {
                const returns = creditNoteItems.filter(i => i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')) || [];
                console.log(returns,"returns")
                const returnQty =  returns.map(i => i.qty).reduce((a, b) => a + b, 0);
                console.log(returnQty,"returnQty")
                const newQty = row.qty - returnQty;
                console.log(newQty,"newQty")
                this.$set(this.form.items,index,{...row, qty : newQty, max : newQty});
            })

            this.$nextTick(() => {
                this.calculateTable();
                const lastTblKey = this.tblKey + 1;
                this.setTblKey(lastTblKey)
                this.returnItem = true;
            })
        },
        cancelItems(){
            const self = this;
            this.form.items.forEach((row, index) => {

                const getAllCancelItems = [];

                let itemDeductQty = 0;

                if(self.form.credit_note_items.length > 0){
                    const returnItemsQty = self.form.credit_note_items.filter((i) => {
                        return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                    });

                    if(returnItemsQty.length > 0){
                        const totalReturnItem = returnItemsQty.map((i) => i.qty).reduce((a,b) => a + b);

                        console.log(`${totalReturnItem} - total return`)

                        itemDeductQty += totalReturnItem
                    }


                }


                self.form.cancellation.forEach((item) => {
                    if(item.items.length > 0){
                        item.items.forEach((innerItem) => {
                            getAllCancelItems.push(innerItem);
                        });
                    }
                });

                const cancelledItems = getAllCancelItems.filter((i) => {
                    return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                });

                if(cancelledItems.length > 0){
                    const totalCancelItem = cancelledItems.map((i) => i.qty).reduce((a,b) => a + b);
                    console.log(`${totalCancelItem} - total cancel`)
                    itemDeductQty += totalCancelItem
                }

                const changeQty = parseInt(row.qty) - itemDeductQty


                self.$set(self.form.items,index,{...row, qty : changeQty, max : changeQty});

                self.calculatePrice(index)
                const lastTblKey = self.tblKey + 1;
                self.setTblKey(lastTblKey)
            })

            this.cancelItem = true;
        },
        exchangeItems(){
            const self = this;
            this.form.items.forEach((row, index) => {

                const exchangeItemsArray = [];

                let itemDeductQty = 0;

                if(self.form.credit_note_items.length > 0){
                    const returnItemsQty = self.form.credit_note_items.filter((i) => {
                        return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                    });

                    if(returnItemsQty.length > 0){
                        const totalReturnItem = returnItemsQty.map((i) => i.qty).reduce((a,b) => a + b);
                        itemDeductQty += totalReturnItem
                    }


                }

                if(self.form.exchange.length > 0){
                    self.form.exchange.forEach((item) => {
                        if(item.items.length > 0){
                            item.items.forEach((innerItem) => {
                                exchangeItemsArray.push(innerItem);
                            });
                        }
                    });


                    const matchExchangeItem = exchangeItemsArray.filter((i) => {
                        return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                    });


                    if(matchExchangeItem.length > 0){
                        const totalCancelItem = matchExchangeItem.map((i) => i.qty).reduce((a,b) => a + b);
                        itemDeductQty += totalCancelItem
                    }
                }


                const changeQty = parseInt(row.qty) - itemDeductQty
                console.log({...row, qty : changeQty, max : changeQty, remarks : ""})
                self.$set(self.form.items,index,{...row, qty : changeQty, max : changeQty, remarks : ""});

                self.calculatePrice(index)
                const lastTblKey = self.tblKey + 1;
                self.setTblKey(lastTblKey)
            })
            this.requestedExchange = true;
            this.exchangeItem = true;
        },

        refundItems(){
            const self = this;
            this.form.items.forEach((row, index) => {

                const refundItemsArray = [];

                let itemDeductQty = 0;

                if(self.form.hasOwnProperty('refund_item') && self.form.refund_item.length > 0){
                    const returnItemsQty = self.form.refund_item.filter((i) => {
                        return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                    });

                    if(returnItemsQty.length > 0){
                        const totalReturnItem = returnItemsQty.map((i) => i.qty).reduce((a,b) => a + b);
                        itemDeductQty += totalReturnItem
                    }


                }

                if(self.form.hasOwnProperty('refund_item') &&  self.form.refund.length > 0){
                    self.form.refund.forEach((item) => {
                        if(item.items.length > 0){
                            item.items.forEach((innerItem) => {
                                refundItemsArray.push(innerItem);
                            });
                        }
                    });


                    const matchRefundItem = refundItemsArray.filter((i) => {
                        return  i.transaction_item_id === row.id && (i.status === 'for-approval' || i.status ==='approved')
                    });


                    if(matchRefundItem.length > 0){
                        const totalRefundItem = matchRefundItem.map((i) => i.qty).reduce((a,b) => a + b);
                        itemDeductQty += totalRefundItem
                    }
                }


                const changeQty = parseInt(row.qty) - itemDeductQty
                self.$set(self.form.items,index,{...row, qty : (changeQty < 0 ? 0: changeQty), max : changeQty});

                self.calculatePrice(index)
                const lastTblKey = self.tblKey + 1;
                self.setTblKey(lastTblKey)
            })
            this.refundRequested = true;
            this.refundItem = true;
        },
        cancelReturnItems(){
            this.returnItem = false;
            this.selected = [];
        },
        requestCreditNote(){
            const self = this;

            this.validated = true
            const isValid = this.$refs.observer.validate();

            console.log(isValid);
            this.showError = false
            if (isValid) {
                this.$refs.confirmCreditNoteForm.openDialog();
            }


            //
            /*
          self.dialogFormVisible = true;
          const params = {
            status : this.form.status,
            attr : this.form.attr,
            transaction_id : this.form.mdbID,
            items : this.selected,
            action : 'exchange'
          }

          self.formLoading = true
          this.storeCreditNote(params).then((response) => {

              self.$ThatsNotify.success({
                                message : response.message
                              })
              self.$emit('success')
              self.setFormRecord(response.data)
              self.formLoading = false
              self.newArrange = []
              self.selected = []
              self.returnItem = false
              self.modify = false
          }) */
        },
        canSelectRow(row, _index){
            const self = this;
            if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && (this.returnItem === true || this.cancelItem === true || this.exchangeItem === true || this.refundItem === true)){

                if(this.returnItem === true){


                    const transactionItemQty = self.form.credit_note_items.filter((itm) =>{
                        return itm.transaction_item_id == row.id && itm.status !== 'cancelled';
                    }).map(i => i.qty)

                    let  totalTransactionItemQty = 0

                    if(transactionItemQty.length > 0){
                        totalTransactionItemQty = transactionItemQty.reduce((a,b) => a + b);
                    }

                    const rowQuantity = parseInt(row.quantity)

                    console.log("totalTransactionItemQty",totalTransactionItemQty);
                    console.log("rowQuantity",rowQuantity);

                    const allowedReturnQty = rowQuantity - totalTransactionItemQty;
                    console.log("allowedReturnQty",allowedReturnQty);

                    if(totalTransactionItemQty >= rowQuantity){
                        return false
                    }
                    return true
                }

                /*  if(this.cancelItem === true){

                      if(row.qty <= 0){
                        return false
                      }
                  return true;
              }
              if(this.exchangeItem === true){
                      if(row.qty <= 0){
                        return false
                      }
                  return true;
              }
              if(this.refundItem === true){
                      if(row.qty <= 0){
                        return false
                      }
                  return true;
              } */
                return false;
            }else{
                return true
            }
        },
        enableRow(row){

            if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returnItem === true){
                const creditNotes = this.form.credit_note_items.map(i => i.code);
                if(creditNotes.includes(row.code)){
                    return false
                }else{
                    return true
                }
            }else{
                return true
            }
        },

        enableModifyAndCreditNote(row){
            if(this.disabled === false ||
                ((this.invoice.series !== null && (this.enableReturn.includes(this.form.status) && (['full-payment','partial-payment','cancelled'].includes(this.form.attr.payment_status)))) &&

                    (this.cancelItem === true || this.returnItem === true || this.modify === true))){
                // return false

                if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returnItem === true){
                    const creditNotes = this.form.credit_note_items.map(i => i.code);
                    if(creditNotes.includes(row.code)){
                        return false
                    }

                }

                return false

            }
            return true
        },

        enableQuantity(row){
            // console.log(row)
            if(this.disabled === false ||
                (this.invoice.series !== null &&
                    ((this.enableReturn.includes(this.form.status) || this.cancelItemEnable.includes(this.form.status) || this.refundItemEnable.includes(this.form.status)) &&
                        (['full-payment','partial-payment','cancelled'].includes(this.form.attr.payment_status)) &&
                        (this.cancelItem === true || this.returnItem === true || this.modify === true || this.refundItem === true)
                    ))){


                return false;
            }


            /* if(this.disabled === false ||
            ((this.invoice.series !== null && (this.enableReturn.includes(this.form.status) && (['full-payment','partial-payment','cancelled'].includes(this.form.attr.payment_status)))) &&

            (this.cancelItem === true || this.returnItem === true || this.modify === true))){
              // return false

              if(this.formStatus === 'update' && (this.form.invoice !== null && this.form.invoice.series !== null) && this.modify === false && this.returnItem === true){
                  const creditNotes = this.form.credit_note_items.map(i => i.code);
                  if(creditNotes.includes(row.code)){
                    return false
                  }

               }

              return false

          } */
            return true
        },

        handleCheckAllChange(val) {
            var self = this;
            this.isIndeterminate = false;
            this.form.items.forEach((row,index) => {
                self.$set(self.form.items,index, {...row,tbo : val});
            })


        },
        handleCheckedTboChange(_value) {
            const self = this;
            const checked = this.form.items.filter(row => {
                return row.tbo === true
            }).map(e => e.tbo).length;

            const isIndeterminate = checked > 0 && checked < this.form.items.length;

            const checkAllTbo = checked === this.form.items.length

            this.$nextTick(() => {
                self.isIndeterminate = isIndeterminate
                self.checkAllTbo = checkAllTbo
            });

        },
        handleCheckAllChangeDelivered(val) {
            var self = this;
            this.isIndeterminateDelivered = false;
            this.form.items.forEach((row,index) => {
                self.$set(self.form.items,index, {...row,delivered : val});
            })


        },
        handleCheckedTboChangeDelivered(_value) {
            const self = this;
            const checked = this.form.items.filter(row => {
                return row.delivered === true
            }).map(e => e.delivered).length;

            const isIndeterminate = checked > 0 && checked < this.form.items.length;

            const checkAll = checked === this.form.items.length

            this.$nextTick(() => {
                self.isIndeterminateDelivered = isIndeterminate
                self.checkAllDelivered = checkAll
            });

        },

        renderHeader(h,{column}){
            return h(
                'div',
                [
                    h('span', column.label),
                    h('el-checkbox',{
                        style:'display:inline-flex;margin-left:5px;',
                        on:{
                            Change: ($event, column) => this.select($event, column), // check the event $event, column, where $event=true, column is the input dom when printing in select
                        }
                    }),
                ],
            )
        },

        select(obj, $event = this.targetEv){
            console.log(obj)
            console.log($event)
        },


        enablePrice(row){

            if( this.$helpers.isSystemAdministrator() && this.modify == true){
                return true
            }else{
                const cat = [137, 136, 126, 83, 127, 129, 132, 130, 135, 128,142, 143,95,133, 87];

                if((this.$helpers.isDeliveryTeam() || this.$helpers.isInteriorDesigner() || this.$helpers.isSalesExecutive() || this.$helpers.isSystemAdministrator()) && row.category !== null && cat.includes(row.category) && this.modify === true){
                    return true;
                }
                return false
            }
        },

        quantityChangeOnReturn(v){
            if(this.returnItem === true || this.cancelItem === true){
                const qty = parseInt(v.qty);
                if(qty > v.max){
                    v.qty = v.max;
                }
                if(qty < 1){
                    v.qty = 1;
                }
            }
        },
        quantityChange(v){
            const code = v.code;
            const qty = parseInt(v.qty);
            if(qty > v.max){
                v.qty = v.max;
            }
            if(qty < 1){
                v.qty = 1;
            }
        },

        handleOutsideClick(){
            const self = this;
            if(this.form.items.length > 0){
                this.form.items.forEach((_item,index) => {
                    self.$set(self.form.items[index], 'show_search', false);
                })
            }
        },

        clickShowSearch(row,index){
            if(this.modify === true && (row.category === 95 || row.category === 132 || row.category === 127)){

                this.$set(this.form.items[index], 'show_search', true);
            }
        },

        calculatePrice(index){
            const self = this
            const item = self.form.items[index];

            this.$set(self.form.items[index], 'price',unformat(item.formatted_price))

            if(typeof self.form.items[index] !== 'undefined') {
                const item = self.form.items[index];

                let discount = 0;
                let remarks = null;

                if(item.promotions.length > 0){
                    const itemPromo = item.promotions[0];
                    discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                    // remarks = this.setRemarks(item.qty,itemPromo)
                }

                if(item.discount_type === 'discount'){
                    const itemPromo = item.promotions[0];
                    discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                    // remarks = this.setRemarks(item.qty,item.custom_discount);
                }


                if(item.code !== null && item.name !== null){
                    const amount = this.computeAmount(item.qty,item.price);
                    const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                    //  this.$set(self.form.items[index], 'remarks',remarks)
                    this.$set(self.form.items[index], 'discount', this.formatNumber(discount))
                    this.$set(self.form.items[index], 'amount', amount)
                    this.$set(self.form.items[index], 'total', totalAmount)

                }
            }


        },

        removeFormat(index){
            const self = this;
            const item = self.form.items[index];
            let amount = 0
            if (item.price !== 0) {
                amount = formatMoney(item.price, {
                    symbol: '',
                    format: '%v',
                    thousand: '',
                    decimal: '.',
                    precision: 2
                })
            }

            this.$set(self.form.items[index], 'formatted_price',amount)
        },
        formatOnBlur(index){
            const self = this;
            const item = self.form.items[index];

            let amount = 0
            if (item.formatted_price !== 0) {
                amount = formatMoney(item.formatted_price, {
                    symbol: '',
                    format: '%v',
                    thousand: ',',
                    decimal: '.',
                    precision: 2
                })
            }

            this.$set(self.form.items[index], 'formatted_price',amount)
            this.$set(self.form.items[index], 'price',unformat(amount))

        },

        closeFabric(index){
            this.$set(this.form.items[index],'show_search',false);
        },

        enablePullOut(){
            this.pullout = true;
            this.modify = false;
            this.modifyReturmItem = false
            this.returnItem = false
        },
        requestPullOut(){
            const self = this;

            const frm = {
                transaction_id : this.form.mdbID,
                description : "",
                attr : this.form.attr,
                pullout : this.creditNoteSelection
            }
            self.formLoading = true
            this.storePullOut(frm).then((response) => {
                self.$ThatsNotify.success({
                    message : response.message
                })
                self.pullout = false;
                self.$emit('success')
                // self.setFormRecord(response.data)
                self.formLoading = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.modify = false
                self.pullout = false
            })

            /*  self.formLoading = true
          this.storeCreditNote(params).then((response) => {

              self.$ThatsNotify.success({
                                message : response.message
                              })
              self.$emit('success')
              self.setFormRecord(response.data)
              self.formLoading = false
              self.newArrange = []
              self.selected = []
              self.returnItem = false
              self.modify = false
          }) */
        },

        handleCreditNoteSelectionChange(v){
            // console.log(v)

            this.creditNoteSelection = v
        },


        openPullOut(v){

            const pullOutData = {items:[],transactions: {series : null,invoice: { series : null},...v}}
            const frmOriginal = JSON.parse(JSON.stringify(pullOutData));
            this.setPullOutStatusUpdate()
            this.setPullOutFormRecord(frmOriginal)
            this.getPullOutRecord({token_id : v.token_id});
            this.$refs.pullOutForm.openDialog()
        },

        getPurchaseRequestSummaries(param) {
            const self = this;
            const { columns, data } = param;
            const sums = [];
            // const numberColumns = [2,3,4,5,6,7,8]

            let totalCol = 2;
            let totalQty= 3;
            // let totalPrice= 4;
            let totalAmount= 5;
            // let totalDiscount= 6;
            let totalTotal= 7;

            columns.forEach((_column, index) => {
                if (index === totalCol) {
                    sums[index] = 'Total';
                    return;
                }


                if (index === totalQty) {
                    const qty = data.map(item => {
                        return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
                    })

                    if (!qty.every(qty => isNaN(qty))) {
                        sums[index] = qty.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    }
                    return;
                }

                if (index === totalAmount) {
                    const amount = data.map(item => {
                        return parseInt(item.qty) * parseFloat(item.price);
                    });

                    if (!amount.every(amount => isNaN(amount))) {
                        const sum = amount.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = this.formatNumber(sum)

                    }

                    return;
                }


                if (index === totalTotal) {
                    const total = data.map(item => {
                        let d = 0;


                        if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                            const itemPromo = item.promotions[0];
                            d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                        }

                        if(item.discount_type === 'discount'){
                            const itemPromo = item.promotions[0];
                            d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);

                        }


                        return self.computeTotalAmountNumber(item.qty,item.price,d);;
                    });

                    if (!total.every(total => isNaN(total))) {
                        const sum = total.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);


                        //  this.form.total =  this.formatNumber(sum)
                        this.total =  this.formatNumber(sum)
                        sums[index] = this.formatNumber(sum)

                    }


                    return;
                }



            });

            // this.toggleCheck()

            return sums;
        },

        editCustomer(){
            // this.customerField = true
            const self = this;
            const {address,mobile, name,email} = this.form.attr

            const em = (typeof email === 'undefined') ? "" : email
            const addr = (typeof address === 'undefined') ? "" : address

            if(this.form.customer_id !== null){
                this.setFormContactStatusUpdate()
                this.getContact({mdbID : this.form.customer_id,mobile : mobile,address : addr, name : name, email : email}).then((response) => {
                    // self.setFormRecordUpdate(response)

                    const contactFormUpdate = {
                        row : response
                    }
                    self.setFormRecordUpdate(contactFormUpdate)
                });
                this.$refs.contactForm.openDialog()
            }else{
                const contacts = {
                    series : 0,
                    name : name,
                    mobile : mobile,
                    email : em,
                    reference : '',
                    description : null,
                    image : [],
                    attr : {
                        address : addr,
                        email : em,
                        origin : 'portal',
                    },
                    status : 'active'
                }

                this.storeContactRecord(contacts).then((response) => {

                    const v = response.data;

                    self.form.customer_id = v.mdbID
                    self.form.mobile = v.mobile
                    self.form.attr.name = v.name;
                    self.form.attr.mobile = v.mobile;
                    self.form.attr.address = v.address;
                    self.form.attr.cx_series = v.series;

                    self.setFormContactStatusUpdate()
                    self.setFormRecordUpdate(response.data)
                    self.$refs.contactsFormUpdate.openDialog()
                })
            }


        },


        contactUpdateSuccess(v){
            // console.log(v)/

            // const {address, mobile, name, email, series} = v
            // this.form.attr = {...this.form.attr, address : address, mobile : mobile, name : name, email : email, cx_series : series}

            const {mobile, name} = v
            const {address, email, address2} = v.attr
            this.form.attr = {...this.form.attr, address : address,address2 : address2, mobile : mobile, name : name, email : email}
            let ndx = null
            const con = this.customer.filter((e,index) => {
                ndx = index
                return e.value === v.mdbID
            })[0];

            const finalContact = {
                opt : name + " "+ mobile,
                label :name,
                value : con.value,
                mobile : mobile,
                address : address,
            }



            if(ndx !== null){


                this.$set(this.customer,ndx,finalContact)
                let add = ""
                add += (v.attr.address != "" && v.attr.address !== null) ? v.attr.address  : "";

                add += (v.attr.address2.street != "" && v.attr.address2.street !== null) ? ","+v.attr.address2.street  : "";
                add += (v.attr.address2.building!= "" && v.attr.address2.building!== null) ? ","+v.attr.address2.building : "";
                add += (v.attr.address2.zone != "" && v.attr.address2.zone !== null) ? ","+v.attr.address2.zone  : "";
                add += (v.attr.address2.area != "" && v.attr.address2.area !== null) ? "/"+v.attr.address2.area  : "";
                add += (v.attr.address2.city != "" && v.attr.address2.city !== null && typeof v.attr.address2.city !== 'undefined') ? "/"+v.attr.address2.city  : "";

                this.displayAddress = add.trim();

            }
        },

        computeDiscountForLoop(form){
            const self = this;

            const itemForm = form
            const {custom_discount, price} = itemForm;
            const {discount, apply} = custom_discount;
            const unFormatPrice = unformat(price);
            let unFormatDiscount = unformat(discount);

            if(unFormatDiscount !== null){



                if(parseInt(unFormatDiscount) > 0){
                    itemForm.discount_type = 'discount'
                }else{
                    itemForm.discount_type = null
                }

                if(unFormatDiscount === ""){
                    unFormatDiscount = 0
                }


                if(apply === true || apply === 1){
                    const off = (unFormatDiscount / 100) * unFormatPrice;
                    const promo = unFormatPrice - off;

                    itemForm.custom_discount.promo = self.formatNumber(promo)
                    itemForm.custom_discount.off_price = self.formatNumber(off)
                }else{

                    if(unFormatDiscount === ""){
                        unFormatDiscount = 0;
                    }
                    const promo = unFormatPrice - unFormatDiscount;
                    itemForm.custom_discount.promo = self.formatNumber(promo)
                    itemForm.custom_discount.off_price = self.formatNumber(unFormatDiscount)
                }


            }
            return itemForm;
        },
        openNewItem(){
            this.setItemFormStatusCreate()

            if(this.checkSystemSupport){
                this.$refs.itemForm.openDialog()
            }else{
                this.$refs.promptPasswordForm.openDialog()
            }
        },

        isAuthorized(value){
            if(value){
                this.$refs.itemForm.openDialog()
            }
        },

        requestItemCancellation(){
            const self = this;
            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                items : this.selected,
            }

            self.formLoading = true
            this.storeItemCancellation(params).then((response) => {

                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success')
                self.setFormRecord(response.data)
                self.formLoading = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.modify = false
                self.cancelItem = false
            })
        },
        /* ITEM CANCEL */
        requestCancelItem(){
            const self = this;
            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                items : this.selected,
            }

            self.cancelItemLoading = true
            self.requestedCancel = true
            self.requestedExchange = true
            this.storeItemCancellation(params).then((response) => {
                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success')
                self.setFormRecord(response.data)
                self.requestedExchange = false
                self.cancelItemLoading = false
                self.requestedCancel = false
                self.cancelItem = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.modify = false
            }).catch((error) => {
                console.log(error)
            })
        },
        requestExchangeItem(){
            const self = this;
            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                items : this.selected,
            }

            // self.exchangeItemLoading = true

            this.setItemToExchange(this.selected);
            this.$refs.exchangeForm.openDialog();
            // this.storeItemExchange(params).then((response) => {
            //     self.$ThatsNotify.success({
            //                       message : response.message
            //                     })
            //     self.$emit('success')
            //     self.setFormRecord(response.data)
            //     self.exchangeItemLoading = false
            //     self.cancelItem = false
            //     self.newArrange = []
            //     self.selected = []
            //     self.returnItem = false
            //     self.modify = false
            // }).catch((error) => {
            //     console.log(error)
            // })
        },

        requestExchange(){
            const self = this;
            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                token_id : this.form.invoice.token_id,
                exchange : this.selected,
            }
            self.exchangeItemLoading = true
            this.storeItemExchange(params).then((response) => {
                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success')
                // self.setFormRecord(response.data)
                self.exchangeItemLoading = false
                self.requestedExchange = false
                self.cancelItem = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.exchangeItem = false
                self.modify = false
            }).catch((error) => {
                console.log(error)
            })
            this.$refs.exchangeForm.closeDialog();
        },
        requestRefund(){
            const self = this;
            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                token_id : this.form.invoice.token_id,
                items : this.selected,
            }
            self.refundItemLoading = true
            this.storeRefund(params).then((response) => {
                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success')
                self.refundItemLoading = false
                self.refundRequested = false
                self.refundItem = false
                self.cancelItem = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.exchangeItem = false
                self.modify = false
            }).catch((error) => {
                console.log(error)
            })
        },

        viewExchange(series,row,index,view){
            const self = this;

            this.setViewForm({...this.form,index : index,exchange_row : row})
            this.getExchangeRecord({series : series}).then((response) => {

                if(response.reference_transaction !== null){
                    self.exchangeForm(response.reference_transaction.transaction);
                }
                self.setItemToExchange(response.items);
                self.setItemToReplace(response.replace);
            })

            if(view){
                self.$refs.exchangeViewForm.openDialog();

            }else{
                self.$refs.exchangeForm.openDialog();
            }
        },

        requestExchangeReplacement(v){
            // console.log(v)

            const self = this;
            // const params = {
            //   status : this.form.status,
            //   attr : this.form.attr,
            //   transaction_id : this.form.mdbID,
            //   token_id : this.form.invoice.token_id,
            //   replace : v,
            // }
            self.exchangeItemLoading = true
            this.storeItemReplacement(v).then((response) => {
                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success')
                // self.setFormRecord(response.data)
                self.exchangeItemLoading = false
                self.requestedExchange = false
                self.cancelItem = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.exchangeItem = false
                self.modify = false
                self.$refs.exchangeForm.closeDialog();
            }).catch((error) => {
                console.log(error)
            })
        },

        unformatBalance(value){
            return unformat(value)
        },

        orderStatusSelectable(v){


            // (v) => v.seperator !== true
            const {settings, user} = JSON.parse(localStorage.getItem('user'));

            const canSetCollected =
                (user.role_slugs || []).includes('administrator') ||
                [2, 18].includes(Number(user.id));

            if (v.code === 'collected' && !canSetCollected) {
                return false;
            }

            const useRole = user.role_slugs[0];
            if(settings.userDisallowInvoiceCancel.includes(useRole) && v.code  === 'cancel' && v.seperator === false){
                return false
            }

            // console.log(v)

            return v.seperator !== true;
        },

        openHistory(){
            // console.log(this.form)
            this.setModule('sales-transaction')
            this.setRecordId(this.form.mdbID)
            this.$refs.historyWindow.openDialog()
        },

        openReferenceInvoice(v){
            this.$emit('open-window',v);
        },
        enableReason(row){
            // console.log(row)
            if(this.disabled === false ||
                (this.invoice.series !== null && ['full-payment','partial-payment','cancelled'].includes(this.form.attr.payment_status) && (this.cancelItem === true || this.returnItem === true || this.modify === true || this.exchangeItem === true || this.refundItem === true))
            ){
                return false;
            }
            return true
        },

        confirmCreditNote(v){
            // alert(v)
            const self = this;

            const params = {
                status : this.form.status,
                attr : this.form.attr,
                transaction_id : this.form.mdbID,
                items : this.selected,
                action : v
            }

            self.formLoading = true
            this.storeCreditNote(params).then((response) => {

                self.$ThatsNotify.success({
                    message : response.message
                })
                self.$emit('success',"Successfully created")
                self.$emit('open-window',response)
                self.$refs.confirmCreditNoteForm.closeDialog();
                // self.setFormRecord(response.data)
                const lastTblKey = self.tblKey + 1;
                self.setTblKey(lastTblKey)

                // self.closeDialog();

                self.formLoading = false
                self.newArrange = []
                self.selected = []
                self.returnItem = false
                self.modify = false


            })
        },

        checkIfRowSelected(transactionItemId){
            const hasSelected = this.selected.filter((i) => i.id === transactionItemId).length

            return (hasSelected > 0) ? true : false
        },
        removeDiscountFormat(){
            this.form.more_discount.discount = this.$helpers.unformat(this.form.more_discount.discount )
        },
        formatOnBlurMoreDiscount(){
            this.form.more_discount.discount = this.$helpers.formatMoney(this.form.more_discount.discount)
        },
        invoiceDiscountPercent(){
            const percent = parseFloat(this.form.more_discount.percent) / 100;

            const totalItems = this.form.items.map((i) => unformat(i.total),[]).reduce((a,b) => a + b, 0)
            const total  = totalItems * percent;
            if(total > 0){
                this.form.more_discount.discount = this.$helpers.formatMoney(total)
            }else{
                this.form.more_discount.discount = 0;
            }
        },

        invoiceDiscount(){
            const discount = this.$helpers.unformat(this.form.more_discount.discount)
            const totalItems = this.form.items.map((i) => unformat(i.total),[]).reduce((a,b) => a + b, 0)
            const percent = discount / totalItems * 100
            if(discount > 0){

                if(Number.isInteger(percent)){
                    this.form.more_discount.percent = percent
                }else{
                    this.form.more_discount.percent = formatMoney(percent, {
                        symbol: '',
                        format: '%v',
                        thousand: '',
                        decimal: '.',
                        precision: 6
                    })
                }

            }else{
                this.form.more_discount.percent = 0;
            }
        },

        openAddressForm(){
            this.$refs.addressForm.openDialog();
        },

        updateAddress(v){
            console.log("update Address")
            console.log(v)


            let add = ""
            add += (v.attr.address != "" && v.attr.address !== null) ? v.attr.address  : "";

            add += (v.attr.address2.street != "" && v.attr.address2.street !== null) ? ","+v.attr.address2.street  : "";
            add += (v.attr.address2.building!= "" && v.attr.address2.building!== null) ? ","+v.attr.address2.building : "";
            add += (v.attr.address2.zone != "" && v.attr.address2.zone !== null) ? ","+v.attr.address2.zone  : "";
            add += (v.attr.address2.area != "" && v.attr.address2.area !== null) ? "/"+v.attr.address2.area  : "";
            add += (v.attr.address2.city != "" && v.attr.address2.city !== null) ? "/"+v.attr.address2.city  : "";



            this.displayAddress = add.trim();

        },

        requestDelivery(){
            this.requestDeliveryDialog = true

            // this.sendDeliveryRequest();
        },

        getText() {
            let [,text] = this.$refs.descriptionEditor.$children;
            text = text.$el.innerHTML;
            return text;
        },

        clearText() {
            let [,text] = this.$refs.descriptionEditor.$children;
            text.$el.innerHTML = "";
        },
        setDescription(v) {
            let [,text] = this.$refs.descriptionEditor.$children;
            text.$el.innerHTML = v;
        },

        sendDeliveryRequestForm(){
            const self = this;
            const getMessage = this.getText();
            this.requestDeliveryForm.message = getMessage
            this.requestDeliveryForm.invoice = this.form.invoice.series
            this.requestDeliveryForm.id = this.form.mdbID
            if(this.requestDeliveryLoading == false){
                this.requestDeliveryLoading = true
                this.sendDeliveryRequest(this.requestDeliveryForm).then((res) => {
                    self.requestDeliveryLoading = false
                    self.requestDeliveryDialog = false
                    self.$ThatsNotify.success({
                        message : "Request successfully sent."
                    })
                }).catch((error) => {
                    self.$ThatsNotify.warning({
                        message : error.response.data.message
                    })
                })
            }
        },

        handleCheckAllFromDisplayChange(val) {
            var self = this;
            this.isIndeterminateFromDisplay = false;
            this.form.items.forEach((row,index) => {
                self.$set(self.form.items,index, {...row,from_display : val});
            })


        },
        handleCheckedFromDisplayChange(value) {
            const self = this;
            const checked = this.form.items.filter(row => {
                return row.from_display === true
            }).map(e => e.from_display).length;

            const isIndeterminate = checked > 0 && checked < this.form.items.length;

            const checkAllFromDisplay = checked === this.form.items.length

            this.$nextTick(() => {
                self.isIndeterminateFromDisplay = isIndeterminate
                self.checkAllFromDisplay = checkAllFromDisplay
            });

            /* this.sele
        console.log((checked > 0 && checked < this.form.items.length)) */
        },

        issueVoucher(){
            const validAmount = this.form.payments.filter((i) => {
                return ['cash','credit-card','wire-transfer','cheque','tap'].includes(i.method) && ['no'].includes(i.canceled)
            },[]).map((i) => {
                return unformat(i.amount)
            },[]).reduce((a,b) => a + b, 0);

            const voucher = (this.form.attr.hasOwnProperty('voucher')) ? this.form.attr.voucher : null;

            this.setIssueVoucherFormData({
                customer : {
                    customer_id : this.form.customer_id,
                    name : this.form.attr.name,
                    mobile : this.form.attr.mobile,
                    cx_series : this.form.attr.cx_series
                },
                document : {
                    series : this.form.invoice.series,
                    total : this.form.total,
                    valid_amount : validAmount,
                    attr : this.form.attr,
                    id : this.form.mdbID,

                },
            })

            this.$refs.issueVoucherDialogForm.openDialog();

        },
        issueVoucherSuccess(v){
            console.log("IssueVoucher")
            console.log(v)
            console.log("v.data.document_attr")
            console.log(v.data.document_attr)

            if(v.hasOwnProperty('document_attr')){
                this.form.attr = {...this.form.attr,...v.document_attr}

                console.log(this.form.attr)
                this.$forceUpdate();
            }
        },
        pushPurchaseRequest(){
           MessageBox.confirm('Are you sure you want to create purchase request?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.oprqLoading = true;
                this.formLoading = true;
                this.createPurchaseRequest({series : this.form.invoice.series}).then((res) => {

                    this.oprqLoading = false
                    this.formLoading = false

                    this.form.oprq.push(res)
                    this.$ThatsNotify.success({
                        message : "Purchase Request successfully created."
                    })
                    console.log("createPurchaseRequest",res)
                }).catch((err) => {

                    console.log(err)
                    this.oprqLoading = false
                    this.formLoading = false


                    if (err.response && err.response.data) {
                        const { error, message } = err.response.data;
                        
                        if (error === 1) {

                            this.$ThatsNotify.error({
                                message : message
                            })
                        } else {
                            this.$ThatsNotify.error({
                                message : message
                            })
                        }
                    } else {
                        console.error('Unexpected error:', err);
                        this.$ThatsNotify.error({
                                message : 'An unexpected error occurred.'
                            })
                    }
                })
            })

        },
        createOnlinePaymentLink(){
            if(!this.canGenerateOnlinePaymentLink){
                MessageBox.alert('A pending online payment link already exists. Cancel it before generating a new link.', 'Warning', { type: 'warning' });
                return;
            }

            this.paymentLinkDialogForm = {...this.form, total : this.form.invoice.remaining, link : null}
            this.$refs.paymentLinkDialogForm.openDialog();
        },

        isPendingOnlinePayment(link){
            const status = link && link.status ? String(link.status).toLowerCase().replace(/[\s-]+/g, '_') : '';
            return ['pending', 'in_progress', 'initiated', 'unpaid'].includes(status);
        },

        isCancelledOnlinePayment(link){
            const status = link && link.status ? String(link.status).toLowerCase().replace(/[\s-]+/g, '_') : '';
            return ['cancelled', 'canceled', 'cancel', 'failed', 'expired'].includes(status);
        },

        openOnlinePaymentLink(link = null){

            const self = this;
            const paymentLink = link && link.invoice_id ? link : this.primaryOnlinePaymentLink;

            if(!paymentLink || !paymentLink.invoice_id || this.isCancelledOnlinePayment(paymentLink)){
                return;
            }

            this.getStatus(paymentLink).then((response) => {
                self.paymentLinkDialogForm = {
                    total : self.form.invoice.remaining,
                    attr : {
                        ...self.form.attr
                    },
                    link : response
                }
            });
            this.$refs.paymentLinkDialogForm.openDialog();
            
        },  
        async makePayment(v){
            const self = this;

            const paymentMeans = {
                origin : 'online',
                series : 0,
                date : "",
                mode : "full-payment",
                method : "tap",
                attr : {
                    cheque_details : null,
                    payment_reference : v.reference,
                    discount_remarks : null,
                    realized : false,
                    loyalty_card_number : null
                },
                description : null,
                amount : unformat(v.amount),
                reference : v.reference,
            }

     
                const paymentformVar = {
                    transaction : this.form,
                    payment_reference : [],

                }

            self.getCustomerCreditNotes(self.form)
            self.getCustomerLoyaltyMembership(self.form.attr.cx_series)
            self.setPaymentForm(paymentformVar);

            

            if(v.reference && this.form.invoice.remaining > 0){
                this.$refs.paymentDialogForm.openPaymentDialogWithData({
                    method : 'tap',
                    amount : unformat(v.amount),
                    reference : v.reference,
                });
                this.openPaymentWindow();
            }

            this.$refs.paymentLinkDialogForm.closeDialog();
        },
            linkCreated(){
                const self = this;
                const activeTab = this.active;
                const invoiceSeries = self.form.invoice && self.form.invoice.series
                    ? self.form.invoice.series
                    : self.form.series;

                this.$refs.paymentLinkDialogForm.closeDialog();
                this.getRecordSeries({token_id: self.form.token_id, series: invoiceSeries}).then(() => {
                    self.$nextTick(() => {
                        self.active = activeTab;
                    });
                });
            },

            cancelOnlinePaymentLinkFromDialog(link){
                this.cancelOnlinePaymentLink(link, true);
            },

            cancelOnlinePaymentLink(link, closeDialog = false){
                if(!link || !link.invoice_id){
                    return;
                }

                const self = this;
                const activeTab = this.active;

                MessageBox.confirm('Cancel this pending online payment link?', 'Warning', {
                    confirmButtonText: 'Cancel Payment Link',
                    cancelButtonText: 'Keep Pending',
                    type: 'warning'
                }).then(() => {
                    const invoiceSeries = self.form.invoice && self.form.invoice.series
                        ? self.form.invoice.series
                        : self.form.series;

                    this.cancelLink({ invoice_id: link.invoice_id }).then(() => {
                        return self.getRecordSeries({token_id: self.form.token_id, series: invoiceSeries}).then(() => {
                            self.$nextTick(() => {
                                self.active = activeTab;
                            });
                            self.$ThatsNotify.success({message: 'Online payment link cancelled'});
                            if(closeDialog){
                                self.$refs.paymentLinkDialogForm.closeDialog();
                            }
                        });
                    }).catch((error) => {
                        const message = error && error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'Unable to cancel online payment link';
                        MessageBox.alert(message, 'Warning', { type: 'warning' });
                    });
                }).catch(() => {});
            },

            async openForOnlinePaymentWindow(obj = {}){


                const self = this;
                const paymentformVar = {
                    transaction : this.form,
                    payment_reference : [],

                }

                self.getCustomerCreditNotes(self.form)
                self.getCustomerLoyaltyMembership(self.form.attr.cx_series)
               

                self.setPaymentForm(paymentformVar);


                if(this.applyMultiplePayment){


                    if(self.form.hasOwnProperty("link") && self.form.link !== null && self.form.link.hasOwnProperty("invoice_id") && self.form.link.invoice_id !== null){

                        await self.getStatus(self.form.link).then((response) => {
                            const newFormData = {
                                ...self.form,
                                link : response
                            }

                            const items = self.form.items.filter((item) => {
                                return item.code !== null
                            },[])
                            newFormData.items = items
                            self.setFormRecord(JSON.parse(JSON.stringify(newFormData)))
                            self.$forceUpdate()
                        });
                        const {link} = self.form;
                        console.log(link,"link")
                        if(link){

                            if (link.attr.hasOwnProperty('InvoiceTransactions') && link.attr.InvoiceTransactions.length) {
                                const obj = {
                                    origin : 'online',
                                    series : 0,
                                    date : "",
                                    mode : "full-payment",
                                    method : "tap",
                                    attr : {
                                        cheque_details : null,
                                        payment_reference : link.attr.InvoiceTransactions[0].AuthorizationId,
                                        discount_remarks : null,
                                        realized : false,
                                        loyalty_card_number : null
                                    },
                                    description : null,
                                    amount : unformat(link.attr.InvoiceTransactions[0].TransationValue),
                                    reference : link.attr.InvoiceTransactions[0].AuthorizationId,
                                }

                                if(link.status === 'paid'){
                                    await self.$refs.multiplePaymentDialogForm.addInitialPayment(obj)
                                }
                            }
                        }
                    }

                    await self.$refs.multiplePaymentDialogForm.openDialog()

                }else{
                    await self.$refs.paymentDialogForm.openDialog()
                }
        },

        /* DELIVERY PICKING */

        delivery_areAllDescendantsSelected(parentRow) {
            const descendants = this.delivery_getDescendants(parentRow);
            if (!descendants.length) return true;

            const selectedKeys = new Set((this.delivery_selectedRows || []).map(r => r.__rowKey));
            return descendants.every(r => selectedKeys.has(r.__rowKey));
        },

        delivery_syncParentSelectionUp(row) {
            let p = row.__parent;
            while (p) {
                const allSelected = this.delivery_areAllDescendantsSelected(p);

                if (!allSelected) {
                this.$refs.sapTable.toggleRowSelection(p, false);
                } else if (this.delivery_isRowValid(p)) {
                this.$refs.sapTable.toggleRowSelection(p, true);
                }

                p = p.__parent;
            }
        },

        delivery_hasUnselectedDescendant(parentRow) {
            if (!parentRow || !parentRow.children || !parentRow.children.length) return false;

            const selectedKeys = new Set((this.delivery_selectedRows || []).map(r => r.__rowKey));
            const descendants = this.delivery_getDescendants(parentRow);

            return descendants.some(r => !selectedKeys.has(r.__rowKey));
            },

        delivery_enforceParentAllOrNothing() {
            if (!this.$refs.sapTable) return;

            const selectedKeys = new Set((this.delivery_selectedRows || []).map(r => r.__rowKey));

            const walk = (rows) => {
                (rows || []).forEach(r => {
                if (r.children && r.children.length) {
                    const parentSelected = selectedKeys.has(r.__rowKey);

                    if (parentSelected && this.delivery_hasUnselectedDescendant(r)) {
                    this.__selecting = true;
                    this.$refs.sapTable.toggleRowSelection(r, false);
                    this.__selecting = false;
                    }

                    walk(r.children);
                }
                });
            };

            walk(this.tableData);
            },

        getItemImageByRefId(refId, itemCode = "") {
            const sourceItems = Array.isArray(this.form && this.form.items) ? this.form.items : [];
            const normalizedRef = refId != null ? String(refId).trim() : "";

            if (normalizedRef !== "") {
                const matchById = sourceItems.find((item) => {
                    const itemId = item && item.id != null ? String(item.id).trim() : "";
                    return itemId !== "" && itemId === normalizedRef;
                });

                if (matchById && matchById.default) {
                    return matchById.default;
                }
            }

            const normalizedCode = itemCode != null ? String(itemCode).trim() : "";
            if (normalizedCode !== "") {
                const matchByCode = sourceItems.find((item) => {
                    const code = item && item.code != null ? String(item.code).trim() : "";
                    return code !== "" && code === normalizedCode;
                });

                if (matchByCode && matchByCode.default) {
                    return matchByCode.default;
                }
            }

            return "";
        },

        delivery_normalizeLines(lines, parent = null) {
            return (lines || []).map((line) => {
                const row = { ...line };
                const rowRef = row.U_RefItemId != null && String(row.U_RefItemId).trim() !== ""
                    ? String(row.U_RefItemId).trim()
                    : (parent && parent.__itemRefId != null ? String(parent.__itemRefId).trim() : "");

                row.__rowKey = `${row.DocEntry}-${row.LineNum}`;
                row.__itemRefId = rowRef;
                row.default = this.getItemImageByRefId(rowRef, row.ItemCode || row.SO_ItemCode || row.DN_ItemCode || "");

                Object.defineProperty(row, "__parent", {
                value: parent,
                enumerable: false,
                writable: true,
                });

                row.__maxQty = this.delivery_toNumber(
                row.OpenQty != null ? row.OpenQty : row.Quantity
                );
                if (Number.isNaN(row.__maxQty)) row.__maxQty = null;

                row.__issueQty = row.__maxQty != null ? row.__maxQty : 0;

                // ✅ BOM scaling for component rows
                if (parent) {
                const factorRaw = this.delivery_toNumber(row.BOMReqQty);
                const factor = factorRaw > 0 ? factorRaw : 1;

                const parentMax =
                    parent.__maxQty != null ? this.delivery_toNumber(parent.__maxQty) : null;

                if (parentMax != null) {
                    row.__maxQty = parentMax * factor;
                }

                row.__issueQty = this.delivery_toNumber(parent.__issueQty) * factor;
                if (row.__maxQty != null) {
                    row.__issueQty = Math.min(row.__issueQty, this.delivery_toNumber(row.__maxQty));
                }
                }

                row.__warehouses = this.delivery_buildWarehouses(row);
                row.__whs = this.delivery_defaultWarehouse(row);

                const wh = row.__warehouses.find((w) => w.WhsCode === row.__whs) || null;
                row.__available = wh ? this.delivery_toNumber(wh.Available) : 0;

                row.__batchOptions = wh && wh.BatchNumbers ? wh.BatchNumbers : [];
                row.__anyBatches = row.__warehouses.some(
                (w) => (w.BatchNumbers || []).length > 0
                );

                row.__batchAlloc = this.delivery_initBatchAllocMap(row.__batchOptions);

                if (Array.isArray(row.components) && row.components.length) {
                row.children = this.delivery_normalizeLines(row.components, row);
                this.delivery_syncChildrenQtyByBom(row);

                // Parent line warehouses come from components (warehouse only).
                row.__warehouses = this.delivery_buildParentWarehouses(row);

                // Keep parent selected warehouse if still valid; otherwise default to first available.
                if (!row.__warehouses.some((w) => w.WhsCode === row.__whs)) {
                    row.__whs = row.__warehouses.length ? (row.__warehouses[0].WhsCode || "") : "";
                }

                // Parent lines are not batch-allocated; components handle stock/batches.
                row.__available = 0;
                row.__batchOptions = [];
                row.__anyBatches = false;
                row.__batchAlloc = {};

                // Push parent warehouse down to components to keep all allocations in one warehouse.
                this.delivery_onWhsChange(row, false);
                }

                return row;
            });
        },

        delivery_isLineClosed(row) {
            const status = String(row && row.LineStatus != null ? row.LineStatus : "").toUpperCase();
            return status === "C" || status === "BOST_CLOSE";
        },
        delivery_buildParentWarehouses(parentRow) {
            const children = (parentRow && parentRow.children ? parentRow.children : []).filter((ch) => {
                if (!ch) return false;
                if (this.delivery_isLineClosed(ch)) return false;
                return this.delivery_toNumber(ch.__issueQty) > 0;
            });

            if (!children.length) {
                return [
                {
                    WhsPrefix: "",
                    WhsCode: "",
                    WhsName: "",
                    Available: 0,
                    BatchNumbers: [],
                },
                ];
            }

            // Keep only warehouses that exist on ALL deliverable children.
            let common = null;

            children.forEach((ch) => {
                const codes = new Set(
                (ch.__warehouses || [])
                    .map((w) => (w && w.WhsCode ? w.WhsCode : ""))
                    .filter((c) => !!c)
                );

                if (common == null) {
                common = codes;
                } else {
                common = new Set([...common].filter((c) => codes.has(c)));
                }
            });

            const codesList = common ? Array.from(common) : [];

            if (!codesList.length) {
                return [
                {
                    WhsPrefix: "",
                    WhsCode: "",
                    WhsName: "",
                    Available: 0,
                    BatchNumbers: [],
                },
                ];
            }

            // Optional: show a meaningful "parent available" based on BOM factors.
            const list = codesList
                .map((code) => {
                let parentAvail = null;

                children.forEach((ch) => {
                    const wh =
                    (ch.__warehouses || []).find((w) => w && w.WhsCode === code) || null;

                    const baseAvail = wh ? this.delivery_toNumber(wh.Available) : 0;

                    const factorRaw = this.delivery_toNumber(ch.BOMReqQty);
                    const factor = factorRaw > 0 ? factorRaw : 1;

                    const possible = factor > 0 ? baseAvail / factor : 0;

                    if (parentAvail == null) parentAvail = possible;
                    else parentAvail = Math.min(parentAvail, possible);
                });

                if (parentAvail == null) parentAvail = 0;

                return {
                    WhsCode: code,
                    WhsPrefix: "",
                    WhsName: "",
                    Available: parentAvail,
                    BatchNumbers: [],
                };
                })
                .filter((w) => w && w.WhsCode);

            list.sort(
                (a, b) =>
                this.delivery_toNumber(b.Available) - this.delivery_toNumber(a.Available)
            );

            return list.length
                ? list
                : [
                    {
                    WhsPrefix: "",
                    WhsCode: "",
                    WhsName: "",
                    Available: 0,
                    BatchNumbers: [],
                    },
                ];
        },

            delivery_buildWarehouses(line) {
            const ws = Array.isArray(line.WarehouseStocks) ? line.WarehouseStocks : [];
            const lineBatchNumbers = Array.isArray(line.BatchNumbers) ? line.BatchNumbers : [];

            console.log("delivery_buildWarehouses", ws)
            const ws2 = ws
                .filter((w) => w && w.WhsCode && w.WhsCode !== "WH-01")
                .map((w) => ({ ...w, __availNum: this.delivery_toNumber(w.Available != null ? w.Available : w.OnHand) }))
                .filter((w) => w.__availNum > 0);

            if (ws2.length) {
                return ws2.map((w) => ({
                ...w,
                WhsCode: w.WhsCode,
                WhsName: "",
                Available: w.__availNum != null ? w.__availNum : this.delivery_toNumber(w.Available != null ? w.Available : w.OnHand),
                BatchNumbers: (() => {
                    const warehouseBatches = Array.isArray(w.BatchNumbers) ? w.BatchNumbers : [];
                    if (warehouseBatches.length > 0) return warehouseBatches;
                    if (w.WhsCode === line.WhsCode && lineBatchNumbers.length > 0) return lineBatchNumbers;
                    return [];
                })(),
                }));
            }

            if (line.WhsCode && line.WhsCode !== "WH-01") {
                const baseAvail = this.delivery_toNumber(line.Available);
                if (baseAvail > 0) {
                return [
                    {
                    WhsPrefix: line.WhsPrefix,
                    WhsCode: line.WhsCode,
                    WhsName: line.WhsName || "",
                    Available: baseAvail,
                    BatchNumbers: lineBatchNumbers,
                    },
                ];
                }
            }

            return [
                {
                WhsPrefix: "",
                WhsCode: "",
                WhsName: "",
                Available: 0,
                BatchNumbers: [],
                },
            ];
            },

            delivery_defaultWarehouse(line) {
            const list = Array.isArray(line.__warehouses)
                ? line.__warehouses
                : this.delivery_buildWarehouses(line);
            if (!list.length) return "";

            const target = this.delivery_toNumber(line.AvailableSelectedWhs);
            const match = list.find((w) => this.delivery_toNumber(w.Available) === target);

            return match && match.WhsCode ? match.WhsCode : list[0].WhsCode || "";
            },

            delivery_warehouseLabel(w) {
            if (!w || !w.WhsCode) return "N/A";

            console.log("delivery_warehouseLabel",w)
            const name =  w.WhsPrefix && w.WhsPrefix.trim()
                ? `${w.WhsPrefix}-${w.WhsCode}`
                : `${w.WhsCode}`;
            return `${name} (Avail: ${this.delivery_toNumber(w.Available)})`;
            },

            delivery_canAllocate(row) {
            if (!row) return false;
            const qty = this.delivery_toNumber(row.__issueQty);
            const avail = this.delivery_toNumber(row.__available);
            const opts = row.__batchOptions || [];
            return !!row.__whs && qty > 0 && avail > 0 && opts.length > 0;
            },

           delivery_isRowValid(row) {
                if (!row) return false;

                const status = String(row.LineStatus || '').toUpperCase();
                if (status === 'C' || status === 'BOST_CLOSE') return false;

                const qty = this.delivery_toNumber(row.__issueQty);
                if (qty <= 0) return false;

                // BOM parent lines are validated by their deliverable component lines.
                if (row.children && row.children.length) {
                    const activeChildren = row.children.filter((ch) => {
                    const st = String(ch.LineStatus || '').toUpperCase();
                    if (st === 'C' || st === 'BOST_CLOSE') return false;
                    return this.delivery_toNumber(ch.__issueQty) > 0;
                    });

                    if (!activeChildren.length) return false;

                    return activeChildren.every((ch) => this.delivery_isRowValid(ch));
                }

                const hasWarehouse =
                    Array.isArray(row.__warehouses) &&
                    row.__warehouses.some((w) => w && w.WhsCode);

                if (!hasWarehouse) return false;

                const whOk = !!row.__whs;
                const availOk = this.delivery_toNumber(row.__available) > 0;

                let selfOk = whOk && availOk;

                if (row.__anyBatches) {
                    const allocOk = Math.abs(this.delivery_batchAllocatedTotal(row) - qty) < 1e-6;
                    selfOk = selfOk && allocOk;
                }

                return selfOk;
            },

           delivery_rowSelectable(row) {
                const status = String(row.LineStatus || '').toUpperCase();
                if (row.__parent || status === 'C' || status === 'BOST_CLOSE') return false;

                // BOM parents: enable checkbox when all deliverable components are valid.
                if (row.children && row.children.length) {
                    return this.delivery_isRowValid(row);
                }

                const hasWarehouse =
                    Array.isArray(row.__warehouses) &&
                    row.__warehouses.some(w => w && w.WhsCode);

                return hasWarehouse && this.delivery_isRowValid(row);

                },

            delivery_enforceSelectionValidity() {
                if (!this.$refs.sapTable) return;
                const sel = (this.delivery_selectedRows || []).slice();
                const invalid = sel.filter((r) => !this.delivery_isRowValid(r));
                if (!invalid.length) return;

                this.delivery_picking = true;
                // invalid.forEach((r) => this.$refs.sapTable.toggleRowSelection(r, false));

                 invalid.forEach(r => {
                    this.$refs.sapTable.toggleRowSelection(r, false);
                    this.setImplicitSelection(r, false);
                });

                this.delivery_picking = false;
            },

            collectSubtree(row) {
                const out = [row];
                const walk = (arr) => {
                    (arr || []).forEach(r => {
                    out.push(r);
                    if (r.children && r.children.length) walk(r.children);
                    });
                };
                walk(row.children);
                return out;
                },

            delivery_onSelectionChange(rows) {
                this.delivery_selectedRows = rows || [];
                if (this.delivery_picking) return;
                    this.$nextTick(() => this.delivery_enforceParentAllOrNothing());
            },

            delivery_flattenRows(rows) {
            const out = [];
            const walk = (arr) => {
                (arr || []).forEach((r) => {
                out.push(r);
                if (r.children && r.children.length) walk(r.children);
                });
            };
            walk(rows);
            return out;
            },

            delivery_getDescendants(row) {
            const out = [];
            const walk = (arr) => {
                (arr || []).forEach((r) => {
                out.push(r);
                if (r.children && r.children.length) walk(r.children);
                });
            };
            walk(row.children || []);
            return out;
            },

            setImplicitSelection(row, isSelected) {
                if (!row || !row.children || !row.children.length) return;

                row.children.forEach(ch => {
                    ch.__selectedByParent = isSelected;
                    this.setImplicitSelection(ch, isSelected);
                });
            },

            delivery_onRowSelect(selection, row) {
                if (this.delivery_picking) return;
                this.delivery_picking = true;

                const isSelected = (selection || []).some(r => r.__rowKey === row.__rowKey);
                

               /*  if (row.children && row.children.length) {
                    const descendants = this.delivery_getDescendants(row);

                    descendants.forEach(ch => {
                    if (!isSelected) {
                        this.$refs.sapTable.toggleRowSelection(ch, false);
                    } else if (this.delivery_isRowValid(ch)) {
                        this.$refs.sapTable.toggleRowSelection(ch, true);
                    }
                    });
                } */
/* 
                if (!isSelected && row.__parent) {
                    this.$refs.sapTable.toggleRowSelection(row.__parent, false);
                } */

                this.setImplicitSelection(row, isSelected);

                this.delivery_picking = false;
                this.$nextTick(() => this.delivery_enforceSelectionValidity());

                /* this.$nextTick(() => {
                    this.delivery_syncParentSelectionUp(row);
                    this.delivery_enforceSelectionValidity();
                }); */
                },


            /* delivery_onRowSelect(selection, row) {
            if (this.delivery_picking) return;
            this.delivery_picking = true;

            const isSelected = (selection || []).some(
                (r) => r.__rowKey === row.__rowKey
            );

            if (row.children && row.children.length) {
                const descendants = this.delivery_getDescendants(row);

                descendants.forEach((ch) => {
                if (!isSelected) {
                    this.$refs.sapTable.toggleRowSelection(ch, false);
                } else if (this.delivery_isRowValid(ch)) {
                    this.$refs.sapTable.toggleRowSelection(ch, true);
                }
                });
            }

            if (!isSelected && row.__parent) {
                const parentIsSelected = (selection || []).some(
                (r) => r.__rowKey === row.__parent.__rowKey
                );
                if (parentIsSelected) {
                this.$refs.sapTable.toggleRowSelection(row.__parent, false);
                }
            }

            this.delivery_picking = false;
            this.$nextTick(() => this.delivery_enforceSelectionValidity());
            }, */

            delivery_onSelectAll(selection) {
                if (this.delivery_picking) return;
                this.delivery_picking = true;

                const isSelected = (selection || []).length > 0;

                (this.delivery_tableData || []).forEach(r => {
                    if (!isSelected) {
                    this.$refs.sapTable.toggleRowSelection(r, false);
                    this.setImplicitSelection(r, false);
                    return;
                    }

                    if (this.delivery_isRowValid(r)) {
                    this.$refs.sapTable.toggleRowSelection(r, true);
                    this.setImplicitSelection(r, true);
                    }
                });
               /*  const all = this.delivery_flattenRows(this.delivery_tableData);

                all.forEach((r) => {
                    if (!isSelected) {
                    this.$refs.sapTable.toggleRowSelection(r, false);
                    return;
                    }
                    if (this.delivery_isRowValid(r)) {
                    this.$refs.sapTable.toggleRowSelection(r, true);
                    }
                });
 */
                this.delivery_picking = false;
                this.$nextTick(() => this.delivery_enforceSelectionValidity());
            },

            delivery_onIssueQtyChange(row, enforce = true) {
                const issueQty = this.delivery_toNumber(row.__issueQty);
                const totalAlloc = this.delivery_batchAllocatedTotal(row);

                if (issueQty < totalAlloc) {
                    this.delivery_trimAllocationsToQty(row, issueQty);
                }

                if (row.children && row.children.length) {
                    this.delivery_syncChildrenQtyByBom(row);
                }

                if (enforce !== false) {
                    this.$nextTick(() => this.delivery_enforceSelectionValidity());
                }
            },

            delivery_syncChildrenQtyByBom(parentRow) {
                const parentQty = this.delivery_toNumber(parentRow.__issueQty);
                const parentMax =
                    parentRow.__maxQty != null ? this.delivery_toNumber(parentRow.__maxQty) : null;

                (parentRow.children || []).forEach((child) => {
                    const bomQtyRaw = this.delivery_toNumber(child.BOMReqQty);
                    const factor = bomQtyRaw > 0 ? bomQtyRaw : 1;

                    if (parentMax != null) {
                    child.__maxQty = parentMax * factor;
                    }

                    const desired = parentQty * factor;

                    const nextQty =
                    child.__maxQty != null
                        ? Math.min(desired, this.delivery_toNumber(child.__maxQty))
                        : desired;

                    child.__issueQty = nextQty;

                    const totalAlloc = this.delivery_batchAllocatedTotal(child);
                    if (nextQty < totalAlloc) {
                    this.delivery_trimAllocationsToQty(child, nextQty);
                    }

                    if (child.children && child.children.length) {
                    this.delivery_syncChildrenQtyByBom(child);
                    }
                });
                },

            delivery_trimAllocationsToQty(row, maxQty) {
            const total = this.delivery_batchAllocatedTotal(row);
            let needReduce = total - this.delivery_toNumber(maxQty);
            if (needReduce <= 0) return;

            const batches = (row.__batchOptions || []).slice().sort((a, b) => {
                const da = new Date(a.ExpDate || a.BatchNumber || 0).getTime();
                const db = new Date(b.ExpDate || b.BatchNumber || 0).getTime();
                return db - da;
            });

            for (const b of batches) {
                const k = b.BatchNumber;
                const q = this.delivery_toNumber(row.__batchAlloc[k]);
                if (q <= 0) continue;

                const reduce = Math.min(q, needReduce);
                row.__batchAlloc[k] = q - reduce;
                needReduce -= reduce;

                if (needReduce <= 0) break;
            }
            },

            delivery_onWhsChange(row, enforce = true) {
                if (!row) return;

                // BOM parent: warehouse is selected on the parent and pushed down to all component rows.
                if (row.children && row.children.length) {
                    const whsCode = row.__whs || "";

                    (row.children || []).forEach((ch) => {
                    if (!whsCode) {
                        ch.__whs = "";
                    } else {
                        const has =
                        Array.isArray(ch.__warehouses) &&
                        ch.__warehouses.some((w) => w && w.WhsCode === whsCode);

                        ch.__whs = has ? whsCode : "";
                    }

                    this.delivery_onWhsChange(ch, false);
                    });

                    if (enforce !== false) {
                        this.$nextTick(() => this.delivery_enforceSelectionValidity());
                    }
                    return;
                }

                // Component rows: keep aligned with the parent warehouse selection (only if it exists for the child).
                if (row.__parent && row.__parent.__whs) {
                    const parentWhs = row.__parent.__whs;
                    const hasParentWhs =
                    Array.isArray(row.__warehouses) &&
                    row.__warehouses.some((w) => w && w.WhsCode === parentWhs);

                    if (hasParentWhs && row.__whs !== parentWhs) {
                    row.__whs = parentWhs;
                    }
                }

                const wh = row.__warehouses.find((w) => w.WhsCode === row.__whs) || null;
                row.__available = wh ? this.delivery_toNumber(wh.Available) : 0;

                row.__batchOptions = wh && wh.BatchNumbers ? wh.BatchNumbers : [];
                row.__batchAlloc = this.delivery_initBatchAllocMap(row.__batchOptions);

                this.delivery_onIssueQtyChange(row, false);

                if (enforce !== false) {
                    this.$nextTick(() => this.delivery_enforceSelectionValidity());
                }
            },

            delivery_openBatchDialog(row) {
            const wh = row.__warehouses.find((w) => w.WhsCode === row.__whs) || null;
            row.__batchOptions = wh && wh.BatchNumbers ? wh.BatchNumbers : [];
            row.__batchAlloc = this.delivery_ensureBatchAllocKeys(
                row.__batchAlloc,
                row.__batchOptions
            );

            this.delivery_activeRow = row;
            this.delivery_batchDialogVisible = true;
            },

            delivery_onBatchDialogClose() {
            this.delivery_activeRow = null;
            },

            delivery_initBatchAllocMap(batchOptions) {
            const map = {};
            (batchOptions || []).forEach((b) => {
                map[b.BatchNumber] = 0;
            });
            return map;
            },

            delivery_ensureBatchAllocKeys(existing, batchOptions) {
            const map = { ...(existing || {}) };
            (batchOptions || []).forEach((b) => {
                if (map[b.BatchNumber] == null) map[b.BatchNumber] = 0;
            });

            const allowed = new Set((batchOptions || []).map((b) => b.BatchNumber));
            Object.keys(map).forEach((k) => {
                if (!allowed.has(k)) delete map[k];
            });

            return map;
            },

            delivery_batchAllocatedTotal(row) {
            const alloc = row && row.__batchAlloc ? row.__batchAlloc : {};
            return Object.values(alloc).reduce(
                (sum, v) => sum + this.delivery_toNumber(v),
                0
            );
            },

            delivery_onBatchQtyChange(row, batch, val) {
            const key = batch.BatchNumber;
            const issueQty = this.delivery_toNumber(row.__issueQty);

            let sumExcept = 0;
            Object.keys(row.__batchAlloc || {}).forEach((k) => {
                if (k === key) return;
                sumExcept += this.delivery_toNumber(row.__batchAlloc[k]);
            });

            const allowedForThisBatch = Math.max(0, issueQty - sumExcept);

            if (this.delivery_toNumber(val) > allowedForThisBatch) {
                row.__batchAlloc[key] = allowedForThisBatch;
            }

            this.$nextTick(() => this.delivery_enforceSelectionValidity());
            },

            delivery_clearBatchAlloc(row) {
            const map = {};
            (row.__batchOptions || []).forEach((b) => {
                map[b.BatchNumber] = 0;
            });
            row.__batchAlloc = map;

            this.$nextTick(() => this.delivery_enforceSelectionValidity());
            },

            delivery_autoAllocateFIFO(row) {
            const issueQty = this.delivery_toNumber(row.__issueQty);
            if (!issueQty || !row.__batchOptions.length) return;

            const opts = row.__batchOptions.slice().sort((a, b) => {
                const da = new Date(a.ExpDate || a.BatchNumber || 0).getTime();
                const db = new Date(b.ExpDate || b.BatchNumber || 0).getTime();
                return da - db;
            });

            const map = {};
            let remaining = issueQty;

            for (const b of opts) {
                const onHand = this.delivery_toNumber(b.OnHand);
                const take = Math.min(onHand, remaining);
                map[b.BatchNumber] = take;
                remaining -= take;
                if (remaining <= 0) break;
            }

            (row.__batchOptions || []).forEach((b) => {
                if (map[b.BatchNumber] == null) map[b.BatchNumber] = 0;
            });

            row.__batchAlloc = map;

            this.$nextTick(() => this.delivery_enforceSelectionValidity());
            },

            delivery_toNumber(x) {
            const n = Number.parseFloat(x);
            return Number.isFinite(n) ? n : 0;
            },

            delivery_getSelectedPayload() {
                const rows = [];

                (this.delivery_selectedRows || []).forEach(parent => {
                    rows.push(...this.collectSubtree(parent));
                });

                return rows.map(r => ({
                    DocEntry: r.DocEntry,
                    LineNum: r.LineNum,
                    ItemCode: r.ItemCode,
                    U_RefItemId : r.U_RefItemId,
                    WhsCode: r.__whs,
                    IssueQty: this.delivery_toNumber(r.__issueQty),
                    BatchAlloc: Object.keys(r.__batchAlloc || {})
                    .map(k => ({ BatchNumber: k, Qty: this.delivery_toNumber(r.__batchAlloc[k]) }))
                    .filter(x => x.Qty > 0),
                }));
            },

            createDelivery() {
                if (!this.delivery_selectedRows.length) {
                    this.$ThatsNotify.warning({ message: "No lines selected for delivery." });
                    return;
                }

                const payload = this.delivery_getSelectedPayload();
                this.deliveryCreating = true;

                const SalesOrderDocEntry = Number(this.form.ordr_sap_data.DocEntry);

                const DocumentLines = payload.map((line) => {
                    const BatchNumbers = (line.BatchAlloc ?? [])
                    .filter((b) => Number(b.Qty) > 0)
                    .map((b) => ({
                        BatchNumber: String(b.BatchNumber ?? "").trim(),
                        Quantity: Number(b.Qty),
                    }));

                    const docLine = {
                    ItemCode: String(line.ItemCode ?? "").trim(),
                    Quantity: Number(line.IssueQty),
                    WarehouseCode: String(line.WhsCode ?? "").trim(),
                    BaseEntry: Number.isFinite(SalesOrderDocEntry) ? SalesOrderDocEntry : null,
                    BaseLine: Number(line.LineNum),
                    BaseType : 17,
                    U_TransitWHSCode : "GIT-03",
                    U_RefItemId: line.U_RefItemId ?? null,
                    };
                    if (BatchNumbers.length) docLine.BatchNumbers = BatchNumbers;

                    return docLine;
                });

                const requestPayload = {
                    connection: this.form.ordr[0].reference,
                    DocDate: this.form.ordr_sap_data.DocDueDate,      
                    DocDueDate: this.form.ordr_sap_data.DocDueDate,  
                    U_WinvoiceNum: String(this.form.invoice?.series ?? "").trim(), 
                    DiscPrcnt: Number(this.form.ordr_sap_data.DiscPrcnt ?? 0),
                    CardCode: this.form.ordr_sap_data.CardCode ? String(this.form.ordr_sap_data.CardCode).trim() : null,
                    DocumentLines,
                };

                console.log("Creating delivery document with lines:", requestPayload);

                this.createDeliveryDocument(requestPayload)
                    .then(() => {
                    this.$ThatsNotify.success({ message: "Delivery document created successfully." });
                    this.delivery_batchDialogVisible = false;
                    this.delivery_selectedRows = [];
                    this.updatePaymentSuccess();
                    })
                    .catch((err) => {
                    console.error("Error creating delivery document:", err);
                    this.$ThatsNotify.error({ message: "Failed to create delivery document." });
                    })
                    .finally(() => {
                    this.deliveryCreating = false;
                    });
                },

            returnReq_toNullableNumber(value) {
                if (value === undefined || value === null) return null;
                if (typeof value === "string" && value.trim() === "") return null;
                const number = parseFloat(value);
                return Number.isNaN(number) ? null : number;
            },

            returnReq_resolveDeliveredReturnableQty(row, fallbackQty = 0) {
                const baseQty = Math.max(0, this.delivery_toNumber(fallbackQty));
                const requestedReturnQty = Math.max(
                    0,
                    this.returnReq_toNullableNumber(
                        this.returnReq_pickValue(row, ["RequestedReturnQty"], null)
                    ) || 0
                );
                const creditNoteReturnQty = Math.max(
                    0,
                    this.returnReq_toNullableNumber(
                        this.returnReq_pickValue(row, ["CreditNoteReturnQty"], null)
                    ) || 0
                );
                const allowedReturnOpenQty = this.returnReq_toNullableNumber(
                    this.returnReq_pickValue(row, ["AllowedReturnOpenQty"], null)
                );
                const returnableQty = this.returnReq_toNullableNumber(
                    this.returnReq_pickValue(row, ["ReturnableQty"], null)
                );

                let resolvedQty;
                if (allowedReturnOpenQty != null) {
                    resolvedQty = Math.max(0, allowedReturnOpenQty - requestedReturnQty);
                } else if (returnableQty != null) {
                    resolvedQty = Math.max(0, returnableQty);
                } else {
                    resolvedQty = Math.max(0, baseQty - creditNoteReturnQty - requestedReturnQty);
                }

                if (allowedReturnOpenQty != null && returnableQty != null) {
                    resolvedQty = Math.min(resolvedQty, Math.max(0, returnableQty));
                }

                return Math.min(baseQty, resolvedQty);
            },

            returnReq_getMaxQty(row) {
                const rowType = String(row && row.RowType ? row.RowType : "").toUpperCase();
                if (rowType === "DELIVERED") {
                    const dnOpenQty = this.delivery_toNumber(row && row.DN_OpenQty);
                    const deliveredQty = this.delivery_toNumber(row && row.DeliveredQty);
                    const fallbackQty = dnOpenQty > 0 ? dnOpenQty : deliveredQty;
                    return this.returnReq_resolveDeliveredReturnableQty(row, fallbackQty);
                }

                if (rowType === "OPEN" || rowType === "UNDELIVERED") {
                    const openQtyToDeliver = this.delivery_toNumber(row && row.OpenQtyToDeliver);
                    if (openQtyToDeliver > 0) return openQtyToDeliver;
                    return this.delivery_toNumber(row && row.OrderedQty);
                }

                return this.delivery_toNumber(
                    (row && row.OpenQtyToDeliver) || (row && row.DN_OpenQty) || (row && row.DeliveredQty) || (row && row.OrderedQty)
                );
            },

            returnReq_isAllowed(row) {
                if (!row) return false;

                const rowType = String(row.RowType || "").toUpperCase();
                const soLineStatus = String(
                    this.returnReq_pickValue(row, ["SO_LineStatus", "sales_order_line_status", "LineStatus"], "")
                ).toUpperCase();
                const isUndelivered = rowType === "OPEN" || rowType === "UNDELIVERED";
                if (isUndelivered) {
                    return soLineStatus !== "C";
                }

                const allowReturnRaw =
                    row.AllowReturn != null
                        ? row.AllowReturn
                        : (row.allow_return != null ? row.allow_return : null);
                const allowReturn = this.returnReq_toBoolean(allowReturnRaw, null);
                if (allowReturn === false) return false;

                const allowRaw = row.AllowSalesReturnRequest;
                const allowRequest = this.returnReq_toBoolean(allowRaw, null);
                if (!allowRequest) return false;

                const selectableRaw = row.SelectableForReturn;
                const selectable = this.returnReq_toBoolean(selectableRaw, false);

                if (rowType === "OPEN") {
                    return true;
                }

                if (rowType === "DELIVERED") {
                    if (allowReturn === true) return true;
                    return selectable;
                }

                return true;
            },

            returnReq_lineStatusValue(row) {
                if (!row) return "";

                const rowType = String(
                    this.returnReq_pickValue(row, ["RowType", "sourceType", "__sourceType"], "")
                ).toUpperCase();

                const soLineStatus = String(
                    this.returnReq_pickValue(
                        row,
                        ["SO_LineStatus", "sales_order_line_status", "LineStatus"],
                        ""
                    )
                ).toUpperCase();

                const dnLineStatus = String(
                    this.returnReq_pickValue(
                        row,
                        ["DN_LineStatus", "delivery_note_line_status", "delivery_status"],
                        ""
                    )
                ).toUpperCase();

                if (rowType === "DELIVERED") {
                    return dnLineStatus || soLineStatus || "";
                }

                if (rowType === "OPEN" || rowType === "UNDELIVERED") {
                    return soLineStatus || dnLineStatus || "";
                }

                return soLineStatus || dnLineStatus || "";
            },

            returnReq_lineStatusLabel(row) {
                const status = this.returnReq_lineStatusValue(row);
                if (!status) return "-";
                if (status === "C") return "Closed";
                if (status === "O") return "Open";
                return status;
            },

            returnReq_lineStatusType(row) {
                const status = this.returnReq_lineStatusValue(row);
                if (status === "O") return "success";
                if (status === "C") return "info";
                return "warning";
            },

            returnReq_treeTypeToBOMType(treeType) {
                const raw = String(treeType || "").toUpperCase();
                if (raw === "S" || raw === "N" || raw === "I") return raw;
                return "N";
            },

            returnReq_extractLineDeliveryRows(line, parentRef = null, includeComponents = false) {
                if (!line) return [];

                const lineRef = line.U_RefItemId != null && String(line.U_RefItemId).trim() !== ""
                    ? String(line.U_RefItemId).trim()
                    : (line.SO_U_RefItemId != null && String(line.SO_U_RefItemId).trim() !== ""
                        ? String(line.SO_U_RefItemId).trim()
                        : (parentRef != null ? String(parentRef).trim() : ""));
                const rootRef = lineRef || "-";

                const orderedQty = this.delivery_toNumber(line.Quantity != null ? line.Quantity : line.OrderedQty);
                const deliveredByLine = this.delivery_toNumber(line.DelivrdQty != null ? line.DelivrdQty : line.DeliveredQty);
                const openByLine = this.delivery_toNumber(line.OpenQty != null ? line.OpenQty : line.OpenQtyToDeliver);
                const lineNum = line.LineNum != null ? line.LineNum : (line.SalesOrderLine != null ? line.SalesOrderLine : "");
                const itemCode = line.ItemCode || line.SO_ItemCode || line.DN_ItemCode || line.BOMGroupItemCode || "";
                const itemDesc = line.Dscription || line.SO_ItemDesc || line.DN_ItemDesc || line.BOMGroupItemDesc || "";
                const itemImage = this.getItemImageByRefId(rootRef, itemCode);
                const bomType = this.returnReq_treeTypeToBOMType(line.TreeType || line.SO_BOMType);
                const bomLevel = bomType === "I" ? 1 : 0;
                const allowRequest = line.AllowSalesReturnRequest === true || line.AllowSalesReturnRequest === 1 || String(line.AllowSalesReturnRequest || "").toUpperCase() === "Y";

                const records = Array.isArray(line.DeliveryRecords) && line.DeliveryRecords.length
                    ? line.DeliveryRecords
                    : ((line.RowType || line.DeliveryDocEntry != null || line.DeliveryNoteNo != null) ? [line] : []);
                const rows = [];

                const makeRow = (record, fallbackType) => {
                    const rowType = String((record && record.RowType) || fallbackType || "").toUpperCase();
                    if (!rowType) return null;

                    const deliveredQty = this.delivery_toNumber(record && record.DeliveredQty);
                    const dnOpenQty = this.delivery_toNumber(record && record.DN_OpenQty);
                    const openQtyToDeliver = this.delivery_toNumber(record && record.OpenQtyToDeliver);
                    const selectableForReturn = record && record.SelectableForReturn != null
                        ? record.SelectableForReturn
                        : (rowType === "DELIVERED" && deliveredQty > 0 ? "Y" : "N");

                    return {
                        RowType: rowType,
                        SalesOrderLine: lineNum,
                        SO_U_RefItemId: rootRef,
                        SO_ItemCode: line.SO_ItemCode || itemCode,
                        SO_ItemDesc: line.SO_ItemDesc || itemDesc,
                        default: itemImage,
                        DN_ItemCode: record && record.DN_ItemCode != null ? record.DN_ItemCode : null,
                        DN_ItemDesc: record && record.DN_ItemDesc != null ? record.DN_ItemDesc : null,
                        OrderedQty: orderedQty,
                        OpenQtyToDeliver: openQtyToDeliver > 0 ? openQtyToDeliver : (rowType === "OPEN" ? openByLine : 0),
                        DeliveredQty: deliveredQty > 0 ? deliveredQty : (rowType === "DELIVERED" ? deliveredByLine : 0),
                        DN_OpenQty: dnOpenQty,
                        DeliveryNoteNo: record && record.DeliveryNoteNo != null ? record.DeliveryNoteNo : null,
                        DeliveryDocEntry: record && record.DeliveryDocEntry != null ? record.DeliveryDocEntry : null,
                        DeliveryDate: record && record.DeliveryDate != null ? record.DeliveryDate : null,
                        DeliveryLine: record && record.DeliveryLine != null ? record.DeliveryLine : null,
                        AllowSalesReturnRequest: allowRequest,
                        SelectableForReturn: selectableForReturn,
                        SO_BOMType: bomType,
                        BOMLevel: record && record.BOMLevel != null ? this.delivery_toNumber(record.BOMLevel) : bomLevel,
                        BOMRequiredQty: record && record.BOMRequiredQty != null ? record.BOMRequiredQty : line.BOMReqQty,
                        components: includeComponents ? (Array.isArray(line.components) ? line.components : []) : [],
                        __rootRefItemId: rootRef,
                        __sourceLineNum: lineNum,
                    };
                };

                records.forEach((record) => {
                    const nextRow = makeRow(record, null);
                    if (nextRow) rows.push(nextRow);
                });

                if (!rows.length) {
                    if (openByLine > 0) {
                        const openRow = makeRow(null, "OPEN");
                        if (openRow) rows.push(openRow);
                    }
                    if (deliveredByLine > 0) {
                        const deliveredRow = makeRow(null, "DELIVERED");
                        if (deliveredRow) rows.push(deliveredRow);
                    }
                }

                return rows;
            },

            returnReq_buildRowsFromDocumentLines(lines, parentRef = null, out = [], includeComponents = false) {
                (lines || []).forEach((line) => {
                    if (!line) return;

                    const lineRef = line.U_RefItemId != null && String(line.U_RefItemId).trim() !== ""
                        ? String(line.U_RefItemId).trim()
                        : (parentRef != null ? String(parentRef).trim() : "");

                    const rows = this.returnReq_extractLineDeliveryRows(line, lineRef, includeComponents);
                    out.push(...rows);
                });

                return out;
            },

            returnReq_flattenDeliveryLines(lines, parentRef = null, out = [], includeComponents = true) {
                (lines || []).forEach((line) => {
                    if (!line) return;

                    const ownRef = line.SO_U_RefItemId != null ? String(line.SO_U_RefItemId).trim() : "";
                    const nextRef = ownRef !== "" ? ownRef : parentRef;

                    out.push({
                        ...line,
                        __rootRefItemId: nextRef,
                    });

                    if (includeComponents && Array.isArray(line.components) && line.components.length) {
                        this.returnReq_flattenDeliveryLines(line.components, nextRef, out);
                    }
                });

                return out;
            },

            returnReq_collectComponentLines(line, parentRef = null, out = [], inherited = null, matchContext = null) {
                if (!line || !Array.isArray(line.components) || !line.components.length) return out;

                const baseRef = line.SO_U_RefItemId != null && String(line.SO_U_RefItemId).trim() !== ""
                    ? String(line.SO_U_RefItemId).trim()
                    : (parentRef != null ? String(parentRef).trim() : "");

                const baseMeta = inherited || {
                    AllowSalesReturnRequest: line.AllowSalesReturnRequest,
                    SelectableForReturn: line.SelectableForReturn,
                    RowType: line.RowType,
                    DeliveryDate: line.DeliveryDate,
                    DeliveryNoteNo: line.DeliveryNoteNo,
                };

                const context = matchContext || {
                    rowType: String(line.RowType || "").toUpperCase(),
                    deliveryDocEntry: line.DeliveryDocEntry != null ? line.DeliveryDocEntry : null,
                    deliveryNoteNo: line.DeliveryNoteNo != null ? line.DeliveryNoteNo : null,
                    deliveryDate: this.returnReq_formatDate(line.DeliveryDate),
                };

                line.components.forEach((component) => {
                    if (!component) return;

                    const compRef = component.SO_U_RefItemId != null && String(component.SO_U_RefItemId).trim() !== ""
                        ? String(component.SO_U_RefItemId).trim()
                        : baseRef;

                    const componentRows = this.returnReq_extractLineDeliveryRows(component, compRef, false);
                    componentRows.forEach((componentRow) => {
                        const normalized = {
                            ...componentRow,
                            __rootRefItemId: componentRow.__rootRefItemId || compRef || baseRef || "-",
                            AllowSalesReturnRequest: component.AllowSalesReturnRequest != null
                                ? componentRow.AllowSalesReturnRequest
                                : baseMeta.AllowSalesReturnRequest,
                            SelectableForReturn: componentRow.RowType === "DELIVERED"
                                ? (this.delivery_toNumber(componentRow.DeliveredQty) > 0 ? "Y" : "N")
                                : (component.AllowSalesReturnRequest != null ? "N" : baseMeta.SelectableForReturn),
                        };

                        const normalizedRowType = String(normalized.RowType || "").toUpperCase();
                        if (context.rowType && normalizedRowType !== context.rowType) return;

                        if (context.rowType === "DELIVERED") {
                            if (context.deliveryDocEntry != null && normalized.DeliveryDocEntry != null && String(context.deliveryDocEntry) !== String(normalized.DeliveryDocEntry)) return;
                            if (context.deliveryDocEntry == null && context.deliveryNoteNo != null && normalized.DeliveryNoteNo != null && String(context.deliveryNoteNo) !== String(normalized.DeliveryNoteNo)) return;
                            if (
                                context.deliveryDocEntry == null &&
                                context.deliveryNoteNo == null &&
                                context.deliveryDate &&
                                this.returnReq_formatDate(normalized.DeliveryDate) &&
                                context.deliveryDate !== this.returnReq_formatDate(normalized.DeliveryDate)
                            ) return;
                        }

                        out.push(normalized);
                    });

                    this.returnReq_collectComponentLines(component, compRef || baseRef, out, {
                        AllowSalesReturnRequest: component.AllowSalesReturnRequest != null ? component.AllowSalesReturnRequest : baseMeta.AllowSalesReturnRequest,
                        SelectableForReturn: component.SelectableForReturn != null ? component.SelectableForReturn : baseMeta.SelectableForReturn,
                        RowType: component.RowType || baseMeta.RowType,
                        DeliveryDate: component.DeliveryDate || baseMeta.DeliveryDate,
                        DeliveryNoteNo: component.DeliveryNoteNo != null ? component.DeliveryNoteNo : baseMeta.DeliveryNoteNo,
                    }, context);
                });

                return out;
            },

            returnReq_hiddenComponentKey(row) {
                if (!row) return "";
                return [
                    row.BOMGroupKey || "",
                    row.SalesOrderLine != null ? row.SalesOrderLine : "",
                    String(row.RowType || "").toUpperCase(),
                    row.DeliveryDocEntry != null ? row.DeliveryDocEntry : "",
                    row.DeliveryLine != null ? row.DeliveryLine : "",
                    row.ReturnBaseEntry != null ? row.ReturnBaseEntry : "",
                    row.ReturnBaseLine != null ? row.ReturnBaseLine : "",
                    row.SO_ItemCode || row.DN_ItemCode || row.BOMGroupItemCode || row.ItemCode || "",
                ].join("|");
            },

            returnReq_formatDate(value) {
                if (!value) return "";
                const text = String(value).trim();
                if (!text) return "";
                if (text.length >= 10) return text.substring(0, 10);
                return text;
            },

            returnReq_toBoolean(value, fallback = null) {
                if (typeof value === "boolean") return value;
                if (typeof value === "number") {
                    if (value === 1) return true;
                    if (value === 0) return false;
                }
                if (typeof value === "string") {
                    const normalized = value.trim().toUpperCase();
                    if (!normalized) return fallback;
                    if (["1", "Y", "YES", "TRUE", "T"].includes(normalized)) return true;
                    if (["0", "N", "NO", "FALSE", "F"].includes(normalized)) return false;
                }
                return fallback;
            },

            returnReq_normalizeLines(lines) {
                const flat = this.returnReq_flattenDeliveryLines(lines, null, [], false);

                const dedupMap = new Map();
                flat.forEach((row, index) => {
                    const key = [
                        row.BOMGroupKey || "",
                        row.SalesOrderLine != null ? row.SalesOrderLine : "",
                        String(row.RowType || "").toUpperCase(),
                        row.DeliveryDocEntry != null ? row.DeliveryDocEntry : "",
                        row.DeliveryLine != null ? row.DeliveryLine : "",
                        row.SO_ItemCode || row.DN_ItemCode || "",
                    ].join("|");

                    if (!dedupMap.has(key)) {
                        dedupMap.set(key, { ...row, __sourceIndex: index });
                    }
                });

                const groupMap = new Map();
                const typeLabel = (type) => (type === "OPEN" ? "Undelivered" : (type === "DELIVERED" ? "Delivered" : "Unknown"));

                const resolveItemMeta = (row) => {
                    const soItemDesc = row.SO_ItemDesc != null ? String(row.SO_ItemDesc).trim() : "";
                    const soRefDesc = row.SO_U_RefItemId != null ? String(row.SO_U_RefItemId).trim() : "";
                    const soDescLooksLikeId = soItemDesc !== "" && /^[0-9]+$/.test(soItemDesc);

                    return {
                        itemCode: row.SO_ItemCode || row.DN_ItemCode || row.BOMGroupItemCode || "",
                        itemName:
                            ((soItemDesc && !soDescLooksLikeId) ? soItemDesc : "") ||
                            row.DN_ItemDesc ||
                            row.BOMGroupItemDesc ||
                            soRefDesc ||
                            soItemDesc ||
                            "",
                    };
                };

                const addComponentToMap = (targetMap, componentRow) => {
                    if (!targetMap || !componentRow) return;

                    const qty = this.returnReq_getMaxQty(componentRow);
                    if (qty <= 0) return;

                    const allow = this.returnReq_isAllowed(componentRow);
                    if (!allow) return;

                    const hiddenKey = this.returnReq_hiddenComponentKey(componentRow);
                    if (!hiddenKey) return;

                    const componentType = String(componentRow.RowType || "").toUpperCase();
                    const componentTypeLabel = typeLabel(componentType);
                    const componentMeta = resolveItemMeta(componentRow);
                    const componentRef =
                        componentRow.SO_U_RefItemId != null && String(componentRow.SO_U_RefItemId).trim() !== ""
                            ? String(componentRow.SO_U_RefItemId).trim()
                            : (componentRow.__rootRefItemId != null && String(componentRow.__rootRefItemId).trim() !== ""
                                ? String(componentRow.__rootRefItemId).trim()
                                : "-");

                    if (!targetMap[hiddenKey]) {
                        targetMap[hiddenKey] = {
                            __rowKey: `ret-hidden-${hiddenKey}`,
                            __hiddenComponent: true,
                            SO_U_RefItemId: componentRef,
                            SalesOrderLine: componentRow.SalesOrderLine != null ? componentRow.SalesOrderLine : "",
                            ItemCode: componentMeta.itemCode,
                            Dscription: componentMeta.itemName,
                            default: this.getItemImageByRefId(componentRef, componentMeta.itemCode),
                            __rowTypeLabel: componentTypeLabel,
                            DeliveredDateDisplay: componentType === "DELIVERED" ? this.returnReq_formatDate(componentRow.DeliveryDate) : "",
                            DocNum: componentType === "DELIVERED" && componentRow.DeliveryNoteNo != null ? String(componentRow.DeliveryNoteNo) : "",
                            Qty: 0,
                            __maxQty: 0,
                            __issueQty: 0,
                            __returnAllowed: allow,
                            Remarks: "",
                            ReturnBaseType: componentRow.ReturnBaseType,
                            ReturnBaseEntry: componentRow.ReturnBaseEntry,
                            ReturnBaseLine: componentRow.ReturnBaseLine,
                            RowType: componentType || componentRow.RowType,
                            SO_ItemCode: componentRow.SO_ItemCode,
                            DN_ItemCode: componentRow.DN_ItemCode,
                        };
                    }

                    const target = targetMap[hiddenKey];
                    target.Qty += qty;
                    target.__maxQty += qty;
                    target.__issueQty += qty;
                    target.__returnAllowed = target.__returnAllowed || allow;
                };

                Array.from(dedupMap.values()).forEach((row, idx) => {
                    const rowType = String(row.RowType || "").toUpperCase();
                    const label = typeLabel(rowType);
                    const bomType = String(row.SO_BOMType || "").toUpperCase();
                    const bomLevel = this.delivery_toNumber(row.BOMLevel);

                    if (bomType === "I" || bomLevel > 0) return;

                    const qty = this.returnReq_getMaxQty(row);

                    const meta = resolveItemMeta(row);
                    const itemCode = meta.itemCode;
                    const itemName = meta.itemName;

                    const salesOrderLine = row.SalesOrderLine != null ? row.SalesOrderLine : "";
                    const refRaw = row.SO_U_RefItemId != null && String(row.SO_U_RefItemId).trim() !== ""
                        ? String(row.SO_U_RefItemId).trim()
                        : (row.__rootRefItemId != null && String(row.__rootRefItemId).trim() !== "" ? String(row.__rootRefItemId).trim() : "-");

                    // Group by refRaw and salesOrderLine only (not by label/type)
                    // This ensures delivered and undelivered items share the same parent row
                    const groupKey = [refRaw, salesOrderLine].join("|");
                    const allow = this.returnReq_isAllowed(row);

                    if (!groupMap.has(groupKey)) {
                        groupMap.set(groupKey, {
                            __rowKey: `ret-group-${idx}-${groupKey}`,
                            SO_U_RefItemId: refRaw,
                            SalesOrderLine: salesOrderLine,
                            ItemCode: itemCode,
                            Dscription: itemName,
                            default: this.getItemImageByRefId(refRaw, itemCode),
                            __rowTypeLabel: "Undelivered", // Parent always shows as Undelivered
                            DeliveredDateDisplay: "",
                            DocNum: "",
                            OrderedQty: this.delivery_toNumber(row.OrderedQty),
                            Qty: 0, // Will be set to undelivered qty only
                            __maxQty: 0, // Will be set to undelivered qty only
                            __issueQty: 0, // Will be set to undelivered qty only
                            __undeliveredQty: 0, // Track undelivered separately
                            __returnAllowed: false,
                            Remarks: "",
                            __detailMap: {},
                            __componentMap: {},
                            __componentRows: [],
                            children: [],
                        });
                    }

                    const group = groupMap.get(groupKey);
                    if (!group.default) {
                        group.default = this.getItemImageByRefId(refRaw, itemCode);
                    }
                    if (group.SalesOrderLine !== "" && salesOrderLine !== "" && String(group.SalesOrderLine) !== String(salesOrderLine)) {
                        group.SalesOrderLine = "";
                    }
                    if (group.ItemCode && itemCode && group.ItemCode !== itemCode) {
                        group.ItemCode = "Multiple";
                    }
                    if (group.Dscription && itemName && group.Dscription !== itemName) {
                        group.Dscription = "Multiple Items";
                    }
                    group.OrderedQty = Math.max(
                        this.delivery_toNumber(group.OrderedQty),
                        this.delivery_toNumber(row.OrderedQty)
                    );

                    // Only add undelivered quantities to the parent row
                    if (label === "Undelivered") {
                        group.Qty += qty;
                        group.__maxQty += qty;
                        group.__issueQty += qty;
                        group.__undeliveredQty += qty;
                        group.__returnAllowed = group.__returnAllowed || allow;
                    }

                    let detail = null;
                    if (label === "Delivered") {
                        const deliveredDate = this.returnReq_formatDate(row.DeliveryDate);
                        const docNum = row.DeliveryNoteNo != null ? String(row.DeliveryNoteNo) : "";
                        const detailKey = [deliveredDate || "__no_date__", docNum || "__no_doc__"].join("|");

                        if (!group.__detailMap[detailKey]) {
                            group.__detailMap[detailKey] = {
                                __rowKey: `ret-detail-${idx}-${groupKey}-${detailKey}`,
                                SO_U_RefItemId: refRaw,
                                SalesOrderLine: group.SalesOrderLine,
                                ItemCode: itemCode,
                                Dscription: itemName,
                                default: this.getItemImageByRefId(refRaw, itemCode),
                                __rowTypeLabel: label,
                                DeliveredDateDisplay: deliveredDate,
                                DocNum: docNum,
                                Qty: 0,
                                __maxQty: 0,
                                __issueQty: 0,
                                __returnAllowed: allow,
                                Remarks: "",
                                __componentMap: {},
                                __componentRows: [],
                            };
                        }

                        detail = group.__detailMap[detailKey];
                        if (!detail.default) {
                            detail.default = this.getItemImageByRefId(refRaw, itemCode);
                        }
                        detail.Qty += qty;
                        detail.__maxQty += qty;
                        detail.__issueQty += qty;
                        detail.__returnAllowed = detail.__returnAllowed || allow;
                    }

                    const componentRows = this.returnReq_collectComponentLines(row, refRaw, []);
                    componentRows.forEach((componentRow) => {
                        addComponentToMap(group.__componentMap, componentRow);
                        if (detail) {
                            addComponentToMap(detail.__componentMap, componentRow);
                        }
                    });
                });

                const typeSortWeight = (label) => {
                    if (label === "Undelivered") return 1;
                    if (label === "Delivered") return 2;
                    return 99;
                };

                const groups = Array.from(groupMap.values()).sort((a, b) => {
                    const refCompare = String(a.SO_U_RefItemId || "").localeCompare(String(b.SO_U_RefItemId || ""), undefined, {
                        numeric: true,
                        sensitivity: "base",
                    });
                    if (refCompare !== 0) return refCompare;

                    const typeCompare = typeSortWeight(a.__rowTypeLabel) - typeSortWeight(b.__rowTypeLabel);
                    if (typeCompare !== 0) return typeCompare;

                    const lineCompare = this.delivery_toNumber(a.SalesOrderLine) - this.delivery_toNumber(b.SalesOrderLine);
                    if (lineCompare !== 0) return lineCompare;

                    return String(a.ItemCode || "").localeCompare(String(b.ItemCode || ""), undefined, { numeric: true, sensitivity: "base" });
                });

                groups.forEach((group) => {
                    const details = Object.values(group.__detailMap || {}).sort((a, b) => {
                        const dateCompare = String(a.DeliveredDateDisplay || "").localeCompare(String(b.DeliveredDateDisplay || ""));
                        if (dateCompare !== 0) return dateCompare;
                        return String(a.DocNum || "").localeCompare(String(b.DocNum || ""), undefined, { numeric: true, sensitivity: "base" });
                    });

                    details.forEach((detail) => {
                        detail.__componentRows = Object.values(detail.__componentMap || {});
                        delete detail.__componentMap;
                    });

                    // If there are delivered items (details), add them as children
                    if (details.length) {
                        details.forEach((detail) => {
                            Object.defineProperty(detail, "__parent", {
                                value: group,
                                enumerable: false,
                                writable: true,
                            });
                        });
                        group.children = details;
                        
                        // If parent has undelivered qty, keep components on parent
                        // Otherwise, components are already on delivered children
                        if (group.__undeliveredQty > 0) {
                            group.__componentRows = Object.values(group.__componentMap || {});
                        } else {
                            group.__componentRows = [];
                        }
                    } else {
                        // No delivered items, keep components on parent
                        group.children = [];
                        group.__componentRows = Object.values(group.__componentMap || {});
                    }

                    delete group.__detailMap;
                    delete group.__componentMap;
                });

                return groups;
            },

            /**
             * Transform return request rows using the new business rules helper
             * This replaces the complex grouping logic with a clearer transformation:
             * - Fully delivered lines (deliveredQty == orderedQty) → single collapsed row
             * - Partially delivered lines → multiple rows (one per DN + one for undelivered)
             */
            returnReq_normalizeSourceType(value) {
                const normalized = String(value || "").toUpperCase();
                if (normalized === "OPEN") return "UNDELIVERED";
                return normalized;
            },

            returnReq_isCreditNoteItemCancelled(status) {
                const normalized = String(status || "").trim().toLowerCase();
                return ["cancel", "cancelled", "canceled"].includes(normalized);
            },

            returnReq_extractCreditNoteItemContext(item) {
                const attr = item && item.attr && typeof item.attr === "object" ? item.attr : {};
                const sourcePayload = attr && attr.source_payload && typeof attr.source_payload === "object"
                    ? attr.source_payload
                    : {};
                const lineReference = item && item.line_reference && typeof item.line_reference === "object"
                    ? item.line_reference
                    : {};

                const soLineNum = this.returnReq_pickValue(
                    lineReference,
                    ["sales_order_line_num"],
                    this.returnReq_pickValue(sourcePayload, ["sales_order_line_num", "line_num"], null)
                );
                const soRefItemId = this.returnReq_pickValue(
                    sourcePayload,
                    ["sales_order_ref_item_id"],
                    this.returnReq_pickValue(item || {}, ["transaction_item_id"], null)
                );
                const deliveryDocEntry = this.returnReq_pickValue(
                    lineReference,
                    ["delivery_note_doc_entry"],
                    this.returnReq_pickValue(sourcePayload, ["delivery_note_doc_entry"], null)
                );
                const deliveryDocNum = this.returnReq_pickValue(
                    lineReference,
                    ["delivery_note_doc_num"],
                    this.returnReq_pickValue(sourcePayload, ["delivery_note_doc_num"], null)
                );
                const deliveryLineNum = this.returnReq_pickValue(
                    lineReference,
                    ["delivery_note_line_num"],
                    this.returnReq_pickValue(sourcePayload, ["delivery_note_line_num"], null)
                );

                return {
                    qty: this.delivery_toNumber(this.returnReq_pickValue(item || {}, ["qty", "return_qty"], 0)),
                    soLineNum,
                    soRefItemId: soRefItemId != null ? String(soRefItemId) : null,
                    itemCode: this.returnReq_pickValue(item || {}, ["code", "item_code"], null),
                    rowType: this.returnReq_normalizeSourceType(
                        this.returnReq_pickValue(sourcePayload, ["row_type", "delivery_note_row_type"], null)
                    ),
                    deliveryDocEntry,
                    deliveryDocNum,
                    deliveryLineNum,
                };
            },

            returnReq_rowMatchesCreditNoteContext(row, context, strictRowType = true) {
                if (!row || !context) return false;

                const rowSourceType = this.returnReq_normalizeSourceType(
                    this.returnReq_pickValue(row, ["sourceType", "RowType", "__sourceType"], null)
                );

                if (strictRowType && context.rowType && rowSourceType && context.rowType !== rowSourceType) {
                    return false;
                }

                const rowSoLine = this.returnReq_pickValue(row, ["SO_LineNum", "salesOrderLineId", "LineNum"], null);
                const rowRefItemId = this.returnReq_pickValue(row, ["SO_U_RefItemId", "itemRefId"], null);
                const rowItemCode = this.returnReq_pickValue(row, ["itemCode", "ItemCode", "SO_ItemCode"], null);

                const hasLineKey = context.soLineNum != null && context.soLineNum !== "";
                const hasRefKey = context.soRefItemId != null && context.soRefItemId !== "";
                const hasItemCodeKey = context.itemCode != null && context.itemCode !== "";

                let baseMatched = false;
                if (hasLineKey && rowSoLine != null && String(rowSoLine) === String(context.soLineNum)) {
                    baseMatched = true;
                }
                if (!baseMatched && hasRefKey && rowRefItemId != null && String(rowRefItemId) === String(context.soRefItemId)) {
                    baseMatched = true;
                }
                if (!baseMatched && hasItemCodeKey && rowItemCode != null && String(rowItemCode) === String(context.itemCode)) {
                    baseMatched = true;
                }

                if (!baseMatched && (hasLineKey || hasRefKey || hasItemCodeKey)) return false;

                const hasDeliveryScope = context.deliveryDocEntry != null || context.deliveryDocNum != null || context.deliveryLineNum != null;
                if (!hasDeliveryScope) return true;

                const rowDnDocEntry = this.returnReq_pickValue(row, ["DN_DocEntry", "DeliveryDocEntry"], null);
                const rowDnDocNum = this.returnReq_pickValue(row, ["DN_DocNum", "DeliveryNoteNo", "dnNumber", "DocNum"], null);
                const rowDnLineNum = this.returnReq_pickValue(row, ["DN_LineNum", "DeliveryLine"], null);

                if (context.deliveryDocEntry != null && String(rowDnDocEntry) !== String(context.deliveryDocEntry)) {
                    return false;
                }
                if (context.deliveryDocNum != null && String(rowDnDocNum) !== String(context.deliveryDocNum)) {
                    return false;
                }
                if (context.deliveryLineNum != null && String(rowDnLineNum) !== String(context.deliveryLineNum)) {
                    return false;
                }

                return true;
            },

            returnReq_applyExistingCreditNoteDeductions(rows) {
                if (!Array.isArray(rows) || rows.length === 0) return rows;

                const creditNoteItems = this.form && Array.isArray(this.form.credit_note_items)
                    ? this.form.credit_note_items
                    : [];

                if (creditNoteItems.length === 0) return rows;

                const workingRows = rows.map((row) => ({
                    ...row,
                    __remainingReturnableQty: Math.max(0, this.delivery_toNumber(row.qtyAvailableForReturn)),
                }));

                creditNoteItems.forEach((item) => {
                    if (!item || this.returnReq_isCreditNoteItemCancelled(item.status)) return;

                    const context = this.returnReq_extractCreditNoteItemContext(item);
                    let remainingQty = Math.max(0, this.delivery_toNumber(context.qty));
                    if (remainingQty <= 0) return;

                    const applyDeduction = (matches) => {
                        matches.forEach((row) => {
                            if (remainingQty <= 0) return;
                            const available = Math.max(0, this.delivery_toNumber(row.__remainingReturnableQty));
                            if (available <= 0) return;
                            const deducted = Math.min(available, remainingQty);
                            row.__remainingReturnableQty = available - deducted;
                            remainingQty -= deducted;
                        });
                    };

                    const strictMatches = workingRows.filter((row) =>
                        this.returnReq_rowMatchesCreditNoteContext(row, context, true)
                    );
                    applyDeduction(strictMatches);

                    if (remainingQty > 0) {
                        const fallbackMatches = workingRows.filter((row) =>
                            this.returnReq_rowMatchesCreditNoteContext(row, context, false)
                        );
                        applyDeduction(fallbackMatches);
                    }
                });

                return workingRows.map((row) => {
                    const nextQty = Math.max(0, this.delivery_toNumber(row.__remainingReturnableQty));
                    const nextRow = { ...row, qtyAvailableForReturn: nextQty };
                    delete nextRow.__remainingReturnableQty;
                    return nextRow;
                });
            },

            returnReq_transformRows(salesOrderLines) {
                // Use the pure transformation helper
                const transformedRows = transformReturnRequestRows(salesOrderLines, this.getItemImageByRefId);
                const adjustedRows = this.returnReq_applyExistingCreditNoteDeductions(transformedRows);

                // Map to component-compatible structure
                return adjustedRows.map((row, index) => {
                    const qtyMax = this.delivery_toNumber(row.qtyAvailableForReturn);
                    const rowType = String(row.sourceType || row.RowType || "").toUpperCase();
                    const soLineStatus = String(row.SO_LineStatus || row.LineStatus || "").toUpperCase();
                    const isUndelivered = rowType === "UNDELIVERED" || rowType === "OPEN";
                    const allowReturnFromRow = this.returnReq_toBoolean(row.AllowReturn, null);
                    const allowSalesReturnRequest = this.returnReq_toBoolean(row.AllowSalesReturnRequest, null);
                    const allowReturn = isUndelivered
                        ? (soLineStatus !== "C" && qtyMax > 0)
                        : (
                            allowReturnFromRow != null
                                ? allowReturnFromRow
                                : (allowSalesReturnRequest != null ? allowSalesReturnRequest : qtyMax > 0)
                        );
                    const lineNum = row.SO_LineNum != null
                        ? row.SO_LineNum
                        : (row.salesOrderLineId != null ? row.salesOrderLineId : row.LineNum);
                    const docEntry = row.DN_DocEntry != null
                        ? row.DN_DocEntry
                        : (row.SO_DocEntry != null ? row.SO_DocEntry : (row.DocEntry != null ? row.DocEntry : null));
                    const docNum = row.dnNumber || row.DN_DocNum || row.DocNum || "";
                    const deliveryDocEntry = row.DeliveryDocEntry != null
                        ? row.DeliveryDocEntry
                        : (row.DN_DocEntry != null ? row.DN_DocEntry : null);
                    const deliveryLine = row.DeliveryLine != null
                        ? row.DeliveryLine
                        : (row.DN_LineNum != null ? row.DN_LineNum : null);
                    const deliveryDate = row.DeliveryDate || row.DN_DeliveryDate || row.dnDate || null;

                    return {
                        ...row,
                        __rowKey: row.__rowKey || `return-row-${index}`,
                        __rowTypeLabel: row.displaySource || row.sourceType,
                        __maxQty: qtyMax,
                        __issueQty: qtyMax, // Default issue qty = available qty
                        __returnAllowed: allowReturn,
                        SalesOrderLine: lineNum,
                        ItemCode: row.itemCode,
                        Dscription: row.itemDesc,
                        SO_U_RefItemId: row.itemRefId,
                        default: row.itemImage,
                        DeliveredDateDisplay: row.dnDate || row.DN_DeliveryDate || "",
                        DocNum: docNum,
                        DocEntry: docEntry,
                        Qty: qtyMax,
                        OrderedQty: row.orderedQty,
                        DeliveredQty: row.deliveredQty,
                        OpenQty: row.openQty,
                        RowType: row.sourceType,
                        AllowReturn: allowReturnFromRow,
                        AllowSalesReturnRequest: allowSalesReturnRequest,
                        LineNum: lineNum,
                        Remarks: "",
                        // Pass through original data for backend compatibility
                        DeliveryDocEntry: deliveryDocEntry,
                        DeliveryLine: deliveryLine,
                        DeliveryDate: deliveryDate,
                        DeliveryNoteNo: row.DeliveryNoteNo || row.DN_DocNum || row.dnNumber || null,
                        DeliveryRecords: Array.isArray(row.DeliveryRecords) ? row.DeliveryRecords : [],
                        DeliveryLines: Array.isArray(row.DeliveryLines) ? row.DeliveryLines : [],
                        SO_Raw: row.SO_Raw || row,
                        DN_Raw: row.DN_Raw || null,
                        DN_RawRecords: Array.isArray(row.DN_RawRecords) ? row.DN_RawRecords : [],
                        // Metadata
                        __isCollapsed: row.__isCollapsed || false,
                        __isFullyDelivered: row.__isFullyDelivered || false,
                        __sourceType: row.sourceType,
                        // No children for this simplified view
                        children: [],
                        __componentRows: [],
                    };
                });
            },

            returnReq_hasValue(value) {
                if (value === undefined || value === null) return false;
                if (typeof value === "string") return value.trim() !== "";
                return true;
            },

            returnReq_pickValue(source, keys = [], fallback = null) {
                if (!source || !Array.isArray(keys)) return fallback;
                for (let i = 0; i < keys.length; i += 1) {
                    const key = keys[i];
                    if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
                    const value = source[key];
                    if (this.returnReq_hasValue(value)) return value;
                }
                return fallback;
            },

            returnReq_normalizeDeliveryLine(record) {
                if (!record || typeof record !== "object") return null;

                const source = record.raw && typeof record.raw === "object" ? record.raw : record;

                const deliveryDateRaw = this.returnReq_pickValue(record, ["delivery_date", "deliveryDate", "DeliveryDate", "DN_DeliveryDate"], this.returnReq_pickValue(source, ["delivery_date", "deliveryDate", "DeliveryDate", "DN_DeliveryDate"], null));
                const rowTypeRaw = this.returnReq_pickValue(record, ["row_type", "RowType", "sourceType", "delivery_status", "deliveryStatus"], this.returnReq_pickValue(source, ["row_type", "RowType", "sourceType", "delivery_status", "deliveryStatus"], null));
                const rowType = String(rowTypeRaw || "").toUpperCase() || null;

                return {
                    delivery_doc_entry: this.returnReq_pickValue(record, ["delivery_doc_entry", "deliveryDocEntry", "DeliveryDocEntry", "DN_DocEntry"], this.returnReq_pickValue(source, ["delivery_doc_entry", "deliveryDocEntry", "DeliveryDocEntry", "DN_DocEntry"], null)),
                    delivery_doc_num: this.returnReq_pickValue(record, ["delivery_doc_num", "deliveryDocNum", "delivery_note_doc_num", "DeliveryDocNum", "DeliveryNoteNo", "DN_DocNum"], this.returnReq_pickValue(source, ["delivery_doc_num", "deliveryDocNum", "delivery_note_doc_num", "DeliveryDocNum", "DeliveryNoteNo", "DN_DocNum"], null)),
                    delivery_line_num: this.returnReq_pickValue(record, ["delivery_line_num", "deliveryLineNum", "DeliveryLine", "DN_LineNum"], this.returnReq_pickValue(source, ["delivery_line_num", "deliveryLineNum", "DeliveryLine", "DN_LineNum"], null)),
                    delivery_date: deliveryDateRaw ? this.returnReq_formatDate(deliveryDateRaw) : null,
                    delivery_status: this.returnReq_pickValue(record, ["delivery_status", "deliveryStatus", "DeliveryStatus", "DN_LineStatus"], this.returnReq_pickValue(source, ["delivery_status", "deliveryStatus", "DeliveryStatus", "DN_LineStatus"], rowType)),
                    delivered_qty: this.delivery_toNumber(this.returnReq_pickValue(record, ["delivered_qty", "deliveredQty", "DeliveredQty", "DN_DeliveredQty"], this.returnReq_pickValue(source, ["delivered_qty", "deliveredQty", "DeliveredQty", "DN_DeliveredQty"], 0))),
                    open_qty: this.delivery_toNumber(this.returnReq_pickValue(record, ["open_qty", "openQty", "OpenQty", "DN_OpenQty"], this.returnReq_pickValue(source, ["open_qty", "openQty", "OpenQty", "DN_OpenQty"], 0))),
                    row_type: rowType,
                    allow_return: this.returnReq_pickValue(record, ["allow_return", "allowReturn", "AllowReturn"], this.returnReq_pickValue(source, ["allow_return", "allowReturn", "AllowReturn"], null)),
                    so_doc_entry: this.returnReq_pickValue(record, ["so_doc_entry", "soDocEntry", "SO_DocEntry"], this.returnReq_pickValue(source, ["so_doc_entry", "soDocEntry", "SO_DocEntry"], null)),
                    so_doc_num: this.returnReq_pickValue(record, ["so_doc_num", "soDocNum", "SO_DocNum"], this.returnReq_pickValue(source, ["so_doc_num", "soDocNum", "SO_DocNum"], null)),
                    so_line_num: this.returnReq_pickValue(record, ["so_line_num", "soLineNum", "SO_LineNum"], this.returnReq_pickValue(source, ["so_line_num", "soLineNum", "SO_LineNum"], null)),
                    so_item_code: this.returnReq_pickValue(record, ["so_item_code", "soItemCode", "SO_ItemCode"], this.returnReq_pickValue(source, ["so_item_code", "soItemCode", "SO_ItemCode"], null)),
                    dn_item_code: this.returnReq_pickValue(record, ["dn_item_code", "dnItemCode", "DN_ItemCode"], this.returnReq_pickValue(source, ["dn_item_code", "dnItemCode", "DN_ItemCode"], null)),
                    dn_item_desc: this.returnReq_pickValue(record, ["dn_item_desc", "dnItemDesc", "DN_ItemDesc"], this.returnReq_pickValue(source, ["dn_item_desc", "dnItemDesc", "DN_ItemDesc"], null)),
                    dn_ref_item_id: this.returnReq_pickValue(record, ["dn_ref_item_id", "dnRefItemId", "DN_U_RefItemId"], this.returnReq_pickValue(source, ["dn_ref_item_id", "dnRefItemId", "DN_U_RefItemId"], null)),
                    raw: { ...source },
                };
            },

            returnReq_buildDeliveryLines(row) {
                if (!row) return [];

                const sources = [];

                if (Array.isArray(row.DeliveryLines) && row.DeliveryLines.length > 0) {
                    sources.push(...row.DeliveryLines);
                }
                if (Array.isArray(row.DN_RawRecords) && row.DN_RawRecords.length > 0) {
                    sources.push(...row.DN_RawRecords);
                }
                if (row.DN_Raw && typeof row.DN_Raw === "object") {
                    sources.push(row.DN_Raw);
                }
                if (Array.isArray(row.DeliveryRecords) && row.DeliveryRecords.length > 0) {
                    sources.push(...row.DeliveryRecords);
                }

                const normalized = sources
                    .map((record) => this.returnReq_normalizeDeliveryLine(record))
                    .filter((record) => {
                        if (!record) return false;
                        if (this.returnReq_hasValue(record.delivery_doc_entry)) return true;
                        if (this.returnReq_hasValue(record.delivery_doc_num)) return true;
                        if (this.delivery_toNumber(record.delivered_qty) > 0) return true;
                        if (this.delivery_toNumber(record.open_qty) > 0) return true;
                        if (this.returnReq_hasValue(record.so_line_num)) return true;
                        return false;
                    });

                if (!normalized.length) {
                    const fallback = this.returnReq_normalizeDeliveryLine(row);
                    if (fallback && (this.returnReq_hasValue(fallback.delivery_doc_entry) || this.returnReq_hasValue(fallback.delivery_doc_num))) {
                        normalized.push(fallback);
                    }
                }

                const dedupMap = new Map();
                normalized.forEach((record) => {
                    const key = [
                        record.delivery_doc_entry != null ? record.delivery_doc_entry : "",
                        record.delivery_doc_num != null ? record.delivery_doc_num : "",
                        record.delivery_line_num != null ? record.delivery_line_num : "",
                        record.so_line_num != null ? record.so_line_num : "",
                        record.dn_item_code || "",
                        record.delivery_date || "",
                        record.row_type || "",
                        this.delivery_toNumber(record.delivered_qty),
                        this.delivery_toNumber(record.open_qty),
                    ].join("|");

                    if (!dedupMap.has(key)) dedupMap.set(key, record);
                });

                return Array.from(dedupMap.values());
            },

            returnReq_extractSourceContext(row) {
                const deliveryLines = this.returnReq_buildDeliveryLines(row);
                const primaryDelivery = deliveryLines.length > 0 ? deliveryLines[0] : null;

                const soDocEntry = this.returnReq_pickValue(row, ["SO_DocEntry", "sales_order_doc_entry", "DocEntry"], this.form.ordr?.[0]?.entry || null);
                const soDocNum = this.returnReq_pickValue(row, ["SO_DocNum", "sales_order_doc_num"], this.form.ordr?.[0]?.number || null);
                const soLineNum = this.returnReq_pickValue(row, ["SO_LineNum", "SalesOrderLine", "sales_order_line_num", "LineNum"], null);
                const soItemCode = this.returnReq_pickValue(row, ["SO_ItemCode"], row.ItemCode || null);
                const soItemDesc = this.returnReq_pickValue(row, ["SO_ItemDesc"], row.Dscription || null);
                const soRefItemId = this.returnReq_pickValue(row, ["SO_U_RefItemId"], row.SO_U_RefItemId || null);
                const soWhsCode = this.returnReq_pickValue(row, ["SO_WhsCode"], row.WhsCode || null);
                const soLineStatus = this.returnReq_pickValue(row, ["SO_LineStatus", "LineStatus"], null);
                const soInventoryItem = this.returnReq_pickValue(row, ["SO_InventoryItem"], null);
                const soSalesItem = this.returnReq_pickValue(row, ["SO_SalesItem"], null);

                const dnDocEntry = this.returnReq_pickValue(
                    row,
                    ["DN_DocEntry", "DeliveryDocEntry", "delivery_note_doc_entry"],
                    primaryDelivery ? primaryDelivery.delivery_doc_entry : null
                );
                const dnDocNum = this.returnReq_pickValue(
                    row,
                    ["DN_DocNum", "DeliveryNoteNo", "delivery_note_doc_num", "DocNum"],
                    primaryDelivery ? primaryDelivery.delivery_doc_num : null
                );
                const dnLineNum = this.returnReq_pickValue(
                    row,
                    ["DN_LineNum", "DeliveryLine", "delivery_note_line_num"],
                    primaryDelivery ? primaryDelivery.delivery_line_num : null
                );
                const dnDateRaw = this.returnReq_pickValue(
                    row,
                    ["DN_DeliveryDate", "DeliveryDate", "delivered_date", "DeliveredDateDisplay"],
                    primaryDelivery ? primaryDelivery.delivery_date : null
                );
                const dnDeliveryDate = dnDateRaw ? this.returnReq_formatDate(dnDateRaw) : null;
                const dnItemCode = this.returnReq_pickValue(
                    row,
                    ["DN_ItemCode"],
                    primaryDelivery ? primaryDelivery.dn_item_code : null
                );
                const dnItemDesc = this.returnReq_pickValue(
                    row,
                    ["DN_ItemDesc"],
                    primaryDelivery ? primaryDelivery.dn_item_desc : null
                );
                const dnRefItemId = this.returnReq_pickValue(
                    row,
                    ["DN_U_RefItemId"],
                    primaryDelivery ? primaryDelivery.dn_ref_item_id : null
                );
                const dnWhsCode = this.returnReq_pickValue(row, ["DN_WhsCode"], null);
                const dnLineStatus = this.returnReq_pickValue(
                    row,
                    ["DN_LineStatus"],
                    primaryDelivery ? primaryDelivery.delivery_status : null
                );
                const dnDeliveredQty = this.delivery_toNumber(
                    this.returnReq_pickValue(
                        row,
                        ["DN_DeliveredQty", "DeliveredQty"],
                        primaryDelivery ? primaryDelivery.delivered_qty : 0
                    )
                );
                const dnOpenQty = this.delivery_toNumber(
                    this.returnReq_pickValue(
                        row,
                        ["DN_OpenQty", "OpenQty"],
                        primaryDelivery ? primaryDelivery.open_qty : 0
                    )
                );
                const dnRowType = this.returnReq_pickValue(
                    row,
                    ["DN_RowType", "RowType", "sourceType"],
                    primaryDelivery ? primaryDelivery.row_type : null
                );
                const selectedRowType = String(this.returnReq_pickValue(row, ["RowType", "sourceType"], dnRowType) || "").toUpperCase();
                const allowReturnFromRow = this.returnReq_toBoolean(
                    this.returnReq_pickValue(row, ["AllowReturn", "allow_return", "__returnAllowed"], null),
                    null
                );
                const allowFlags = deliveryLines
                    .filter((line) => {
                        const deliveryRowType = String(line && line.row_type ? line.row_type : "").toUpperCase();
                        if (!selectedRowType || !deliveryRowType) return true;
                        if (selectedRowType === "DELIVERED") return deliveryRowType === "DELIVERED";
                        if (selectedRowType === "UNDELIVERED" || selectedRowType === "OPEN") {
                            return deliveryRowType === "OPEN" || deliveryRowType === "UNDELIVERED";
                        }
                        return true;
                    })
                    .map((line) =>
                        this.returnReq_toBoolean(
                            this.returnReq_pickValue(line, ["allow_return"], this.returnReq_pickValue(line.raw || {}, ["AllowReturn"], null)),
                            null
                        )
                    )
                    .filter((flag) => flag !== null);
                const allowReturnFromLines = allowFlags.length > 0 ? allowFlags.some((flag) => flag === true) : null;
                const allowReturnFromSalesOrder = this.returnReq_toBoolean(
                    this.returnReq_pickValue(row, ["AllowSalesReturnRequest"], null),
                    null
                );
                let allowReturn = allowReturnFromRow != null
                    ? allowReturnFromRow
                    : (allowReturnFromLines != null ? allowReturnFromLines : allowReturnFromSalesOrder);
                if (selectedRowType === "UNDELIVERED" || selectedRowType === "OPEN") {
                    allowReturn = String(soLineStatus || "").toUpperCase() !== "C";
                }
                const lineStatus = selectedRowType === "DELIVERED"
                    ? (dnLineStatus || soLineStatus || null)
                    : (soLineStatus || dnLineStatus || null);

                const docEntry = dnDocEntry != null ? dnDocEntry : soDocEntry;
                const docNum = dnDocNum != null ? dnDocNum : soDocNum;

                return {
                    docEntry,
                    docNum,
                    soDocEntry,
                    soDocNum,
                    soLineNum,
                    soItemCode,
                    soItemDesc,
                    soRefItemId,
                    soWhsCode,
                    soLineStatus,
                    soInventoryItem,
                    soSalesItem,
                    dnDocEntry,
                    dnDocNum,
                    dnLineNum,
                    dnDeliveryDate,
                    dnItemCode,
                    dnItemDesc,
                    dnRefItemId,
                    dnWhsCode,
                    dnLineStatus,
                    dnDeliveredQty,
                    dnOpenQty,
                    dnRowType,
                    lineStatus,
                    allowReturn,
                    deliveryLines,
                    soRaw: row.SO_Raw || row,
                    dnRaw: row.DN_Raw || null,
                    dnRawRecords: Array.isArray(row.DN_RawRecords) ? row.DN_RawRecords : [],
                };
            },

            returnReq_getPickingRecords(row) {
                if (!row) return [];

                const pickingRecords = [];

                const pushPickingRecords = (source) => {
                    if (!source || typeof source !== "object") return;
                    if (Array.isArray(source.PickingRecords)) {
                        pickingRecords.push(...source.PickingRecords);
                    }
                    if (Array.isArray(source.picking_records)) {
                        pickingRecords.push(...source.picking_records);
                    }
                };

                pushPickingRecords(row);
                pushPickingRecords(row.SO_Raw);

                return pickingRecords;
            },

            returnReq_isStartedPickingRecord(record) {
                const lineStatus = String(
                    this.returnReq_pickValue(record, ["LINESTATUS", "LineStatus", "line_status"], "")
                ).toUpperCase();
                const released = this.returnReq_pickValue(record, ["RELEASED", "Released", "released"], null);
                return lineStatus === "O" && String(released) === "1";
            },

            /**
             * SrvIntr reports picking as a scalar on the line: "not_started" or
             * "started". Released, partially picked and picked all arrive as
             * "started", so only the explicit "not_started" reads as not begun -
             * any value added later is treated as started rather than unknown.
             */
            returnReq_pickingStatusValue(row) {
                return String(
                    this.returnReq_pickValue(row, ["PickingStatus", "picking_status"], "") || ""
                ).trim().toLowerCase();
            },

            returnReq_pickingStatusLabel(row) {
                /* Once a line has shipped there is nothing left to pick, and the
                   value SrvIntr still reports for it cannot be relied on: lines
                   on one delivery note come back with different answers. */
                if (!this.returnReq_isSalesOrderSource(row)) return "-";

                const status = this.returnReq_pickingStatusValue(row);

                if (status !== "") {
                    return status === "not_started" ? "Not Started" : "Started";
                }

                /* Older payloads carried an array of pick lines instead, where a
                   released open line was what meant picking had begun. */
                const pickingRecords = this.returnReq_getPickingRecords(row);
                if (!pickingRecords.length) return "-";
                return pickingRecords.some((record) => this.returnReq_isStartedPickingRecord(record))
                    ? "Started"
                    : "Not Started";
            },

            returnReq_hasPickedOpenReleasedRecord(row) {
                if (!row) return false;

                // Same reasoning as the label: stale on anything already shipped.
                if (!this.returnReq_isSalesOrderSource(row)) return false;

                const status = this.returnReq_pickingStatusValue(row);

                if (status !== "") {
                    return status !== "not_started";
                }

                return this.returnReq_getPickingRecords(row).some((record) => this.returnReq_isStartedPickingRecord(record));
            },

            returnReq_isSalesOrderSource(row) {
                if (!row) return false;
                const baseType = this.returnReq_pickValue(row, ["ReturnBaseType", "BaseType", "base_type"], null);
                if (baseType != null && String(baseType) === "17") return true;
                const rowType = String(this.returnReq_pickValue(row, ["__rowType", "RowType", "sourceType", "row_type"], "") || "").toUpperCase();
                return rowType === "OPEN" || rowType === "UNDELIVERED" || rowType === "SALES_ORDER";
            },
            returnReq_hasStartedPicking(row) {
                if (!row) return false;
                const sources = [row, row.SO_Raw, row.DN_Raw].filter((source) => source && typeof source === "object");
                return sources.some((source) => {
                    const status = String(this.returnReq_pickValue(source, ["PickingStatus", "picking_status", "PickStatus", "pick_status"], "") || "").toLowerCase();
                    return ["started", "released", "in_progress", "in-progress", "picked", "partially_picked", "partially-picked"].includes(status);
                });
            },
            returnReq_rowSelectable(row) {
                if (!row) return false;

                if (this.returnReq_isSalesOrderSource(row) && this.returnReq_hasPickedOpenReleasedRecord(row)) return false;
                             if (this.returnReq_isSalesOrderSource(row) && this.returnReq_hasStartedPicking(row)) return false;
                
                // Check if row has selectable descendants (delivered items) - for old normalization
                if (Array.isArray(row.children) && row.children.length > 0) {
                    const hasSelectableDescendants = this.returnReq_getSelectableDescendants(row).length > 0;
                    const hasUndeliveredQty = this.delivery_toNumber(row.__maxQty) > 0 && row.__returnAllowed;
                    // Parent is selectable if it has undelivered qty OR selectable children
                    return hasUndeliveredQty || hasSelectableDescendants;
                }
                
                // Simple check for new transformation or child rows
                if (!row.__returnAllowed) return false;
                return this.delivery_toNumber(row.__maxQty) > 0;
            },

            returnReq_rowClassName({ row }) {
                if (!row) return "";
                return this.returnReq_rowSelectable(row)
                    ? "return-request-valid-row"
                    : "return-request-invalid-row";
            },

            returnReq_isRowSelected(row) {
                if (!row) return false;
                return (this.return_requestSelectedRows || []).some(r => r.__rowKey === row.__rowKey);
            },

            returnReq_expandSelectionWithComponents(rows) {
                const selectedMap = new Map();

                (rows || []).forEach((row) => {
                    if (!row) return;

                    const issueQty = this.delivery_toNumber(row.__issueQty);
                    if (this.returnReq_rowSelectable(row) && issueQty > 0) {
                        selectedMap.set(row.__rowKey, row);
                    }

                    const rowQty = this.delivery_toNumber(row.Qty);
                    const ratio = rowQty > 0 ? Math.max(0, Math.min(1, issueQty / rowQty)) : 0;
                    const linkedComponents = Array.isArray(row.__componentRows) ? row.__componentRows : [];

                    linkedComponents.forEach((component) => {
                        if (!component || !component.__returnAllowed) return;

                        const maxQty = this.delivery_toNumber(component.__maxQty);
                        const componentIssueQty = maxQty * ratio;
                        if (componentIssueQty <= 0) return;

                        const key = component.__rowKey || this.returnReq_hiddenComponentKey(component);
                        if (!key) return;

                        if (!selectedMap.has(key)) {
                            selectedMap.set(key, {
                                ...component,
                                __issueQty: Math.min(maxQty, componentIssueQty),
                                __selectedByParent: true,
                            });
                            return;
                        }

                        const existing = selectedMap.get(key);
                        const nextQty = this.delivery_toNumber(existing.__issueQty) + componentIssueQty;
                        existing.__issueQty = Math.min(this.delivery_toNumber(existing.__maxQty), nextQty);
                    });
                });

                return Array.from(selectedMap.values());
            },

            returnReq_onSelectionChange(rows) {
                const selected = Array.isArray(rows) ? rows : [];
                
                console.log('Return Request Selection Changed:', selected.length, 'items selected');
                console.log('Selected rows:', selected);
                
                // Use Vue.set for reactivity
                this.$set(this, 'return_requestSelectedRows', selected);
                
                const expanded = this.returnReq_expandSelectionWithComponents(selected);
                this.$set(this, 'return_requestExpandedSelectedRows', expanded);
                
                console.log('Expanded selection:', expanded.length, 'items (including components)');

                if (this.return_requestPicking) return;

                this.$nextTick(() => this.returnReq_enforceSelectionValidity());
            },

            returnReq_onIssueQtyChange(row) {
                if (!row) return;

                const maxQty = this.delivery_toNumber(row.__maxQty);
                let qty = this.delivery_toNumber(row.__issueQty);

                if (qty < 0) qty = 0;
                if (qty > maxQty) qty = maxQty;

                row.__issueQty = qty;

                const isSelected = (this.return_requestSelectedRows || []).some((item) => item.__rowKey === row.__rowKey);
                if (isSelected && qty <= 0 && this.$refs && this.$refs.sapReturnTable) {
                    this.$refs.sapReturnTable.toggleRowSelection(row, false);
                }

                this.return_requestExpandedSelectedRows = this.returnReq_expandSelectionWithComponents(this.return_requestSelectedRows || []);

                this.$nextTick(() => this.returnReq_enforceSelectionValidity());
            },

            returnReq_getSelectableDescendants(row) {
                if (!row || !row.children || !row.children.length) return [];
                return this.delivery_getDescendants(row).filter((ch) => this.returnReq_rowSelectable(ch));
            },

            returnReq_areAllDescendantsSelected(parentRow, selection) {
                const descendants = this.returnReq_getSelectableDescendants(parentRow);
                if (!descendants.length) return true;
                const selectedKeys = new Set((selection || []).map((r) => r.__rowKey));
                return descendants.every((r) => selectedKeys.has(r.__rowKey));
            },

            returnReq_enforceSelectionValidity() {
                if (!this.$refs || !this.$refs.sapReturnTable) return;

                const invalid = (this.return_requestSelectedRows || []).filter((row) => {
                    const qty = this.delivery_toNumber(row && row.__issueQty);
                    return !this.returnReq_rowSelectable(row) || qty <= 0;
                });

                if (!invalid.length) return;

                this.return_requestPicking = true;
                invalid.forEach((row) => this.$refs.sapReturnTable.toggleRowSelection(row, false));
                this.return_requestPicking = false;
            },

            returnReq_onRowSelect(selection, row) {
                if (this.return_requestPicking || !this.$refs || !this.$refs.sapReturnTable) return;

                this.return_requestPicking = true;

                const isSelected = (selection || []).some((r) => r.__rowKey === row.__rowKey);

                // If selecting and issueQty is 0, set it to maxQty
                if (isSelected && this.delivery_toNumber(row.__issueQty) <= 0) {
                    const maxQty = this.delivery_toNumber(row.__maxQty);
                    if (maxQty > 0) {
                        row.__issueQty = maxQty;
                        console.log('Auto-set return qty to', maxQty, 'for', row.ItemCode);
                    }
                }

                // No longer cascade selection to children or parents
                // Each row now works independently

                this.return_requestPicking = false;
                this.$nextTick(() => this.returnReq_enforceSelectionValidity());
            },

            returnReq_onSelectAll(selection) {
                if (this.return_requestPicking || !this.$refs || !this.$refs.sapReturnTable) return;

                this.return_requestPicking = true;
                const shouldSelect = Array.isArray(selection) && selection.length > 0;
                const rows = this.delivery_flattenRows(this.return_requestTableData || []);

                rows.forEach((row) => {
                    if (!this.returnReq_rowSelectable(row)) return;
                    
                    // If selecting and issueQty is 0, set it to maxQty
                    if (shouldSelect && this.delivery_toNumber(row.__issueQty) <= 0) {
                        const maxQty = this.delivery_toNumber(row.__maxQty);
                        if (maxQty > 0) {
                            row.__issueQty = maxQty;
                        }
                    }
                    
                    this.$refs.sapReturnTable.toggleRowSelection(row, shouldSelect);
                });

                this.return_requestPicking = false;
                this.$nextTick(() => this.returnReq_enforceSelectionValidity());
            },

            confirmSubmitReturnRequest() {
                if (!this.return_requestExpandedSelectedRows || this.return_requestExpandedSelectedRows.length === 0) {
                    this.$ThatsNotify.warning({ message: 'No items selected for return request.' });
                    return;
                }

                const rowsWithoutRemarks = this.return_requestSelectedRows.filter((row) => {
                    return !row.Remarks || String(row.Remarks).trim() === '';
                });

                if (rowsWithoutRemarks.length > 0) {
                    this.$ThatsNotify.warning({
                        message: `Please provide remarks for all selected items. ${rowsWithoutRemarks.length} item(s) missing remarks.`,
                    });
                    return;
                }

                this.returnRequestType = '';
                this.returnRequestTypeDialogVisible = true;
            },

            closeReturnRequestTypeDialog() {
                this.returnRequestTypeDialogVisible = false;
                this.returnRequestType = '';
            },

            proceedSubmitReturnRequest() {
                if (!this.returnRequestType) {
                    this.$ThatsNotify.warning({ message: 'Please select return request type.' });
                    return;
                }

                const selectedCount = this.return_requestSelectedRows.length;
                const expandedCount = this.return_requestExpandedSelectedRows.length;

                const selectedTypeLabel = this.returnRequestType === 'exchange' ? 'Exchange' : 'Refund';
                let message = `You are about to submit a return request for ${selectedCount} item(s)`;
                if (expandedCount > selectedCount) {
                    message += ` (including ${expandedCount - selectedCount} component(s))`;
                }
                message += ` as ${selectedTypeLabel}. Do you want to continue?`;

                MessageBox.confirm(message, 'Confirm Return Request', {
                    confirmButtonText: 'Yes, Submit',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                }).then(() => {
                    this.returnRequestTypeDialogVisible = false;
                    this.submitReturnRequest();
                }).catch(() => {
                    // User cancelled
                });
            },

            submitReturnRequest() {
                const self = this;
                
                if (self.returnRequestSubmitting) return;
                if (!self.return_requestExpandedSelectedRows || self.return_requestExpandedSelectedRows.length === 0) {
                    self.$ThatsNotify.warning({ message: 'No items selected for return request.' });
                    return;
                }

                if (!self.returnRequestType) {
                    self.returnRequestTypeDialogVisible = true;
                    self.$ThatsNotify.warning({ message: 'Please select return request type.' });
                    return;
                }

                // Validate that all selected rows have remarks
                const rowsWithoutRemarks = self.return_requestSelectedRows.filter(row => {
                    return !row.Remarks || String(row.Remarks).trim() === '';
                });

                if (rowsWithoutRemarks.length > 0) {
                    self.$ThatsNotify.warning({ 
                        message: `Please provide remarks for all selected items. ${rowsWithoutRemarks.length} item(s) missing remarks.` 
                    });
                    return;
                }

                self.returnRequestSubmitting = true;

                const payload = {
                    transaction_id: self.form.mdbID,
                    location: self.form.location && self.form.location.id ? self.form.location.id : null,
                    prefix: self.form.location && self.form.location.prefix ? self.form.location.prefix : null,
                    invoice_series: self.form.invoice?.series || null,
                    sales_order_doc_entry: self.form.ordr?.[0]?.entry || null,
                    sales_order_doc_num: self.form.ordr?.[0]?.number || null,
                    sales_order_reference: self.form.ordr?.[0]?.reference || null,
                    return_date: self.form.ordr_sap_data?.DocDueDate || null,
                    return_request_type: self.returnRequestType,
                    items: self.return_requestExpandedSelectedRows.map((row) => {
                        const source = self.returnReq_extractSourceContext(row);

                        return {
                            item_code: row.ItemCode,
                            item_name: row.Dscription,
                            doc_num: source.docNum,
                            doc_entry: source.docEntry,
                            base_type: row.BaseType != null ? row.BaseType : null,
                            base_line: row.BaseLine != null ? row.BaseLine : null,
                            line_num: row.LineNum != null ? row.LineNum : source.soLineNum,
                            qty: self.delivery_toNumber(row.Qty),
                            return_qty: self.delivery_toNumber(row.__issueQty),
                            upc: row.CodeBars || null,
                            warehouse: row.__whs || row.WhsCode || source.soWhsCode || source.dnWhsCode || null,
                            delivered_date: source.dnDeliveryDate || null,
                            row_type: row.__rowType || row.RowType || 'normal',
                            is_bom_parent: (Array.isArray(row.children) && row.children.length > 0),
                            parent_item_code: row.__parent ? row.__parent.ItemCode : null,
                            bom_req_qty: row.BOMReqQty || null,
                            remarks: row.Remarks || null,
                            batches: row.__batches || [],
                            allow_return: source.allowReturn != null ? source.allowReturn : !!row.__returnAllowed,
                            line_status: source.lineStatus || null,
                            // SalesOrder fields
                            sales_order_doc_entry: source.soDocEntry,
                            sales_order_doc_num: source.soDocNum,
                            sales_order_line_num: source.soLineNum,
                            sales_order_item_code: source.soItemCode,
                            sales_order_item_desc: source.soItemDesc,
                            sales_order_ref_item_id: source.soRefItemId,
                            sales_order_whs_code: source.soWhsCode,
                            sales_order_line_status: source.soLineStatus,
                            sales_order_inventory_item: source.soInventoryItem,
                            sales_order_sales_item: source.soSalesItem,
                            // DeliveryNote fields (if delivered)
                            delivery_note_doc_entry: source.dnDocEntry,
                            delivery_note_doc_num: source.dnDocNum,
                            delivery_note_line_num: source.dnLineNum,
                            delivery_note_date: source.dnDeliveryDate,
                            delivery_note_item_code: source.dnItemCode,
                            delivery_note_item_desc: source.dnItemDesc,
                            delivery_note_ref_item_id: source.dnRefItemId,
                            delivery_note_whs_code: source.dnWhsCode,
                            delivery_note_line_status: source.dnLineStatus,
                            delivery_note_delivered_qty: source.dnDeliveredQty,
                            delivery_note_open_qty: source.dnOpenQty,
                            delivery_note_row_type: source.dnRowType,
                            // Detailed DN mapping for one-to-many SO->DN relationships
                            delivery_lines: source.deliveryLines,
                            // Raw payload snapshots for traceability / future mapping
                            sales_order_raw: source.soRaw,
                            delivery_note_raw: source.dnRaw,
                            delivery_note_raw_records: source.dnRawRecords,
                        };
                    }),
                };

                console.log('Submitting return request with payload:', payload);

                // Call API to store return request
                self.storeReturnRequest(payload)
                    .then((response) => {
                        const responseData = response && response.data ? response.data : {};
                        const returnRequestData = responseData.return_request || {};
                        const returnRequestHeader = returnRequestData.header || {};
                        const creditNoteData = responseData.credit_note || {};

                        self.return_requestHeader = {
                            transaction_id: self.form ? self.form.mdbID : null,
                            return_request_id: returnRequestHeader.return_request_id || returnRequestData.id || null,
                            return_request_series: returnRequestHeader.return_request_series || returnRequestData.series || null,
                            return_request_status: returnRequestHeader.return_request_status || returnRequestData.status || null,
                            credit_note_id: returnRequestHeader.credit_note_id || returnRequestData.credit_note_id || creditNoteData.id || null,
                            credit_note_series: returnRequestHeader.credit_note_series || creditNoteData.series || null,
                            credit_note_status: returnRequestHeader.credit_note_status || creditNoteData.status || null,
                            credit_note_action: returnRequestHeader.credit_note_action || creditNoteData.action || null,
                        };

                        self.$ThatsNotify.success({
                            message: response.message || 'Return request submitted successfully.'
                        });
                        
                        // Clear selection
                        self.return_requestSelectedRows = [];
                        self.return_requestExpandedSelectedRows = [];
                        self.returnRequestType = '';
                        self.returnRequestTypeDialogVisible = false;
                        if (self.$refs && self.$refs.sapReturnTable) {
                            self.$refs.sapReturnTable.clearSelection();
                        }
                        
                        // Refresh invoice data so returnable qty reflects the newly created request.
                        if (self.form && self.form.invoice && self.form.invoice.series) {
                            self.getRecordSeries({
                                token_id: self.form.token_id,
                                series: self.form.invoice.series,
                            });
                        }
                    })
                    .catch((error) => {
                        const errorMsg = error?.response?.data?.message || 'Failed to submit return request.';
                        self.$ThatsNotify.error({ message: errorMsg });
                        console.error('Submit return request error:', error);
                    })
                    .finally(() => {
                        self.returnRequestSubmitting = false;
                    });
            },

        /* END OF DELIVERY PICKING */
        /* START SCAN UPC/BATCH */
            handleScanSubmit(rows) {
                const self = this;

                try {
                    if (!Array.isArray(rows) || rows.length === 0) {
                    self.$ThatsNotify.warning({ message: "No scanned items to allocate." });
                    return;
                    }

                    if (!self.form || !self.form.ordr_sap_data) {
                    self.$ThatsNotify.warning({ message: "Sales order data not loaded yet." });
                    return;
                    }

                    if (!Array.isArray(self.delivery_tableData) || self.delivery_tableData.length === 0) {
                    self.$ThatsNotify.warning({ message: "Delivery picking table is not ready." });
                    return;
                    }

                    if (!self.$refs || !self.$refs.sapTable) {
                    self.$ThatsNotify.warning({ message: "Delivery table reference is not available." });
                    return;
                    }

                    const docEntryFallback = self.form.ordr_sap_data.DocEntry;

                    // Flatten delivery table (includes BOM children if any)
                    const flat = self.delivery_flattenRows(self.delivery_tableData);

                    // Map: "__rowKey" => row
                    const rowMap = {};
                    flat.forEach((r) => {
                    if (r && r.__rowKey) rowMap[String(r.__rowKey)] = r;
                    });

                    // Group scans by "DocEntry-LineNum"
                    const grouped = {};

                    (rows || []).forEach((sr) => {
                    const docEntry =
                        sr && (sr.docEntry != null ? sr.docEntry : sr.DocEntry != null ? sr.DocEntry : docEntryFallback);
                    const lineNum = sr && (sr.lineNum != null ? sr.lineNum : sr.LineNum);

                    if (docEntry == null || lineNum == null) return;

                    const rowKey = `${docEntry}-${lineNum}`;

                    const whsCode = String(sr && (sr.whsCode != null ? sr.whsCode : sr.WhsCode != null ? sr.WhsCode : "")).trim();
                    const batchNumber = String(
                        sr && (sr.batchNumber != null ? sr.batchNumber : sr.BatchNumber != null ? sr.BatchNumber : "")
                    ).trim();

                    const qty = self.delivery_toNumber(sr && (sr.qty != null ? sr.qty : sr.Qty != null ? sr.Qty : 0));

                    if (!grouped[rowKey]) {
                        grouped[rowKey] = {
                        rowKey,
                        whsCode: whsCode || "",
                        whsConflict: false,
                        batches: {},
                        total: 0
                        };
                    }

                    const g = grouped[rowKey];

                    if (whsCode) {
                        if (g.whsCode && g.whsCode !== whsCode) g.whsConflict = true;
                        if (!g.whsCode) g.whsCode = whsCode;
                    }

                    if (!batchNumber || qty <= 0) return;

                    g.batches[batchNumber] = (g.batches[batchNumber] || 0) + qty;
                    g.total += qty;
                    });

                    const keys = Object.keys(grouped);
                    if (!keys.length) {
                    self.$ThatsNotify.warning({ message: "No valid scanned rows to allocate." });
                    return;
                    }

                    const getRoot = (r) => {
                    let x = r;
                    while (x && x.__parent) x = x.__parent;
                    return x;
                    };

                    let allocatedLines = 0;
                    let notFoundLines = 0;
                    let skippedBomParents = 0;
                    let missingBatchCount = 0;
                    let clampedQtyCount = 0;
                    let warehouseConflictCount = 0;

                    const rowsToSelect = [];

                    keys.forEach((rowKey) => {
                    const g = grouped[rowKey];
                    const row = rowMap[rowKey];

                    if (!row) {
                        notFoundLines += 1;
                        return;
                    }

                    if (g.whsConflict) warehouseConflictCount += 1;

                    // If BOM parent (has children), allocation is on components; skip to prevent wrong allocations.
                    if (row.children && row.children.length) {
                        skippedBomParents += 1;
                        return;
                    }

                    const targetWhs = (g.whsCode || row.__whs || "").trim();
                    if (!targetWhs) return;

                    // Force warehouse and reset batch options/allocation map for that warehouse
                    row.__whs = targetWhs;
                    self.delivery_onWhsChange(row, false);

                    // Qty from scan, capped by max qty and available
                    let desiredQty = self.delivery_toNumber(g.total);

                    const maxQty = row.__maxQty != null ? self.delivery_toNumber(row.__maxQty) : null;
                    if (maxQty != null && desiredQty > maxQty) {
                        desiredQty = maxQty;
                        clampedQtyCount += 1;
                    }

                    const available = row.__available != null ? self.delivery_toNumber(row.__available) : null;
                    if (available != null && available > 0 && desiredQty > available) {
                        desiredQty = available;
                        clampedQtyCount += 1;
                    }

                    row.__issueQty = desiredQty;

                    // If item does not require batches, stop here
                    if (!row.__anyBatches) {
                        self.delivery_onIssueQtyChange(row, false);
                        allocatedLines += 1;

                        const root = getRoot(row);
                        if (root && !root.__parent && self.delivery_isRowValid(root)) rowsToSelect.push(root);
                        return;
                    }

                    // Apply batch allocations
                    const allocMap = row.__batchAlloc || {};
                    let remaining = desiredQty;

                    Object.keys(g.batches).forEach((bn) => {
                        if (remaining <= 0) return;

                        if (allocMap[bn] == null) {
                        missingBatchCount += 1;
                        return;
                        }

                        const take = Math.min(self.delivery_toNumber(g.batches[bn]), remaining);
                        allocMap[bn] = take;
                        remaining -= take;
                    });

                    // Ensure Vue reactivity
                    row.__batchAlloc = { ...allocMap };

                    // Safety: enforce allocation total <= qty
                    const totalAlloc = self.delivery_batchAllocatedTotal(row);
                    if (totalAlloc > desiredQty) {
                        self.delivery_trimAllocationsToQty(row, desiredQty);
                    }

                    self.delivery_onIssueQtyChange(row, false);

                    allocatedLines += 1;

                    const root = getRoot(row);
                    if (root && !root.__parent && self.delivery_isRowValid(root)) rowsToSelect.push(root);
                    });

                    // Auto-select valid allocated rows
                    if (rowsToSelect.length) {
                    self.delivery_picking = true;
                    rowsToSelect.forEach((r) => {
                        self.$refs.sapTable.toggleRowSelection(r, true);
                        self.setImplicitSelection(r, true);
                    });
                    self.delivery_picking = false;
                    }

                    self.$nextTick(() => {
                    self.delivery_enforceSelectionValidity();
                    });

                    if (allocatedLines === 0) {
                    self.$ThatsNotify.warning({ message: "No scanned lines were allocated to delivery picking." });
                    return;
                    }

                    const notes = [];
                    if (notFoundLines) notes.push(`${notFoundLines} not found`);
                    if (skippedBomParents) notes.push(`${skippedBomParents} BOM parent skipped`);
                    if (missingBatchCount) notes.push(`${missingBatchCount} batch missing`);
                    if (warehouseConflictCount) notes.push(`${warehouseConflictCount} warehouse conflict`);
                    if (clampedQtyCount) notes.push(`${clampedQtyCount} qty capped`);

                    const msg = notes.length
                    ? `Allocated ${allocatedLines} line(s) to delivery picking. (${notes.join(", ")})`
                    : `Allocated ${allocatedLines} line(s) to delivery picking.`;

                    self.$ThatsNotify.success({ message: msg });
                } catch (error) {
                    // Hard error
                    console.error("handleScanSubmit error:", error);
                    self.$ThatsNotify.error({
                    message: error && error.message ? error.message : "Failed to allocate scanned items.",
                    timeOut: 20000
                    });
                }
                },

            handShowScan(){
                this.showScan = true
            },
         /* END SCAN UPC/BATCH */

            allowedUser(){
                const allowedIds = [2,18]; 
                return allowedIds.includes(this.user.id);
            }
    },

    computed: {

        isBalancePendingByOrder(){
            return !!(this.form && this.form.attr && this.form.attr.balance_pending_reason === 'by-order');
        },

        ...mapGetters('InvoiceModule',
            [
                'formStatus',
                'formRecord',
                'viewLoading',
                'tblKey',
            ]),

        ...mapGetters('AuthModule',[ 'user' ]),
        ...mapGetters('SalesOrderDeliveryModule',{
            deliveryPostLoading : 'postLoading'
        }),

        applyMultiplePayment : function(){
            if(this.form.attr.hasOwnProperty('multiple_tier_discount') && this.form.attr.multiple_tier_discount !== null){
                return this.form.attr.multiple_tier_discount.apply;
            }
            return false;
        },


        itemSeries : function(){
            var self = this;
            const filteredSeries = self.form.items.filter((item) => {
                return (item.code !== "" && item.code !== null)
            }).map(function(key){
                return key.code
            })


            return filteredSeries;
        },

        noInvoiceDisabled : function(){
            if(this.formStatus === 'create' || this.form.invoice === null || (this.form.invoice !== null && this.form.invoice.series === null)){
                return true;
            }
            return false
        },

        isReservationApplied : function(){
            if(this.form === null){
                return false;
            }

            return this.isReservationAppliedValue(this.form.reservation);
        },

        reservationAlreadyConfirmed : function(){
            return this.isReservationConfirmedRecord(this.form);
        },

        reservationApplyDisabled : function(){
            return this.isReservationConfirmedRecord(this.form) || this.isReservationConfirmedRecord(this.formOriginal);
        },

        reservationConfirmationDisabled : function(){
            return this.formStatus !== 'update' ||
                !this.isReservationApplied ||
                !this.reservationConfirmationAllowed ||
                this.reservationAlreadyConfirmed ||
                this.viewLoading ||
                this.formLoading ||
                this.formOriginal.status === 'cancel';
        },

        reservationConfirmationAllowed : function(){
            return this.$helpers.isSystemAdministrator() ||
                this.$helpers.isShowroomManager() ||
                this.$helpers.isGeneralManager();
        },

        reservationConfirmationCancelDisabled : function(){
            return this.formStatus !== 'update' ||
                !this.reservationAlreadyConfirmed ||
                !this.reservationConfirmationAllowed ||
                this.viewLoading ||
                this.formLoading ||
                this.formOriginal.status === 'cancel';
        },

        invoice : function(){
            let inv = {
                series : null,
                date : "",
                balance : 0,
                paid : 0,
                attachment : [],
                payments : [],
            }

            if(this.formStatus == 'update'){
                if(this.formRecord != null && this.formRecord.invoice !== null){
                    inv = this.formRecord.invoice
                }

            }

            inv.balance = unformat(inv.balance)
            return inv
        },


        showSalespersonCard : function(){
            return this.checkSystemSupport || this.checkShowroomManager;
        },

        checkSalesExecutive : function(){
            return this.$helpers.isSalesExecutive();
        },
        checkSystemSupport : function(){
            return this.$helpers.isSystemAdministrator();
        },
        allowEditAddress : function(){
            // return this.$helpers.isSystemAdministrator() || this.$helpers.isDeliveryTeam();
            return true;
        },
        checkShowroomManager : function(){
            return this.$helpers.isShowroomManager();
        },
        checkAccounting : function(){
            return this.$helpers.isAccounting();
        },
        showCheckBox : function(){
            if(this.formStatus == 'create' || (this.formStatus == 'update' && (this.returnItem === true || this.cancelItem === true || this.exchangeItem === true || this.refundItem === true))){
                return true;
            }

            return false;
        },
        showCheckBoxCreditNote : function(){
            if(this.formStatus == 'update' && this.modifyReturmItem === true){
                return true;
            }

            return false;
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                    // property doesn't exist on either object
                    return 0;
                }

                const varA = (typeof a[key] === 'string')
                    ? a[key].toUpperCase() : a[key];
                const varB = (typeof b[key] === 'string')
                    ? b[key].toUpperCase() : b[key];

                let comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } else if (varA < varB) {
                    comparison = -1;
                }
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        },

        hasSelected(){
            if(this.selected.length > 0){
                return false;
            };
            return true
        },



        hasInvoice(){
            if(this.form.invoice !== null && this.form.invoice.series !== null){
                return true;
            }
            return false;
        },

        toBeOrder(){
            return this.form.items.map(i => i.tbo).lenth;
        },

        creditNoteSelectionLength(){
            return this.creditNoteSelection.length;
        },


        editCustomerField(){
            return this.disabled && this.customerField
        },

        documentEntry(){
            const {document} = this.formOriginal.attr;


            if(document.entry !== null && document.entry !== ""){
                return true;
            }
            return false
        },

        remainingCreditNote(){

            if(this.form.credit_notes.length > 0){



                const creditNoteItems = this.form.credit_notes.filter((i) => i.status === 'approved',[]).map((i) => i.total,0).reduce((a,b) => a + b, 0)



                /*           const creditNoteItems = this.form.credit_notes.map(i => {
            const itemTotal = i.items.map((innerItem) =>unformat(innerItem.total),[]).reduce((a,b) => a + b);
            let total = 0;
              if(i.attr.hasOwnProperty('more_discount') && i.attr.more_discount.enable === true){
                total = itemTotal - (itemTotal * (i.attr.more_discount.percent/ 100));
              }
            return total
          },[]) */


                /* console.log(creditNoteItems)

          const total = this.form.credit_notes.map(i => {
            const itemTotal = i.items.map((innerItem) =>unformat(innerItem.total),[]).reduce((a,b) => a + b);

              if(i.attr.hasOwnProperty('more_discount') && i.attr.more_discount.enable === true){
                total = itemTotal - (itemTotal * (i.attr.more_discount.percent/ 100));
              }
            return total
          },[]).reduce((a,b) => a + b); */

                return creditNoteItems - this.form.credit_note.credit_note_reference.map(i => i.amount).reduce((a,b) => a + b);
            }

            return 0;



            // return (this.form.credit_note_items.map(i => unformat(i.total)).reduce((a,b) => a + b)) - this.form.credit_note.credit_note_reference.map(i => i.amount).reduce((a,b) => a + b);
        },

        contactPersonName: {
            get(){
                return (this.form.attr.contact_person.name !== null && this.form.attr.contact_person.name !== null) ?  `${this.form.attr.contact_person.name}/${this.form.attr.contact_person.mobile}` : ""

            },
            set(value){
                return value
            }
        },

        onlinePaymentFormData(){
            return {...this.form, total : this.form.invoice.remaining}
        },

        onlinePaymentLinks(){
            if(!this.form) return [];
            if(Array.isArray(this.form.links) && this.form.links.length > 0) return this.form.links;
            return this.form.link ? [this.form.link] : [];
        },

        primaryOnlinePaymentLink(){
            return this.onlinePaymentLinks.find(link => this.isPendingOnlinePayment(link))
                || this.onlinePaymentLinks.find(link => !this.isCancelledOnlinePayment(link))
                || null;
        },

        hasPendingOnlinePayment(){
            return this.onlinePaymentLinks.some(link => this.isPendingOnlinePayment(link));
        },

        canGenerateOnlinePaymentLink(){
            if(this.formStatus !== 'update' || !this.invoice || this.invoice.payments.length === 0 || !this.form || !this.form.hasOwnProperty('links')){
                return false;
            }

            if(this.onlinePaymentLinks.length === 0) return true;
            return this.onlinePaymentLinks.every(link => this.isCancelledOnlinePayment(link));
        },

        canManageOnlinePaymentLink(){
            return this.checkSystemSupport
                || this.checkShowroomManager
                || this.$helpers.isGeneralManager()
                || this.$helpers.isDeliveryTeam()
                || this.$helpers.isInteriorDesigner();
        },

        canCancelOnlinePayment(){
            return this.$helpers.isSystemAdministrator() || this.$helpers.isAccounting();
        },

        width100P(){

        const width = window.innerWidth - ( window.innerWidth * 0.09 );
        return width;
        },
        height100P(){
        let viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        console.log("window.innerHeight",viewportHeight);
        return viewportHeight;
        },

        hasSelectedForDelivery(){
            if(this.delivery_selectedRows.length > 0){
                return true;
            }
            return false;
        },

        activeTableSlot(){
            if(this.tabs.length === 0){
                return 'form-slot'
            }
            return this.tabs[this.active].slot;
        },

        allowSyncInvoice(){
            const ordr = this.form && Array.isArray(this.form.ordr) ? this.form.ordr : [];
            const hasQatlOrdr = ordr.some((row) => row && row.reference === 'QATL_PRODUCTION');
            return !hasQatlOrdr;
        },


    },

    watch: {
        viewLoading : function(v){
            this.formLoading = v
        },
        'form.reservation' : function(value){
            if(this.reservationApplyDisabled && !this.isReservationAppliedValue(value)){
                this.form.reservation = 1;
                return;
            }

            if(this.reservationAlreadyConfirmed){
                return;
            }

            if(this.isReservationAppliedValue(value)){
                if(!this.reservationConfirmationDate){
                    this.reservationConfirmationDate = this.currentDateValue();
                }
                return;
            }

            this.reservationConfirmationDate = null;
        },
        'form.attr.balance_pending_reason' : function(value){
            if(value !== 'by-order' && this.form && this.form.attr){
                this.form.attr.balance_pending_eta = null;
            }
        },
        tblKey : function(){
            // this.initSortable();
        },

/*         'form.total': function(newAmount) {
            if (newAmount) {
                let amountWithoutCommas = this.removeCommas(newAmount);
                if (!isNaN(amountWithoutCommas)) {
                    // let roundedAmount = this.roundAmount(amountWithoutCommas);
                    this.form.total = this.addCommas(amountWithoutCommas);
                } else {
                    this.form.total = '0.00';
                }
            } else {
                this.form.total = '0.00';
            }
        }, */

        // viewLoading : function(v){
        //     if(v === false && this.formStatus === 'update'){
        //          if(this.form.invoice !== null  && (v.invoice.hasOwnProperty('series') && v.invoice.series !== null)){
        //            alert("watch viewloading invoiced")

        //          }else{
        //            alert("watch viewloading update quotation")
        //          }
        //     }
        // },
        formRecord : function(v){
            const self = this;
            this.active = 0;
            this.formKey++;
            this.disabled = false
            // alert(this.formStatus);
            this.delivery_selectedRows = [];

            if(this.formStatus == 'update'){
                // alert("update")
                // if(!this.viewLoading){
                if(v.invoice !== null && (v.invoice.hasOwnProperty('series') && v.invoice.series !== null)){
                    // alert()
                    if(this.modify === false){
                        this.disableSortable();
                    }
                    this.disabled = true
                    this.tabs = [
                        { text: 'Sales Details', slot: 'form-slot' },
                        { text: 'Payments', slot: 'invoice-slot' },
                        { text: 'Attachments', slot: 'form-attachment' }
                    ]

                }else{
                    this.form.invoice = {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    }

                }
                // }


                const jsonParse = {...this.formVar(),...JSON.parse(JSON.stringify(this.formRecord))};

                if(!jsonParse.hasOwnProperty('reservation')){
                    jsonParse.reservation = 0;
                }

                if(jsonParse.hasOwnProperty('attr')){
                    jsonParse.attr = {...this.form.attr,...jsonParse.attr}
                }
                jsonParse.more_discount = {...this.form.more_discount,...jsonParse.more_discount}


                jsonParse.credit_note = {...this.form.credit_note,...jsonParse.credit_note}
                // jsonParse.credit_memo = [...this.form.credit_memo,...jsonParse.credit_memo]
                // jsonParse.credit_note_items = [...this.form.credit_note_items,...jsonParse.credit_note_items]


                // const sortItems =

                // jsonParse.items = jsonParse.items.sort((a, b) => a.sort > b.sort);
                jsonParse.items = jsonParse.items.sort((a, b) => (a.sort > b.sort ? 1 : -1));
                // jsonParse.items = jsonParse.items.sort(self.compareValues('sort','asc'));


                jsonParse.attr = {
                    ...jsonParse.attr,
                    address2 : {
                        street : null,
                        building : null,
                        zone : null,
                        area : null,
                        city : null,
                        ...jsonParse.attr.address2
                    },
                }

                if(!jsonParse.hasOwnProperty('ordr_sap_data')){
                    jsonParse.ordr_sap_data = null
                }


                console.log("jsonParse.attr")
                console.log(jsonParse.attr)
                if(!jsonParse.attr.hasOwnProperty('customer_service')){
                    jsonParse.attr.customer_service = null;
                }


                this.form = jsonParse;
                this.setReservationConfirmationDateFromForm(this.form);
                this.formOriginal = JSON.parse(JSON.stringify(jsonParse));

                // this.newArrange = jsonParse.items;


               


                if(this.form.hasOwnProperty('credit_note_items') && this.form.credit_note_items.length > 0){
                    this.tabs = [...this.tabs,{ text: 'Credit Notes', slot: 'credit-notes' }];
                }
                if(this.form.hasOwnProperty('delivery_notes') && this.form.delivery_notes.length > 0){
                    this.tabs = [...this.tabs,{ text: 'Delivery Notes', slot: 'delivery-notes' }];
                }

                if(this.form.hasOwnProperty('purchase_request_item') && this.form.purchase_request_item.length > 0){
                    const tbs = this.tabs.map(e => e.slot);

                    if(!tbs.includes('purchase-request')){
                        this.tabs = [...this.tabs,{ text: 'Purchase Request', slot: 'purchase-request' }];
                    }

                }

                if(this.form.hasOwnProperty('cancellation') && this.form.cancellation.length > 0){
                    const tbs = this.tabs.map(e => e.slot);

                    if(!tbs.includes('cancelled-items')){
                        this.tabs = [...this.tabs,{ text: 'Cancelled Items', slot: 'cancelled-items' }];
                    }

                }

                if(this.form.hasOwnProperty('exchange') && this.form.exchange.length > 0){
                    const tbs = this.tabs.map(e => e.slot);

                    if(!tbs.includes('exchange-items')){
                        this.tabs = [...this.tabs,{ text: 'Exchange Items', slot: 'exchange-items' }];
                    }

                }

                if(this.form.hasOwnProperty('refund') && this.form.refund.length > 0){
                    const tbs = this.tabs.map(e => e.slot);

                    if(!tbs.includes('refund-items')){
                        this.tabs = [...this.tabs,{ text: 'Refund Items', slot: 'refund-items' }];
                    }

                }

                const hasOnlinePaymentTab = this.tabs.some(tab => tab.slot === 'online-payment');
                if(!hasOnlinePaymentTab){
                    if(this.form.invoice.remaining){
                        this.tabs = [...this.tabs,{ text: 'Generate Online Payment', slot: 'online-payment' }];
                    }else{
                        const index = this.tabs.findIndex(tab => tab.slot === 'online-payment');
                        if(index > -1){
                            this.tabs.splice(index, 1);
                        }

                    }

                }

                console.log("sales order ============>>>>>>>>>>>>", this.form.ordr)

                const hasSapDocumentsTab = this.tabs.some(tab => tab.slot === 'sap-documents-slot');
                if(!hasSapDocumentsTab && ((this.form.hasOwnProperty('ordr') && this.form.ordr.length > 0))){
                    this.tabs = [...this.tabs,{ text: 'Sales Order', slot: 'sap-documents-slot' }];

                    const hasSapSalesReturnRequestTab = this.tabs.some(tab => tab.slot === 'sales-return-request-slot');
                    if(!hasSapSalesReturnRequestTab && ((this.form.hasOwnProperty('ordr') && this.form.ordr.length > 0))){
                        this.tabs = [...this.tabs,{ text: 'Return Request', slot: 'sales-return-request-slot' }];
                    }
                }



                let add = ""
                add += (v.attr.address != "" && v.attr.address !== null) ? v.attr.address  : "";

                add += (v.attr.address2.street != "" && v.attr.address2.street !== null) ? ","+v.attr.address2.street  : "";
                add += (v.attr.address2.building!= "" && v.attr.address2.building!== null) ? ","+v.attr.address2.building : "";
                add += (v.attr.address2.zone != "" && v.attr.address2.zone !== null) ? ","+v.attr.address2.zone  : "";
                add += (v.attr.address2.area != "" && v.attr.address2.area !== null) ? "/"+v.attr.address2.area  : "";
                add += (v.attr.address2.city != "" && v.attr.address2.city !== null) ? "/"+v.attr.address2.city  : "";



                this.displayAddress = add.trim();



                if(!this.disabled){
                    const formItemVar = this.formItemVar();
                    this.form.items.push(formItemVar)
                }


                if(Object.keys(v).length !== 0 && v.constructor === Object){
                    this.customer = [{
                        opt : this.form.attr.name + " "+ this.form.attr.mobile,
                        label :this.form.attr.name,
                        value : this.form.customer_id,
                        mobile : this.form.attr.mobile,
                        address : this.form.attr.address,
                    }];
                }



              


            }

            if(this.formStatus == 'create'){
                this.FormResetter();
                // this.initSortable();
                // alert("watch create")
            }

            this.getCustomerService().then((response) => {
                this.customerService = response;
            });
        },

        'form.items' : {
            handler: function(v) {
                if(v.length > 0){
                    const total = v.map((i) => {
                        return unformat(i.total);
                    },[]).reduce((a,b) => {
                        return a + b;
                    },0)


                    const percent = unformat(this.form.more_discount.percent);
                    const discount = total * (percent / 100);

                    const formTotal = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
                    if(this.form.more_discount.enable){
                        // const discount = unformat(discount);
                        this.form.total = formatMoney((total - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });

                        console.log("watch enable")
                        console.log(this.form.total)

                    }else{
                        this.form.total = formTotal

                        console.log("watch not")
                        console.log(this.form.total)
                    }

                    this.form.more_discount.discount = discount;
                    this.form.attr.more_discount.discount = discount;


                }

            },
            deep: true
        },
        "form.more_discount.discount" : function(v){
            if(this.form !== null){
                const discount = unformat(v);
                const total = this.form.items.map((i) => unformat(i.total),[]).reduce((a, b) => a + b,0);
                let formattedTotal = formatMoney((total - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });

                if(this.form.more_discount.enable === false){
                    formattedTotal = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });

                }


                this.form.total = formattedTotal

            }
        },
        "form.more_discount.enable" : function(v){
            if(this.form !== null){
                const percent = unformat(this.form.more_discount.percent);
                const total = this.form.items.map((i) => unformat(i.total),[]).reduce((a, b) => a + b,0);
                // const total = unformat(this.total);

                const discount = total * (percent/100);

                let formattedTotal = formatMoney((total - discount), { symbol: "", precision: 2, thousand: ",", decimal: "." });


                this.form.more_discount.discount = discount;
                if(this.form.attr.hasOwnProperty("more_discount") && this.form.more_discount !== null){
                    this.form.attr.more_discount.discount = discount;
                }
                if(v === false){
                    formattedTotal = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
                }


                this.form.total = formattedTotal
            }

        },
        "form.ordr_sap_data": {
            immediate: true,
            deep: false,
            handler(v) {

                console.log("watch ordr_sap_data", v);
                const lines = v && v.DocumentLines ? v.DocumentLines : [];
                this.delivery_tableData = this.delivery_normalizeLines(lines, null);
                this.delivery_selectedRows = [];

                this.return_requestTableData = selectReturnRequestRows(
                    v || {},
                    this.getItemImageByRefId,
                    (legacyLines) => {
                        if (v && Array.isArray(v.DeliveryData) && v.DeliveryData.length > 0) {
                            return this.returnReq_normalizeLines(legacyLines);
                        }
                        return this.returnReq_transformRows(legacyLines);
                    }
                );

                this.return_requestSelectedRows = [];
                this.return_requestExpandedSelectedRows = [];
                this.$nextTick(() => {
                    this.delivery_enforceSelectionValidity();
                    this.returnReq_enforceSelectionValidity();
                });
            },
        },

    },




}
</script>

<style scoped>
.click-to-add-logo{
    font-size: 14px;cursor: pointer;
}



.custom-control {
    position: absolute!important;
    margin: 10px!important;
}

.custom-control.image-delete{
    right: 0;cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery{
    padding: 65px;
    text-align: center;
}

.no-image-gallery i.far {
    font-size: 42px;
    color: #959595;
}
a.discount-a{
    margin : 5px;
}

.tab-content{
    height: auto!important;
}

.search-fabric{
    position: absolute;
    width: 250px;
    z-index: 999;
    top: 0;
    left: 0;
    padding: 5px;
    background: #ddd;
    border-radius: 3px;
    margin: 0px 0 0 20px;
}

.sap-issue-pick-table .tiny {
  font-size: 12px;
  line-height: 1.2;
}
.sap-issue-pick-table .muted {
  color: #909399;
}
.sap-issue-pick-table .danger {
  color: #f56c6c;
}
.sap-issue-pick-table .strong {
  font-weight: 600;
}

.tiny {
  font-size: 12px;
  line-height: 1.2;
}

.danger {
  color: #f56c6c;
}

.is-invalid input {
  border-color: #f56c6c !important;
}

.batch-cell {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.dialog-head {
  margin-bottom: 10px;
}
.dialog-actions {
  margin: 10px 0;
  display: flex;
  gap: 8px;
}
.footer-metrics {
  margin-top: 10px;
}

.return-request-header {
  margin: 10px 0 8px;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f8f9fb;
}

.return-request-header-title {
  font-size: 11px;
  color: #909399;
  text-transform: uppercase;
}

.return-request-header-value {
  font-size: 14px;
  font-weight: 600;
}

.return-request-header-subtitle {
  font-size: 12px;
  color: #606266;
}

::v-deep .el-table .return-request-valid-row > td {
  background-color: #e6f6f0 !important;
}

::v-deep .el-table .return-request-invalid-row > td {
  background-color: rgb(255, 200, 200) !important;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped.return-request-valid-row > td {
  background-color: #dcefe8 !important;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped.return-request-invalid-row > td {
  background-color: rgb(255, 186, 186) !important;
}
</style>
